namespace $ {
	
	export let $mol_spell_ru = new $mol_spell(
		undefined,
		new Set([
			"противо",
			"внутри",
			"ультра",
			"экстра",
			"вдоль",
			"гипер",
			"интер",
			"испод",
			"контр",
			"между",
			"небез",
			"около",
			"перед",
			"после",
			"преди",
			"предо",
			"прото",
			"сверх",
			"среди",
			"супер",
			"транс",
			"через",
			"анти",
			"архи",
			"вице",
			"возо",
			"надо",
			"недо",
			"низо",
			"обез",
			"обер",
			"пере",
			"подо",
			"поза",
			"пост",
			"пред",
			"разо",
			"чрез",
			"без",
			"взо",
			"вне",
			"воз",
			"дез",
			"дис",
			"изо",
			"кое",
			"кой",
			"меж",
			"над",
			"наи",
			"низ",
			"обо",
			"ото",
			"под",
			"пра",
			"пре",
			"при",
			"про",
			"раз",
			"суб",
			"сыз",
			"экс",
			"up",
			"вз",
			"во",
			"вы",
			"де",
			"до",
			"за",
			"из",
			"им",
			"на",
			"не",
			"ни",
			"об",
			"от",
			"па",
			"по",
			"ре",
			"со",
			"су",
			"а",
			"в",
			"к",
			"о",
			"с",
			"у"
		]),
		new Set([
			"верноподданный",
			"заблаговременн",
			"конфиденциальн",
			"пронунсиаменто",
			"пронунциаменто",
			"благосостояни",
			"заблагорассуд",
			"коллаборацион",
			"неукоснительн",
			"обстоятельств",
			"перпендикуляр",
			"респектабельн",
			"самостоятельн",
			"сентиментальн",
			"существительн",
			"членораздельн",
			"экстравагантн",
			"аппассионато",
			"архитектоник",
			"архитектонич",
			"бандерильеро",
			"бефстроганов",
			"благопристой",
			"действительн",
			"дивертисмент",
			"знаменательн",
			"исключительн",
			"истеблишмент",
			"квантитативн",
			"киндзмараули",
			"конквистадор",
			"консерватори",
			"любознательн",
			"междоусобица",
			"нововведение",
			"ньюфаундленд",
			"перистальтик",
			"перистальтич",
			"подобостраст",
			"посредственн",
			"поступательн",
			"предрассудок",
			"председатель",
			"прилагательн",
			"продовольств",
			"пятибалльный",
			"рефрижератор",
			"самодеятельн",
			"сентименталь",
			"способствова",
			"трансцендент",
			"фантасмагори",
			"хламидомонад",
			"экстемпорале",
			"экстемпорали",
			"азербайджан",
			"антрепренёр",
			"апокалипсис",
			"апостериори",
			"архимандрит",
			"ассортимент",
			"билатеральн",
			"благоприятн",
			"благосклонн",
			"бонбоньероч",
			"брандахлыст",
			"государствл",
			"департамент",
			"добродетель",
			"замечательн",
			"знаменатель",
			"индифферент",
			"индульгенци",
			"интеллигент",
			"интеллигенц",
			"искусственн",
			"калейдоскоп",
			"капельдинер",
			"каптенармус",
			"кватроченто",
			"конкистадор",
			"консеквентн",
			"консерватор",
			"контрамароч",
			"контрапункт",
			"контрассигн",
			"конфигураци",
			"коэффициент",
			"крамбамбули",
			"мадемуазель",
			"меркантильн",
			"мефистофель",
			"монтекристо",
			"муниципальн",
			"набалдашник",
			"нарицательн",
			"неандерталь",
			"номенклатур",
			"обстоятельн",
			"ответственн",
			"относительн",
			"положительн",
			"понедельник",
			"понедельнич",
			"посредством",
			"презерватив",
			"преимуществ",
			"прейскурант",
			"преставлени",
			"пропедевтик",
			"пропедевтич",
			"простоволос",
			"пространств",
			"профилактик",
			"профилактич",
			"распростран",
			"реконструкт",
			"рододендрон",
			"сентиментал",
			"состоятельн",
			"темперамент",
			"тотализатор",
			"трансильван",
			"трансмиттер",
			"транспарант",
			"транспортир",
			"удовольстви",
			"ультрамарин",
			"универсальн",
			"университет",
			"факультатив",
			"фантасмагор",
			"фешенебельн",
			"фольксдойче",
			"хрестоматий",
			"циркумфлекс",
			"чинквеченто",
			"ынтеллигент",
			"ыскусственн",
			"эксперимент",
			"энциклопеди",
			"абракадабр",
			"авторитарн",
			"адмиралтей",
			"аккредитив",
			"аксельбант",
			"акупунктур",
			"амбулатори",
			"анафилакси",
			"апартамент",
			"апостериор",
			"апперцепци",
			"аристократ",
			"артиллерий",
			"аттракцион",
			"баттерфляй",
			"безалаберн",
			"беллетрист",
			"бенедиктин",
			"бестселлер",
			"биссектрис",
			"благоображ",
			"благообраз",
			"благополуч",
			"благоприят",
			"благословл",
			"бонбоньерк",
			"брудершафт",
			"бургомистр",
			"вазисубани",
			"виолончель",
			"воскресень",
			"восстанавл",
			"восстановл",
			"вундеркинд",
			"галантерей",
			"гардемарин",
			"гарибальди",
			"геликоптер",
			"гимнастёрк",
			"гиперборей",
			"гиппопотам",
			"гонобобель",
			"государств",
			"дарданелль",
			"дебаркадер",
			"декрешендо",
			"декрещендо",
			"джентльмен",
			"дизентерий",
			"диминуэндо",
			"дирижабель",
			"дифференци",
			"довольстви",
			"доскональн",
			"духовенств",
			"епитрахиль",
			"залихватск",
			"замысловат",
			"здравствуй",
			"импресарио",
			"инаугураци",
			"ингредиент",
			"инструмент",
			"интермеццо",
			"интродукци",
			"исступлени",
			"камердинер",
			"каракалпак",
			"каракалпач",
			"карамболин",
			"карбованец",
			"карбонарий",
			"коллоквиум",
			"комбинезон",
			"компаратив",
			"комплемент",
			"комплимент",
			"компромисс",
			"конкорданс",
			"консистент",
			"консистенц",
			"контингент",
			"контрабанд",
			"контрагент",
			"контральто",
			"контрамарк",
			"контрапост",
			"контрибуци",
			"контроверз",
			"контроллер",
			"конфедерат",
			"конференци",
			"конъюнктив",
			"конъюнктур",
			"корреспонд",
			"космополит",
			"кунсткамер",
			"лиственниц",
			"лиственнич",
			"магистраль",
			"манускрипт",
			"мануфактур",
			"марионеточ",
			"маркшейдер",
			"мартиролог",
			"медикамент",
			"меморандум",
			"менестрель",
			"мерехлюнди",
			"мероприяти",
			"метрдотель",
			"митрополит",
			"митрополич",
			"неандертал",
			"неприкаянн",
			"неприятель",
			"нравственн",
			"обсерватор",
			"обстановоч",
			"опрометчив",
			"орангутанг",
			"оригинальн",
			"ориентальн",
			"остеречься",
			"папоротник",
			"парабеллум",
			"парикмахер",
			"партикуляр",
			"патримоний",
			"перспектив",
			"плексиглас",
			"повествова",
			"подбородок",
			"подбородоч",
			"подпоручик",
			"пожалуйста",
			"полишинель",
			"последстви",
			"потенциаль",
			"предвосхит",
			"предвосхищ",
			"предложени",
			"предоставл",
			"предприним",
			"предупрежд",
			"прелюбодей",
			"пренебречь",
			"прерогатив",
			"преследова",
			"приспосабл",
			"приспособл",
			"провансаль",
			"пролетарий",
			"промежуток",
			"промежуточ",
			"просперити",
			"протестант",
			"пунктуальн",
			"разгильдяй",
			"рациональн",
			"регредиент",
			"резистентн",
			"реконструк",
			"рентабельн",
			"респондент",
			"референдум",
			"сальмонелл",
			"сатисфакци",
			"сертификат",
			"сколопендр",
			"скрупулёзн",
			"сольфеджио",
			"сообразова",
			"соответств",
			"справедлив",
			"ставрополь",
			"студебекер",
			"субстантив",
			"супплетивн",
			"существова",
			"температур",
			"транзистор",
			"транзитивн",
			"трансмисси",
			"турбулентн",
			"удовлетвор",
			"удовольств",
			"фейервероч",
			"фильдеперс",
			"финтифлюшк",
			"фисгармони",
			"флибустьер",
			"флёрдоранж",
			"фортепиано",
			"фортепьяно",
			"фрикадельк",
			"хрестомати",
			"чертополох",
			"чистоплотн",
			"чрезвычайн",
			"эквивалент",
			"экзистенци",
			"экскремент",
			"экстирпаци",
			"экстрадици",
			"элементарн",
			"энциклопед",
			"абиссальн",
			"австралий",
			"авторитет",
			"администр",
			"аквамарин",
			"аккомпани",
			"аккордеон",
			"аккузатив",
			"аксессуар",
			"александр",
			"аллигатор",
			"альбатрос",
			"альфреско",
			"аляфуршет",
			"амариллис",
			"амбулатор",
			"анакреонт",
			"анафилакт",
			"антреприз",
			"антресоль",
			"апеллятив",
			"апокалипс",
			"апокалипт",
			"апоплекси",
			"аппендикс",
			"апперцепт",
			"артиллери",
			"архипелаг",
			"аутсайдер",
			"багульник",
			"бадминтон",
			"бальзамин",
			"балюстрад",
			"бандероль",
			"банкаброш",
			"барабульк",
			"баркентин",
			"барристер",
			"баттерфля",
			"башибузук",
			"безалабер",
			"беззаветн",
			"безотчётн",
			"белендряс",
			"белладонн",
			"бельведер",
			"бельканто",
			"бересклет",
			"бернштейн",
			"берсальер",
			"бешбармак",
			"билирубин",
			"биндюжник",
			"благодаря",
			"благодать",
			"благослов",
			"благотвор",
			"благочест",
			"бланманже",
			"бородавоч",
			"браконьер",
			"бригантин",
			"бриллиант",
			"бульдозер",
			"бутерброд",
			"бутоньерк",
			"бухгалтер",
			"бюллетень",
			"вакханаль",
			"валансьен",
			"вальдшнеп",
			"вахмистер",
			"ведомость",
			"великолеп",
			"велосипед",
			"венесуэль",
			"вермишель",
			"вертикаль",
			"вертопрах",
			"вертопраш",
			"вестибюль",
			"ветеринар",
			"взбалмошн",
			"взбутетен",
			"винчестер",
			"виолончел",
			"виртуальн",
			"вирулентн",
			"воодушевл",
			"восприним",
			"восстанов",
			"галазолин",
			"галантере",
			"гастроном",
			"гауптвахт",
			"гватемаль",
			"генеалоги",
			"геральдик",
			"геральдич",
			"герменевт",
			"герострат",
			"гетеродин",
			"гиперборе",
			"гипнотизм",
			"гипотенуз",
			"гладиатор",
			"гладиолус",
			"глиссандо",
			"гоминьдан",
			"горностай",
			"госпиталь",
			"господарь",
			"готовальн",
			"готтентот",
			"грандиозн",
			"грейпфрут",
			"гросфатер",
			"гурджаани",
			"гуттаперч",
			"дезабилье",
			"деликатес",
			"демикотон",
			"дербенник",
			"деструкци",
			"диагональ",
			"диакритич",
			"дизентери",
			"диксиленд",
			"дирижабль",
			"дискредит",
			"дискримин",
			"диспансер",
			"диспетчер",
			"диспозици",
			"диссидент",
			"дистрибут",
			"дистрибуц",
			"дисциплин",
			"дифферент",
			"дифференц",
			"докембрий",
			"должность",
			"достоверн",
			"драндулет",
			"дребедень",
			"жаворонок",
			"жерминаль",
			"жимолость",
			"жирандоль",
			"замухрышк",
			"запальчив",
			"заподлицо",
			"застенчив",
			"захолусть",
			"зашпандор",
			"зензубель",
			"зимородок",
			"имманентн",
			"иммельман",
			"иммунитет",
			"императив",
			"импичмент",
			"импозантн",
			"инвентарь",
			"индикатив",
			"индонезий",
			"инициатив",
			"инквартат",
			"инкогнито",
			"интеллект",
			"интендант",
			"интенсивн",
			"интервент",
			"интервенц",
			"интерлюди",
			"интермеди",
			"интерпелл",
			"интерпрет",
			"интрумент",
			"инфантиль",
			"инфинитив",
			"инъюнктив",
			"ипохондри",
			"исподволь",
			"исследова",
			"кабальеро",
			"кабельтов",
			"кабриолет",
			"кавалькад",
			"календарь",
			"каллиграф",
			"каллимико",
			"камеристк",
			"камикадзе",
			"кампанелл",
			"камчадаль",
			"канделябр",
			"каннибаль",
			"кантабиле",
			"канцеляри",
			"капитальн",
			"каприччио",
			"каракатиц",
			"карамболь",
			"карборунд",
			"кардиналь",
			"карикатур",
			"карманьол",
			"карнаваль",
			"картофель",
			"кастаньет",
			"кастелянш",
			"катамаран",
			"катапульт",
			"катастроф",
			"католикос",
			"катоптрик",
			"катоптрич",
			"квазимодо",
			"квипрокво",
			"кинестези",
			"клавикорд",
			"клерикаль",
			"когерентн",
			"количеств",
			"коллектив",
			"коллектор",
			"коловорот",
			"колоратур",
			"коммандос",
			"коммюнике",
			"компендий",
			"компетент",
			"компетенц",
			"комплекци",
			"композици",
			"компонент",
			"компрадор",
			"компресси",
			"компромет",
			"компьютер",
			"конвульси",
			"конгломер",
			"конгруэнт",
			"конгруэнц",
			"кондуктор",
			"конкурент",
			"коннотаци",
			"консенсус",
			"консерват",
			"консилиум",
			"конструкт",
			"контейнер",
			"континент",
			"континуум",
			"контражур",
			"контральт",
			"контрданс",
			"конъектур",
			"конъюнкци",
			"координат",
			"кордельер",
			"кордильер",
			"коростель",
			"корпускул",
			"корреальн",
			"краеуголь",
			"криминаль",
			"кроманьон",
			"кронштейн",
			"куропаточ",
			"куртизанк",
			"кухмистер",
			"ламбрекен",
			"лапсердак",
			"латеральн",
			"лаццарони",
			"лейтенант",
			"лихорадоч",
			"лицеприят",
			"локомотив",
			"магдебург",
			"мадаполам",
			"мадригаль",
			"макиавелл",
			"макулатур",
			"малахольн",
			"манчестер",
			"маргаритк",
			"маргинали",
			"маргиналь",
			"марионетк",
			"маркетинг",
			"марсельез",
			"мастодонт",
			"медиеваль",
			"междомети",
			"мезальянс",
			"мемориаль",
			"меркантил",
			"местоимен",
			"метранпаж",
			"милостынь",
			"минимальн",
			"минускуль",
			"митральез",
			"можжевель",
			"монастырь",
			"монпансье",
			"мораторий",
			"москатель",
			"муниципал",
			"набекрень",
			"наместник",
			"наместнич",
			"напареули",
			"напрячься",
			"настропал",
			"натюрморт",
			"нашармака",
			"невзначай",
			"недоразум",
			"неимоверн",
			"нейтральн",
			"ненависть",
			"необходим",
			"необычайн",
			"непреложн",
			"непременн",
			"неприязнь",
			"несусветн",
			"нидерланд",
			"ностальги",
			"обескураж",
			"оборудова",
			"обсерваци",
			"обскурант",
			"обстановк",
			"обструкци",
			"объективн",
			"одуванчик",
			"одухотвор",
			"оксиморон",
			"оксюморон",
			"олицетвор",
			"ономастик",
			"опрометью",
			"орангутан",
			"оранжерей",
			"оригиналь",
			"осуществл",
			"откровенн",
			"официальн",
			"паблисити",
			"палатальн",
			"палисандр",
			"палладиум",
			"паллиатив",
			"панариций",
			"панегирик",
			"панегирич",
			"паникадил",
			"параллакс",
			"параллакт",
			"параллель",
			"парафраст",
			"паркинсон",
			"парламент",
			"пассакаль",
			"пастернак",
			"пастораль",
			"патримони",
			"пергамент",
			"переплева",
			"перепоноч",
			"переправл",
			"периферий",
			"перламутр",
			"перманент",
			"пинкертон",
			"пирамидон",
			"пиццикато",
			"пиччикато",
			"пластилин",
			"плебисцит",
			"подтвержд",
			"подшипник",
			"полинезий",
			"полотенеч",
			"померанец",
			"портативн",
			"португаль",
			"посредств",
			"постамент",
			"постанавл",
			"постановл",
			"постепенн",
			"постромоч",
			"потенциал",
			"правоверн",
			"правомерн",
			"православ",
			"прапорщик",
			"превосход",
			"предместь",
			"предостав",
			"предполаг",
			"предполож",
			"предпочес",
			"предпочит",
			"предприим",
			"предприня",
			"представл",
			"предупред",
			"президент",
			"президиум",
			"презумпци",
			"преисподн",
			"преисполн",
			"прекослов",
			"прелюбоде",
			"пренебрег",
			"пренебреж",
			"пренебрёг",
			"преподава",
			"препятств",
			"пресвитер",
			"пресловут",
			"преферанс",
			"прецедент",
			"прибауточ",
			"привилеги",
			"пригоршен",
			"принадлеж",
			"приоритет",
			"приспособ",
			"пристальн",
			"пристраст",
			"причиндал",
			"провизорн",
			"прожектор",
			"прозорлив",
			"произвест",
			"произволь",
			"пролетари",
			"пропаганд",
			"пропеллер",
			"проповеда",
			"проповедь",
			"проститут",
			"простофил",
			"пространн",
			"простраци",
			"противень",
			"протоколь",
			"профилакт",
			"прохиндей",
			"пьедестал",
			"радикальн",
			"радикулит",
			"располага",
			"распредел",
			"расстояни",
			"револьвер",
			"регламент",
			"резервуар",
			"резиденци",
			"резистивн",
			"результат",
			"рекогносц",
			"реконстру",
			"ренессанс",
			"репертуар",
			"репрезент",
			"репродукт",
			"республик",
			"реституци",
			"речитатив",
			"ркацители",
			"рододендр",
			"романсеро",
			"сазандари",
			"саламандр",
			"санаторий",
			"сангвиник",
			"сангвинич",
			"сантимент",
			"сардоникс",
			"свидетель",
			"сграффито",
			"секретарь",
			"секундант",
			"селезёноч",
			"селективн",
			"сельдерей",
			"сенбернар",
			"сенсуальн",
			"серпантин",
			"серпентин",
			"сигнарант",
			"симпозиум",
			"скальпель",
			"скандинав",
			"скарлатин",
			"собственн",
			"совершенн",
			"сокровенн",
			"сольфеджо",
			"сомнамбул",
			"сообразов",
			"сопоставл",
			"сопротивл",
			"соревнова",
			"сорокопут",
			"сочельник",
			"спектакль",
			"специальн",
			"стационар",
			"стеречься",
			"стоеросов",
			"страсбург",
			"стремглав",
			"субстанци",
			"субститут",
			"субституц",
			"сумасброд",
			"супплетив",
			"сфорцандо",
			"сывороточ",
			"табасаран",
			"тарантелл",
			"терминаль",
			"терренкур",
			"территори",
			"тождествл",
			"толерантн",
			"тоталитар",
			"травертин",
			"траектори",
			"транскриб",
			"транскрип",
			"трансмисс",
			"транспорт",
			"трансферт",
			"трансформ",
			"тривиальн",
			"троглодит",
			"туркестан",
			"тушканчик",
			"удостовер",
			"универсал",
			"утилитарн",
			"факсимиле",
			"факсимиль",
			"факультет",
			"фамильярн",
			"фейерверк",
			"фернамбук",
			"фестиваль",
			"физиогном",
			"физиократ",
			"фиксатуар",
			"филармони",
			"филигрань",
			"филистимл",
			"фильдекос",
			"флогистон",
			"фломастер",
			"флорентий",
			"фортепиан",
			"фортепьян",
			"фотофиниш",
			"фундамент",
			"фуникулёр",
			"хлестаков",
			"хризантем",
			"хунвейбин",
			"церемоний",
			"цинандали",
			"циферблат",
			"чарльстон",
			"чахохбили",
			"шампиньон",
			"шансонетк",
			"шероховат",
			"шпингалет",
			"шпицрутен",
			"штакетник",
			"щепетильн",
			"ынициатив",
			"ынтеграль",
			"эдельвейс",
			"экземпляр",
			"экслибрис",
			"экспертиз",
			"экспозици",
			"экспропри",
			"эксфолиат",
			"эксфолиац",
			"эльдорадо",
			"энтузиазм",
			"энтузиаст",
			"эрцгерцог",
			"эскадриль",
			"эскалатор",
			"эспаньолк",
			"эсперанто",
			"абориген",
			"абстракт",
			"авангард",
			"австрали",
			"автономи",
			"автохтон",
			"агглютин",
			"агностик",
			"агностиц",
			"агностич",
			"аграмант",
			"адекватн",
			"адмираль",
			"адъектив",
			"адъютант",
			"акваланг",
			"акварель",
			"аквариум",
			"акватори",
			"аккомпан",
			"аккредит",
			"аккуратн",
			"акрополь",
			"актиниди",
			"актуальн",
			"акцидент",
			"акциденц",
			"алгоритм",
			"алебастр",
			"ализарин",
			"алкоголь",
			"аллегори",
			"альбинос",
			"альбумин",
			"алькальд",
			"альманах",
			"альманаш",
			"альсекко",
			"аляповат",
			"амальгам",
			"амбразур",
			"амикошон",
			"амплитуд",
			"анамнест",
			"анахорет",
			"ангстрем",
			"анестези",
			"анимальн",
			"ансамбль",
			"антиквар",
			"антологи",
			"антрекот",
			"антресол",
			"апартеид",
			"апелляци",
			"апельсин",
			"апоплекс",
			"апоплект",
			"апостоль",
			"апостроф",
			"аппарель",
			"аппендиц",
			"апперкот",
			"апперцип",
			"аппозици",
			"арабесоч",
			"аракчеев",
			"аргентин",
			"аргумент",
			"арканзас",
			"арпеджио",
			"арсеналь",
			"артезиан",
			"артефакт",
			"артиллер",
			"архитект",
			"архитрав",
			"асимптот",
			"аскорбин",
			"аспирант",
			"ассамбле",
			"астрахан",
			"атлантич",
			"атмосфер",
			"аудиенци",
			"аудитори",
			"аутодафе",
			"базамент",
			"бакалавр",
			"баклажан",
			"бактерий",
			"балалаеч",
			"балалайк",
			"балдахин",
			"бандерол",
			"барабошк",
			"барахоль",
			"барбарис",
			"барвинок",
			"барвиноч",
			"баргузин",
			"бареттер",
			"баркарол",
			"баррикад",
			"басурман",
			"батальон",
			"безображ",
			"безобраз",
			"белиберд",
			"бельтинг",
			"бельфлёр",
			"бергамот",
			"берейтор",
			"берендей",
			"беречься",
			"бессараб",
			"бессемер",
			"бесшабаш",
			"биеннале",
			"бижутери",
			"бильбоке",
			"бифштекс",
			"бихевиор",
			"благовол",
			"благогов",
			"благодар",
			"благодат",
			"благоден",
			"благодуш",
			"благолеп",
			"благоуха",
			"благочин",
			"блейвейс",
			"богадель",
			"богатырь",
			"богдыхан",
			"боготвор",
			"бойскаут",
			"бонапарт",
			"бонвиван",
			"бородавк",
			"бородавч",
			"брамсель",
			"браунинг",
			"брашпиль",
			"брильянт",
			"бристоль",
			"брокколи",
			"бруствер",
			"брюссель",
			"бумеранг",
			"бурмистр",
			"бурундук",
			"бурундуч",
			"бутадиен",
			"бутадион",
			"бьеннале",
			"бюллетен",
			"бюрократ",
			"бюрокрач",
			"вакханал",
			"валериан",
			"валерьян",
			"вальтрап",
			"василиск",
			"васисдас",
			"ватерпас",
			"ватрушеч",
			"вахмистр",
			"вдохновл",
			"вегетари",
			"ведомост",
			"ведомств",
			"венесуэл",
			"вербальн",
			"вермишел",
			"вернисаж",
			"вертикал",
			"вестибул",
			"вестфаль",
			"веществл",
			"византий",
			"визуальн",
			"викторин",
			"винегрет",
			"виноград",
			"витютень",
			"владимир",
			"водевиль",
			"возмезди",
			"волонтёр",
			"волочься",
			"вольготн",
			"вольтерь",
			"вольфрам",
			"волюнтар",
			"воодушев",
			"воробьев",
			"восвояси",
			"восприем",
			"восприим",
			"восприня",
			"вурдалак",
			"выспренн",
			"выхухоль",
			"габардин",
			"гайдамак",
			"гайдамат",
			"гайдамац",
			"галактик",
			"галактич",
			"галимать",
			"галлюцин",
			"гамадрил",
			"гангстер",
			"гардероб",
			"гарнизон",
			"гарнитур",
			"гастроль",
			"гватемал",
			"гекатомб",
			"гелертер",
			"гельминт",
			"геморрой",
			"генеалог",
			"генераль",
			"геркулес",
			"герундив",
			"герундий",
			"гидальго",
			"гильберт",
			"гильотин",
			"гипербол",
			"глицерин",
			"глобальн",
			"голкипер",
			"гомункул",
			"горечавк",
			"горизонт",
			"горноста",
			"гороскоп",
			"гортензи",
			"госпитал",
			"господар",
			"господин",
			"гостинец",
			"гостиниц",
			"гостинич",
			"государь",
			"гравилат",
			"градиент",
			"граффити",
			"граффито",
			"гренадер",
			"гренланд",
			"гроссбух",
			"гулливер",
			"дагестан",
			"дайджест",
			"дацзыбао",
			"девяност",
			"дезертир",
			"деликатн",
			"демократ",
			"демонстр",
			"депресси",
			"деревень",
			"десигнат",
			"дескрипт",
			"дескрипц",
			"деструкт",
			"деструкц",
			"детектив",
			"детермин",
			"децемвир",
			"джонатан",
			"диагност",
			"диагонал",
			"диаграмм",
			"диапазон",
			"диафрагм",
			"дивиденд",
			"дивизион",
			"дизъюнкт",
			"дизъюнкц",
			"дикобраз",
			"дилетант",
			"дилижанс",
			"димедрол",
			"дипломат",
			"директив",
			"директор",
			"дирижабл",
			"дискретн",
			"дискусси",
			"диспепси",
			"дисперси",
			"диспозит",
			"дистанци",
			"дистинкт",
			"дистинкц",
			"дифирамб",
			"дифракци",
			"дифтерий",
			"доберман",
			"доблесть",
			"документ",
			"должност",
			"доместик",
			"доминант",
			"доминион",
			"достояни",
			"драгоман",
			"дребезги",
			"дредноут",
			"дриблинг",
			"дрозофил",
			"дромадер",
			"дроссель",
			"дульцине",
			"евангели",
			"евангель",
			"екатерин",
			"елизавет",
			"епитимий",
			"ессентук",
			"ефрейтор",
			"жантильн",
			"женьшень",
			"живопись",
			"жимолост",
			"журавель",
			"забубённ",
			"забулдыг",
			"забулдыж",
			"загашник",
			"загвоздк",
			"зажиточн",
			"закадычн",
			"занавесь",
			"заповедь",
			"заскоруз",
			"застрель",
			"затрапез",
			"заусенец",
			"заусениц",
			"захолуст",
			"зверобой",
			"здравств",
			"знаменит",
			"золотник",
			"иероглиф",
			"изысканн",
			"имеретин",
			"империал",
			"импетиго",
			"импотент",
			"импотенц",
			"импресси",
			"имуществ",
			"инвентар",
			"индонези",
			"индустри",
			"инициаль",
			"инкорпор",
			"инкримин",
			"инспектр",
			"инстанци",
			"инстинкт",
			"институт",
			"инструкт",
			"инструкц",
			"интервал",
			"интервью",
			"интернат",
			"интерфер",
			"интерьер",
			"интоксик",
			"инфантер",
			"инфантил",
			"инфузори",
			"инцидент",
			"ипостась",
			"ипохондр",
			"искариот",
			"искусств",
			"исповедь",
			"источник",
			"ительмен",
			"итератив",
			"кабардин",
			"кабестан",
			"кавалери",
			"кавальер",
			"кавардак",
			"кавасаки",
			"какавелл",
			"каламбур",
			"каламянк",
			"каланхоэ",
			"календар",
			"календул",
			"каликант",
			"калифорн",
			"калькутт",
			"камамбер",
			"камариль",
			"камвольн",
			"камергер",
			"камертон",
			"кампаней",
			"камчадал",
			"канарееч",
			"канарейк",
			"кандидат",
			"канитель",
			"канифоль",
			"каннибал",
			"кантилен",
			"канцеляр",
			"капилляр",
			"капитель",
			"каприччо",
			"каравелл",
			"каракуль",
			"каракурт",
			"карамель",
			"карандаш",
			"карантин",
			"карачаев",
			"карбонад",
			"кардамон",
			"кардинал",
			"кармазин",
			"карнавал",
			"каротель",
			"картвель",
			"картофел",
			"карусель",
			"карфаген",
			"кассандр",
			"кастрюль",
			"катаваси",
			"катакомб",
			"каталажк",
			"катаракт",
			"катафалк",
			"катахрез",
			"категори",
			"каудильо",
			"каузальн",
			"каузатив",
			"кацавейк",
			"кварталь",
			"квартирь",
			"квебрахо",
			"квислинг",
			"квитанци",
			"кембридж",
			"кибернет",
			"кингстон",
			"кинестет",
			"киноварь",
			"кислород",
			"кислорож",
			"клавесин",
			"клерикал",
			"коверкот",
			"коктейль",
			"коленкор",
			"коллекци",
			"коллодий",
			"колоброд",
			"коловрат",
			"колодезь",
			"колоколь",
			"колосник",
			"колошмат",
			"колошмач",
			"колчедан",
			"колыбель",
			"кольраби",
			"командир",
			"комбинат",
			"комильфо",
			"комиссар",
			"коммуник",
			"компаней",
			"компаний",
			"компенди",
			"комплекс",
			"комплект",
			"композит",
			"компресс",
			"конвейер",
			"конвенци",
			"конверси",
			"конвульс",
			"конгресс",
			"кондитер",
			"кондрашк",
			"конкретн",
			"конкреци",
			"консолид",
			"конспект",
			"констант",
			"констанц",
			"конститу",
			"конструк",
			"консульт",
			"консьерж",
			"контагий",
			"контамин",
			"контекст",
			"контракт",
			"контраст",
			"контроль",
			"конфедер",
			"конфекци",
			"конфесси",
			"конфетти",
			"конфитюр",
			"конфликт",
			"конфороч",
			"конфронт",
			"концентр",
			"концесси",
			"корабель",
			"корвалол",
			"коренаст",
			"кориандр",
			"коричнев",
			"корнилов",
			"коромысл",
			"корректн",
			"коррозий",
			"кортизон",
			"косметик",
			"кочевряж",
			"кошениль",
			"краковяк",
			"крахмаль",
			"крендель",
			"крепостн",
			"крепость",
			"крестьян",
			"крешендо",
			"крещендо",
			"криминал",
			"кримплен",
			"кристалл",
			"кристаль",
			"критерий",
			"крокодил",
			"крузейро",
			"кузнечик",
			"кукареку",
			"культурь",
			"культяпк",
			"куропатк",
			"курултай",
			"курфюрст",
			"курчатов",
			"лабиринт",
			"лабрадор",
			"лавирова",
			"ламантин",
			"ламинари",
			"ландшафт",
			"латифунд",
			"левантин",
			"левиафан",
			"лепесток",
			"лепесточ",
			"либераль",
			"либретто",
			"линолеум",
			"лиссабон",
			"литораль",
			"литургий",
			"лицензия",
			"логарифм",
			"ложемент",
			"лонжерон",
			"лучезарн",
			"люминесц",
			"мавзолей",
			"магарадж",
			"магистер",
			"мадригал",
			"мажордом",
			"макинтош",
			"макрурус",
			"максвелл",
			"мандарин",
			"мандолин",
			"манифест",
			"маньчжур",
			"маракова",
			"марганец",
			"маргарин",
			"марихуан",
			"маркграф",
			"маркетри",
			"маркизет",
			"мармелад",
			"мартышеч",
			"марципан",
			"маскулин",
			"мастихин",
			"материал",
			"матриарх",
			"матрикул",
			"маэстозо",
			"маюскуль",
			"мгновени",
			"медальон",
			"медиальн",
			"междомет",
			"меланхол",
			"мельхиор",
			"мемориал",
			"менеджер",
			"мензульн",
			"мензуроч",
			"меридиан",
			"меридион",
			"мерлушеч",
			"метастаз",
			"метастат",
			"метропол",
			"мизерере",
			"миллиард",
			"милостын",
			"мингрель",
			"минераль",
			"миниатюр",
			"министер",
			"минотавр",
			"минускул",
			"мирабель",
			"мистраль",
			"митропол",
			"модерато",
			"модильон",
			"можжевел",
			"можжевёл",
			"молескин",
			"молибден",
			"мольберт",
			"монастыр",
			"монополи",
			"монополь",
			"монумент",
			"моралите",
			"мотоцикл",
			"мошеннич",
			"мракобес",
			"мукузани",
			"мундштук",
			"мундштуч",
			"навигаци",
			"наизусть",
			"наличник",
			"наложниц",
			"наоборот",
			"наполеон",
			"наречься",
			"насмороч",
			"настурци",
			"нафталин",
			"нахлобуч",
			"нашатырь",
			"нганасан",
			"неаполит",
			"невзрачн",
			"негодова",
			"незыблем",
			"неказист",
			"ненавист",
			"неприязн",
			"несессер",
			"несуразн",
			"нетопырь",
			"нечестив",
			"номиналь",
			"норичник",
			"ностальг",
			"нототени",
			"нумизмат",
			"нюрнберг",
			"облечься",
			"облигаци",
			"обмундир",
			"образова",
			"обречься",
			"обсидиан",
			"объектив",
			"оглобель",
			"одеколон",
			"одинаков",
			"околоток",
			"околоточ",
			"окольнич",
			"оппозици",
			"оппортун",
			"опроверг",
			"опроверж",
			"оранжере",
			"ординарн",
			"оригинал",
			"ориентал",
			"орнамент",
			"ортодокс",
			"осведомл",
			"останавл",
			"остановл",
			"остеречь",
			"остинато",
			"остойчив",
			"осторожн",
			"осуществ",
			"отверсти",
			"откровен",
			"отповедь",
			"официаль",
			"официант",
			"павильон",
			"падеграс",
			"пакистан",
			"паланкин",
			"палантин",
			"панибрат",
			"панкреас",
			"панкреат",
			"панталон",
			"парагвай",
			"параграф",
			"парадигм",
			"парадокс",
			"параллел",
			"параметр",
			"парафраз",
			"паренхим",
			"партизан",
			"партитур",
			"парфюмер",
			"парцелль",
			"пасквиль",
			"паспарту",
			"пассажир",
			"пассатиж",
			"пастиччо",
			"патиссон",
			"патриарх",
			"патриарш",
			"патриций",
			"педераст",
			"пенальти",
			"пеницилл",
			"пентагон",
			"пергамен",
			"пергамин",
			"перевясл",
			"перепонк",
			"перепонч",
			"переправ",
			"перипети",
			"перифери",
			"перкусси",
			"перлюстр",
			"персонал",
			"перстень",
			"перчаточ",
			"першерон",
			"пестицид",
			"петрушеч",
			"пехлевий",
			"пилигрим",
			"пистолет",
			"питомник",
			"питомнич",
			"планктон",
			"планширь",
			"пластырь",
			"платформ",
			"плацдарм",
			"плацкарт",
			"плашкоут",
			"площадоч",
			"плюральн",
			"подбород",
			"подлежащ",
			"подоплёк",
			"подспорь",
			"подстрек",
			"подтверд",
			"подхалим",
			"подхалюз",
			"позвонок",
			"позвоноч",
			"поздравл",
			"позумент",
			"поколени",
			"полиграф",
			"полинези",
			"полирова",
			"полисмен",
			"полномоч",
			"половник",
			"положени",
			"полотенц",
			"померанц",
			"помпадур",
			"пономарь",
			"популярн",
			"портвейн",
			"портланд",
			"портмоне",
			"портплед",
			"португал",
			"портулак",
			"портупей",
			"портфель",
			"портяноч",
			"порядочн",
			"пословиц",
			"послович",
			"поссибил",
			"постанов",
			"постепен",
			"постоянн",
			"постромк",
			"правомер",
			"правомоч",
			"праздник",
			"празднич",
			"преамбул",
			"превенци",
			"превзойд",
			"превратн",
			"прегражд",
			"предвзят",
			"предикат",
			"предикац",
			"предпочт",
			"предприя",
			"предречь",
			"представ",
			"предъявл",
			"преклонн",
			"прекрасн",
			"прелесть",
			"преображ",
			"преобраз",
			"препарат",
			"преподоб",
			"прериаль",
			"пресмыка",
			"прессинг",
			"преставл",
			"престоль",
			"преступл",
			"прибаутк",
			"приверед",
			"привилег",
			"пригоршн",
			"примитив",
			"припадок",
			"припадоч",
			"приправл",
			"пристойн",
			"пристращ",
			"приструн",
			"прихлеба",
			"причасти",
			"причастн",
			"приятель",
			"провиант",
			"провизор",
			"провинци",
			"проволок",
			"проволоч",
			"прогалин",
			"прогност",
			"программ",
			"продольн",
			"продюсер",
			"прозелит",
			"прозрачн",
			"произвед",
			"произвес",
			"производ",
			"произвол",
			"произнес",
			"произнос",
			"произнош",
			"пролетар",
			"пролювий",
			"променад",
			"промилле",
			"промысел",
			"пропасть",
			"пропилен",
			"проповед",
			"прополис",
			"пропорци",
			"проспект",
			"проститу",
			"протекци",
			"протокол",
			"професси",
			"прохвост",
			"процедур",
			"процесси",
			"пруденци",
			"псалтырь",
			"пустельг",
			"пуццолан",
			"равнодуш",
			"радиатор",
			"развлечь",
			"разоблач",
			"разумева",
			"рамбулье",
			"располож",
			"распоряд",
			"распоряж",
			"расправл",
			"раунатин",
			"рационал",
			"реабилит",
			"реверанс",
			"ревербер",
			"революци",
			"регулярн",
			"редуплик",
			"редуплиц",
			"резидент",
			"резолюци",
			"резорцин",
			"реквизит",
			"рекоменд",
			"релятивн",
			"репресси",
			"репродук",
			"репродуц",
			"репутаци",
			"ресторан",
			"рефракци",
			"ридикюль",
			"ритенуто",
			"робинзон",
			"родничок",
			"розмарин",
			"ромштекс",
			"ронгалит",
			"ротмистр",
			"рубероид",
			"рудимент",
			"рукопашн",
			"сагайдак",
			"сагайдач",
			"саксауль",
			"саксофон",
			"салфеточ",
			"сандарак",
			"санскрит",
			"саперави",
			"сарабанд",
			"сардельк",
			"сардонич",
			"саркофаг",
			"сателлит",
			"секвестр",
			"секретар",
			"секретер",
			"секстант",
			"селезень",
			"селезёнк",
			"селектор",
			"сельджук",
			"семинари",
			"семиотик",
			"семиотич",
			"сенегаль",
			"сенсибил",
			"сентенци",
			"сентябрь",
			"сервелат",
			"сервильн",
			"сервитут",
			"сердолик",
			"сигнатур",
			"симметри",
			"симплекс",
			"сингуляр",
			"синдикал",
			"синекдох",
			"синопсис",
			"синоптик",
			"синоптич",
			"синтетич",
			"скабрёзн",
			"скандаль",
			"скатерть",
			"скафандр",
			"скваттер",
			"скипидар",
			"сковород",
			"скоморох",
			"скоморош",
			"скопидом",
			"скорпион",
			"скрижаль",
			"скриптум",
			"следстви",
			"смородин",
			"соболезн",
			"совершен",
			"совокупл",
			"совокупн",
			"согласно",
			"содейств",
			"сокровищ",
			"сомбреро",
			"сообразн",
			"сопостав",
			"социальн",
			"сочувств",
			"спагетти",
			"спаниель",
			"спиккато",
			"спинальн",
			"спиннинг",
			"средотач",
			"средоточ",
			"стабильн",
			"стагнаци",
			"стаккато",
			"стаксель",
			"стамесоч",
			"стандарт",
			"станиоль",
			"стаханов",
			"стержень",
			"стерильн",
			"стерлинг",
			"стерлядь",
			"стипенди",
			"столыпин",
			"странгул",
			"странств",
			"стрежень",
			"стриппер",
			"стриптиз",
			"стрихнин",
			"стричься",
			"строение",
			"стропиль",
			"строптив",
			"структур",
			"субмарин",
			"субстрат",
			"субтильн",
			"суверенн",
			"сулугуни",
			"супостат",
			"суррогат",
			"суспензи",
			"сфорцато",
			"сцинтилл",
			"сыворотк",
			"талисман",
			"тамарикс",
			"тамариск",
			"танзаний",
			"тарантас",
			"тарантул",
			"тарбаган",
			"тезаурус",
			"текстиль",
			"тектоник",
			"тектонич",
			"тенденци",
			"термидор",
			"терминал",
			"термозит",
			"терракот",
			"террикон",
			"техникум",
			"тильбюри",
			"тиристор",
			"тождеств",
			"тожествл",
			"толочься",
			"томагавк",
			"тореадор",
			"торжеств",
			"травести",
			"трактова",
			"трамблёр",
			"трамбова",
			"трамплин",
			"транспир",
			"транспон",
			"трафарет",
			"трафареч",
			"трензель",
			"треченто",
			"триангул",
			"трибунал",
			"тривиаль",
			"триенале",
			"трикотаж",
			"триктрак",
			"триллион",
			"триумвир",
			"тростник",
			"трубадур",
			"туберкул",
			"тулумбас",
			"турмалин",
			"турникет",
			"турухтан",
			"тушеваль",
			"тщательн",
			"ультимат",
			"утилитар",
			"фанабери",
			"фанариот",
			"фанданго",
			"фанфарон",
			"фарандол",
			"фарватер",
			"фармазон",
			"фейербах",
			"фельдшер",
			"фельетон",
			"ферлакур",
			"фертильн",
			"филармон",
			"филатели",
			"филигран",
			"филиппик",
			"филиппин",
			"филистер",
			"фиолетов",
			"фиоритур",
			"фламенко",
			"фламинго",
			"флоренти",
			"флоридин",
			"флуоресц",
			"флюгароч",
			"флюоресц",
			"фокстрот",
			"фолликул",
			"фольклор",
			"фордыбач",
			"форейтор",
			"формуляр",
			"форсуноч",
			"форштадт",
			"фрагмент",
			"франклин",
			"франциск",
			"фрейлейн",
			"фривольн",
			"фристайл",
			"фурнитур",
			"фурункул",
			"халцедон",
			"хамелеон",
			"харакири",
			"характер",
			"хачапури",
			"хвостник",
			"холецист",
			"хрусталь",
			"хулигань",
			"целомудр",
			"церемони",
			"циркуляр",
			"цитадель",
			"частушеч",
			"чересчур",
			"чичероне",
			"шансонье",
			"шаривари",
			"шарлатан",
			"швартовл",
			"шестерён",
			"шизофрен",
			"шимпанзе",
			"шифоньер",
			"шкатулоч",
			"шкворень",
			"шлагбаум",
			"шпаклева",
			"шпаклёва",
			"шпангоут",
			"шпандырь",
			"шпиндель",
			"шрапнель",
			"штандарт",
			"штемпель",
			"штепсель",
			"штукатур",
			"штурваль",
			"щиколотк",
			"ымпровиз",
			"ынвентар",
			"эвкалипт",
			"эвристик",
			"эвристич",
			"эвтектик",
			"эвтектич",
			"эгалитар",
			"эйнштейн",
			"эквилибр",
			"экзерсис",
			"эклиптик",
			"эклиптич",
			"эксплуат",
			"экспресс",
			"экспромт",
			"экссудат",
			"экссудац",
			"экстракт",
			"экстракц",
			"экстренн",
			"эксцентр",
			"элеватор",
			"элегантн",
			"электрик",
			"эллипсис",
			"элоквент",
			"элоквенц",
			"эпиграмм",
			"эпикурей",
			"эпистроф",
			"эпиталам",
			"эпителий",
			"эпоксидн",
			"эскадрон",
			"эскалаци",
			"эспадрон",
			"эспандер",
			"эсперант",
			"эстрагон",
			"аббреви",
			"абдомен",
			"абдомин",
			"абиетин",
			"абиссин",
			"абитури",
			"аблатив",
			"аблятив",
			"аболици",
			"абразив",
			"абрикос",
			"абрикот",
			"абсолют",
			"абстраг",
			"абстрак",
			"абсцесс",
			"абсцисс",
			"абштрих",
			"авантаж",
			"авантюр",
			"авокадо",
			"австрал",
			"австрий",
			"автарки",
			"автобус",
			"автомат",
			"автоном",
			"агломер",
			"агрегат",
			"агреман",
			"агресси",
			"адамант",
			"адверби",
			"адвокат",
			"адиабат",
			"адмирал",
			"адренал",
			"адъюнкт",
			"адыгеец",
			"айсберг",
			"академи",
			"акафист",
			"аквадаг",
			"акварел",
			"акведук",
			"аккомод",
			"аккумул",
			"аккурат",
			"акридин",
			"акробат",
			"аксакал",
			"аксамит",
			"акселер",
			"актуаль",
			"акцесси",
			"алатырь",
			"алебард",
			"алейрон",
			"алексин",
			"алиготе",
			"алимент",
			"алкогол",
			"алкоран",
			"аллегор",
			"аллегри",
			"аллегро",
			"аллерги",
			"аллилуй",
			"аллитер",
			"аллопат",
			"аллювий",
			"алфавит",
			"альбедо",
			"альвеол",
			"альпака",
			"альпари",
			"альтерн",
			"альфонс",
			"амарант",
			"амбрози",
			"амбушюр",
			"аметист",
			"амистад",
			"амнисти",
			"амуници",
			"анаконд",
			"аналоги",
			"анальги",
			"анамнез",
			"анапест",
			"анатоми",
			"андалуз",
			"анекдот",
			"анестез",
			"анестет",
			"аннекси",
			"аномали",
			"аномаль",
			"ансамбл",
			"антагон",
			"антилоп",
			"антимон",
			"антицип",
			"антолог",
			"антракт",
			"антураж",
			"анфилад",
			"апокрин",
			"апокриф",
			"апологи",
			"апостол",
			"апофегм",
			"апофеоз",
			"аппарат",
			"аппетит",
			"аппозит",
			"априори",
			"арабеск",
			"арбалет",
			"аргамак",
			"ареопаг",
			"арзамас",
			"арифмет",
			"аркебуз",
			"арлекин",
			"арпеджо",
			"арсенал",
			"артикль",
			"артикул",
			"артишок",
			"архалук",
			"архаров",
			"аспирин",
			"ассимил",
			"ассирий",
			"ассорти",
			"асфальт",
			"атрибут",
			"атрибуц",
			"аугмент",
			"аудитор",
			"аукцион",
			"афродит",
			"ахалтек",
			"аэробик",
			"базальт",
			"базаров",
			"базилик",
			"байкаль",
			"бакалей",
			"баккара",
			"бактери",
			"балабан",
			"балабол",
			"балабош",
			"балаган",
			"балагур",
			"баламут",
			"баламуч",
			"балахон",
			"балерин",
			"балласт",
			"баллист",
			"балобан",
			"бальзам",
			"бамбино",
			"банальн",
			"банкнот",
			"банкрот",
			"барабан",
			"бараноч",
			"барахол",
			"барахта",
			"барвинк",
			"баритон",
			"барокко",
			"баррель",
			"бассейн",
			"бастард",
			"бастион",
			"бастова",
			"бастурм",
			"батарей",
			"батиаль",
			"батюшки",
			"бахваль",
			"бегемот",
			"бедекер",
			"бедокур",
			"бедолаг",
			"белорус",
			"бельгий",
			"бенгаль",
			"бенефис",
			"бенефиц",
			"бензоин",
			"берданк",
			"беремен",
			"беркшир",
			"бернард",
			"беспечн",
			"беспоко",
			"биатлон",
			"биллион",
			"бильярд",
			"бирюлеч",
			"бирюльк",
			"бисквит",
			"благоух",
			"блаженн",
			"блокнот",
			"блондин",
			"богадел",
			"богатыр",
			"боливар",
			"боливий",
			"бордель",
			"бордеро",
			"ботиноч",
			"ботфорт",
			"бразиль",
			"браслет",
			"брахман",
			"брашпил",
			"брезент",
			"бретель",
			"бридинг",
			"брифинг",
			"бройлер",
			"бруцелл",
			"брыжееч",
			"брыжейк",
			"бственн",
			"будораж",
			"буковин",
			"буколик",
			"буколич",
			"булавоч",
			"бульвар",
			"бульдог",
			"бульдож",
			"бумазей",
			"бунгало",
			"бургунд",
			"буржуаз",
			"бурлеск",
			"буссоль",
			"бутафор",
			"буцефал",
			"вавилон",
			"вазелин",
			"ваканси",
			"вакуоль",
			"валанда",
			"валентн",
			"валидол",
			"валторн",
			"вальяжн",
			"вандаль",
			"вариант",
			"варьете",
			"васильк",
			"василёк",
			"василёч",
			"вассаль",
			"ватрушк",
			"вашгерд",
			"вдохнов",
			"вевериц",
			"везикул",
			"вейсман",
			"вековеч",
			"вексель",
			"вельбот",
			"вельвет",
			"вельмож",
			"вензель",
			"вентиль",
			"верблюд",
			"верблюж",
			"вербова",
			"вердикт",
			"верениц",
			"веретен",
			"веретён",
			"вермахт",
			"веролом",
			"вероник",
			"вероятн",
			"верстак",
			"верстач",
			"вертель",
			"вертлюг",
			"вертлюж",
			"верёвоч",
			"ветеран",
			"веществ",
			"взбелен",
			"византи",
			"виктори",
			"вилайет",
			"винкель",
			"виньетк",
			"виртуоз",
			"витамин",
			"внезапн",
			"водевил",
			"водород",
			"возврат",
			"возвращ",
			"воздвиг",
			"воздвиж",
			"воздерж",
			"воздыма",
			"возмезд",
			"возмест",
			"возраст",
			"вокабул",
			"вокатив",
			"вокзаль",
			"волапюк",
			"волдырь",
			"волокит",
			"волокон",
			"волость",
			"волчанк",
			"вольтер",
			"вольтиж",
			"воображ",
			"вообраз",
			"вопреки",
			"ворвань",
			"воробей",
			"вороноч",
			"воскрес",
			"воскреш",
			"восприя",
			"восторг",
			"восторж",
			"впечатл",
			"впрочем",
			"врангел",
			"вселенн",
			"всмятку",
			"вульгар",
			"выдержк",
			"выкамар",
			"вымпель",
			"выхухол",
			"вьетнам",
			"габарит",
			"габитус",
			"газават",
			"галаган",
			"галалит",
			"галантн",
			"галстук",
			"галстуч",
			"галтель",
			"гальван",
			"гальтер",
			"гамбузи",
			"ганглий",
			"гангрен",
			"гаранти",
			"гардени",
			"гармонь",
			"гарцева",
			"гаршнеп",
			"гастрол",
			"гвардей",
			"гегемон",
			"генерал",
			"генитив",
			"георгин",
			"гестапо",
			"гиацинт",
			"гидравл",
			"гильдей",
			"гимнази",
			"гимнаст",
			"гинекей",
			"гинецей",
			"гипотез",
			"гипотет",
			"гирлянд",
			"глаголь",
			"глазурь",
			"гледичи",
			"глетчер",
			"глухарь",
			"гностик",
			"гностиц",
			"гностич",
			"гнусавл",
			"гобелен",
			"голавль",
			"голланд",
			"гондоль",
			"гонорар",
			"гонорей",
			"гораздо",
			"горжетк",
			"гортань",
			"господь",
			"гостинч",
			"государ",
			"грабарь",
			"грабаст",
			"граваци",
			"градаци",
			"граждан",
			"граммат",
			"гребень",
			"грейдер",
			"грейфер",
			"грильяж",
			"гринвич",
			"грифель",
			"громожд",
			"громозд",
			"гротеск",
			"груббер",
			"гуанако",
			"губерни",
			"гугенот",
			"гульден",
			"гусениц",
			"гусенич",
			"гуталин",
			"дактиль",
			"дальтон",
			"дансинг",
			"девясил",
			"девять:",
			"дедвейт",
			"дедерон",
			"декабрь",
			"декольт",
			"дельфий",
			"дельфин",
			"делювий",
			"демагог",
			"демиург",
			"демпинг",
			"демпфер",
			"деникин",
			"денотат",
			"депозит",
			"депресс",
			"депутат",
			"депутац",
			"деревен",
			"дескать",
			"дефинит",
			"дефиниц",
			"дефицит",
			"дефлегм",
			"джамбул",
			"джейран",
			"джемпер",
			"джентри",
			"диагноз",
			"диалект",
			"диамант",
			"диаметр",
			"диаспор",
			"дибазол",
			"диверси",
			"дизажио",
			"динамит",
			"динарий",
			"династи",
			"дискант",
			"дисконт",
			"дискурс",
			"дискусс",
			"диспепс",
			"дисперс",
			"дисплей",
			"диссерт",
			"дистилл",
			"дистроф",
			"диффузи",
			"диффунд",
			"доблест",
			"довзыск",
			"довольн",
			"договор",
			"доктрин",
			"доломан",
			"доломит",
			"дольмен",
			"доминик",
			"домкрат",
			"доставл",
			"достичь",
			"достоин",
			"достойн",
			"дребезг",
			"дребезж",
			"дреколь",
			"дрифтер",
			"дроссел",
			"дрягиль",
			"думпкар",
			"дуплекс",
			"дуршлаг",
			"дуумвир",
			"дьяволь",
			"евангел",
			"евгеник",
			"евгенич",
			"ентерий",
			"епископ",
			"епитимь",
			"еподъём",
			"ерофеич",
			"естеств",
			"жаккард",
			"жандарм",
			"желатин",
			"желоноч",
			"желудок",
			"желудоч",
			"живопис",
			"жужелиц",
			"журавль",
			"журналь",
			"журфикс",
			"зависть",
			"заворот",
			"завтрак",
			"заглавл",
			"загогул",
			"заимств",
			"закавык",
			"закавыч",
			"заклани",
			"заковыр",
			"закомар",
			"закорюк",
			"закорюч",
			"занавес",
			"занавеш",
			"заповед",
			"запорож",
			"заправл",
			"запясть",
			"заставл",
			"застрех",
			"затылок",
			"затылоч",
			"заурядн",
			"здоравл",
			"здоровл",
			"здорово",
			"здоровь",
			"зеркаль",
			"зимогор",
			"знакомл",
			"знамени",
			"золотух",
			"золотуш",
			"зубатов",
			"ивишень",
			"игрений",
			"игумень",
			"идальго",
			"иерихон",
			"изабелл",
			"избыток",
			"избыточ",
			"известн",
			"известь",
			"изнаноч",
			"изображ",
			"изобраз",
			"изобрес",
			"изобрет",
			"изразец",
			"израиль",
			"изумруд",
			"иллюмин",
			"иллюстр",
			"ильмень",
			"иммерси",
			"импульс",
			"инвалид",
			"инверси",
			"индивид",
			"инженер",
			"инициал",
			"инкассо",
			"инкруст",
			"инспект",
			"инспекц",
			"инсталл",
			"инсулин",
			"инсульт",
			"интенци",
			"интерес",
			"инфаркт",
			"инфекци",
			"инфузор",
			"искорен",
			"искренн",
			"исповед",
			"исполин",
			"испражн",
			"иссимус",
			"исследу",
			"исступл",
			"историй",
			"истребл",
			"истукан",
			"йоркшир",
			"кабачок",
			"каберне",
			"кабинет",
			"каботаж",
			"кабошон",
			"кавалер",
			"каватин",
			"кадастр",
			"каденци",
			"кадриль",
			"каземат",
			"казимир",
			"казинет",
			"какофон",
			"каландр",
			"калибер",
			"калорий",
			"калуфер",
			"кальвин",
			"калькул",
			"кальмар",
			"кальсон",
			"камарин",
			"камбодж",
			"камелёк",
			"камзоль",
			"кампани",
			"кандаль",
			"кандиль",
			"каникул",
			"канистр",
			"канител",
			"канифас",
			"канифол",
			"канонад",
			"канонер",
			"канонир",
			"канотье",
			"кантеле",
			"кануфер",
			"канцлер",
			"капитал",
			"капитан",
			"капитон",
			"капитул",
			"капраль",
			"капсуль",
			"капсюль",
			"капуцин",
			"капюшон",
			"карабах",
			"карабин",
			"каравай",
			"караван",
			"карагач",
			"каракал",
			"караков",
			"каракул",
			"карамел",
			"карамор",
			"карапуз",
			"карауль",
			"карачун",
			"каронад",
			"каротаж",
			"каротин",
			"картвел",
			"картель",
			"картечь",
			"картинг",
			"карточк",
			"каршуни",
			"касатик",
			"кастрюл",
			"катабол",
			"катализ",
			"каталит",
			"каталог",
			"каталож",
			"каталон",
			"категор",
			"катетер",
			"катехиз",
			"католик",
			"католиц",
			"католич",
			"каустик",
			"кахетин",
			"качеств",
			"кашалот",
			"кашемир",
			"кашмири",
			"квадриг",
			"квартал",
			"квартир",
			"кельнер",
			"кемпинг",
			"кенгуру",
			"кентавр",
			"керосин",
			"кетмень",
			"кибиточ",
			"кикимор",
			"кинемат",
			"кинжаль",
			"киновар",
			"кипарис",
			"кирасир",
			"кистень",
			"кладбищ",
			"кладезь",
			"клаксон",
			"кларнет",
			"классиц",
			"классич",
			"клаузул",
			"клеврет",
			"клерова",
			"климакс",
			"климакт",
			"клиринг",
			"клистир",
			"клубень",
			"кляссер",
			"кнессет",
			"коалици",
			"кобальт",
			"кобольд",
			"козырёк",
			"кокоточ",
			"колибри",
			"коллеги",
			"колледж",
			"коллект",
			"коллизи",
			"коллоди",
			"коллоид",
			"колодез",
			"колодец",
			"колокол",
			"коломен",
			"колонок",
			"колоноч",
			"колорад",
			"колорит",
			"колымаг",
			"колымаж",
			"кольмат",
			"кольчуг",
			"кольчуж",
			"колясоч",
			"комбайн",
			"комингс",
			"комисси",
			"комитет",
			"коммент",
			"коммерс",
			"коммерц",
			"коммерч",
			"компакт",
			"компани",
			"компань",
			"компенс",
			"компост",
			"комфорт",
			"конвент",
			"конверт",
			"конденс",
			"кондици",
			"кондуит",
			"конечно",
			"конкрет",
			"конкурс",
			"коновод",
			"конопат",
			"конопач",
			"консерв",
			"консигн",
			"консист",
			"консоме",
			"конспир",
			"констат",
			"констру",
			"консуль",
			"контаги",
			"контакт",
			"контрол",
			"конфирм",
			"конфиск",
			"конфорк",
			"конформ",
			"конфуци",
			"концепт",
			"концепц",
			"концерн",
			"концерт",
			"координ",
			"корабел",
			"корабль",
			"коральк",
			"коридор",
			"корифей",
			"коррази",
			"коррект",
			"коррекц",
			"коррози",
			"коррумп",
			"корточк",
			"корысть",
			"косвенн",
			"костыль",
			"костёль",
			"коттедж",
			"кочегар",
			"кочедыж",
			"кочедык",
			"кочерыг",
			"кочерыж",
			"кочерёж",
			"кошенил",
			"кравчик",
			"крамоль",
			"краплак",
			"крахмал",
			"креветк",
			"крейцер",
			"кремень",
			"крендел",
			"крепост",
			"кресель",
			"критери",
			"кровать",
			"кровель",
			"кромешн",
			"крохаль",
			"ксерокс",
			"кубышеч",
			"кувшинк",
			"кукарек",
			"кукуруз",
			"кулебяк",
			"кулинар",
			"кульбит",
			"кульмин",
			"культив",
			"культур",
			"кумарин",
			"купидон",
			"купорос",
			"курабье",
			"куркуль",
			"куролес",
			"курсорн",
			"кустарь",
			"кутерьм",
			"кучеряв",
			"кюммель",
			"лабильн",
			"лавиров",
			"лазарет",
			"ламберт",
			"лангуст",
			"лапланд",
			"лассаль",
			"ласточк",
			"латентн",
			"лауреат",
			"левретк",
			"легальн",
			"леггорн",
			"легитим",
			"леденец",
			"леденеч",
			"леопард",
			"лепестк",
			"лепёшеч",
			"летальн",
			"летарги",
			"либерал",
			"либерти",
			"либретт",
			"лигатур",
			"лилипут",
			"лимонад",
			"лимузин",
			"линеарн",
			"линотип",
			"литерат",
			"литурги",
			"лихорад",
			"лицедей",
			"лицемер",
			"лицензи",
			"лиценци",
			"ловелас",
			"локальн",
			"ломбард",
			"ломонос",
			"лопасть",
			"лотерей",
			"любопыт",
			"люмбаго",
			"люстрин",
			"лягушеч",
			"магазин",
			"магарыч",
			"магистр",
			"магнето",
			"магноли",
			"магомет",
			"мажорит",
			"мазурик",
			"мазуроч",
			"майолик",
			"майонез",
			"майоран",
			"майорат",
			"макадам",
			"макарон",
			"македон",
			"макраме",
			"макрель",
			"макушеч",
			"малазий",
			"малахай",
			"малодуш",
			"мальтуз",
			"мальчик",
			"малярий",
			"мамалыг",
			"мамзель",
			"мангуст",
			"мандраж",
			"манекен",
			"маникюр",
			"манипул",
			"манихей",
			"мансард",
			"мантиль",
			"мантисс",
			"маратхи",
			"марафон",
			"марганц",
			"маренго",
			"мародёр",
			"марокен",
			"мартини",
			"мартышк",
			"маршалл",
			"маршаль",
			"маршрут",
			"мастерь",
			"мастурб",
			"масштаб",
			"матадор",
			"математ",
			"материй",
			"материк",
			"матрёшк",
			"маэстро",
			"маюскул",
			"маятник",
			"мгновен",
			"мегрель",
			"медведь",
			"меделян",
			"меджлис",
			"медицин",
			"медресе",
			"мезонин",
			"мельтеш",
			"мембран",
			"мензурк",
			"менонит",
			"менстру",
			"мергель",
			"меринос",
			"мерлушк",
			"металль",
			"метатез",
			"метафор",
			"метоним",
			"метресс",
			"меценат",
			"мигрень",
			"мизгирь",
			"мизинец",
			"микстур",
			"милитар",
			"милицей",
			"миллион",
			"милость",
			"минарет",
			"мингрел",
			"миндаль",
			"минерал",
			"минимал",
			"министр",
			"мирабел",
			"мирабил",
			"мистери",
			"мистрис",
			"миткаль",
			"миттель",
			"мичурин",
			"моветон",
			"могикан",
			"модальн",
			"мокасин",
			"молекул",
			"моллюск",
			"молозив",
			"молокан",
			"молочай",
			"монголь",
			"монитор",
			"монокок",
			"монопол",
			"морковь",
			"москаль",
			"московк",
			"мотыльк",
			"мотылёк",
			"мотылёч",
			"муравей",
			"мурмолк",
			"мусават",
			"мускуль",
			"мустанг",
			"мусульм",
			"мухлева",
			"муэдзин",
			"мыслете",
			"мыщелок",
			"наволок",
			"наволоч",
			"награжд",
			"надменн",
			"надфиль",
			"наипаче",
			"найтовл",
			"нактоуз",
			"налыгач",
			"намедни",
			"напасть",
			"направл",
			"напрасн",
			"напрячь",
			"наргиле",
			"нарочит",
			"нарцисс",
			"насеком",
			"наслажд",
			"насморк",
			"наставл",
			"настежь",
			"настичь",
			"настоящ",
			"настрой",
			"наступл",
			"настырн",
			"натурал",
			"нашатыр",
			"небрежн",
			"невзгод",
			"негатив",
			"неглиже",
			"недаром",
			"недоимк",
			"недомог",
			"недосуг",
			"недотёп",
			"незадач",
			"неистов",
			"нейтрал",
			"нелюдим",
			"ненавид",
			"ненасть",
			"нерадив",
			"несураз",
			"несчаст",
			"неужели",
			"неуклюж",
			"нечаянн",
			"нигерий",
			"низверг",
			"низверж",
			"никотин",
			"нипочём",
			"ниппель",
			"ножовоч",
			"нокдаун",
			"ноктюрн",
			"номинал",
			"нонсенс",
			"норманд",
			"норманн",
			"нувориш",
			"обезьян",
			"обелиск",
			"обеспеч",
			"обечайк",
			"обитель",
			"область",
			"облаточ",
			"облепих",
			"обломов",
			"облучок",
			"обморок",
			"обмороч",
			"обнаруж",
			"оболочк",
			"обормот",
			"образец",
			"образов",
			"обурева",
			"обыденн",
			"оголтел",
			"ожерель",
			"ойкумен",
			"оксалат",
			"октябрь",
			"олеандр",
			"олигарх",
			"омнибус",
			"определ",
			"оранжев",
			"ординар",
			"ординат",
			"оркестр",
			"ортопед",
			"орудова",
			"осведом",
			"осклабл",
			"оскорбл",
			"осокорь",
			"остальн",
			"останов",
			"остерег",
			"остереж",
			"остерёг",
			"остолоп",
			"осторож",
			"отображ",
			"отобраз",
			"оторопь",
			"отправл",
			"отпрыск",
			"отрывок",
			"отрывоч",
			"отстран",
			"офицерь",
			"офтальм",
			"охламон",
			"очевидн",
			"очередь",
			"пазанок",
			"пакгауз",
			"пакость",
			"паладин",
			"палатал",
			"палаточ",
			"палаццо",
			"палисад",
			"пальмир",
			"памперо",
			"памфлет",
			"пандект",
			"пандури",
			"панегир",
			"паниров",
			"панихид",
			"панорам",
			"пансион",
			"пантеон",
			"панцирь",
			"папавер",
			"паперть",
			"папирос",
			"папирус",
			"парабол",
			"парагва",
			"парадиз",
			"паразит",
			"парализ",
			"паралит",
			"паралич",
			"парандж",
			"параной",
			"парапет",
			"парафин",
			"парашют",
			"парвеню",
			"пардонн",
			"паритет",
			"паркинг",
			"паркова",
			"пародий",
			"партнёр",
			"парубок",
			"парусин",
			"парфорс",
			"парцелл",
			"паскаль",
			"пасквил",
			"пасмурн",
			"пасмурь",
			"паспорт",
			"пастель",
			"пасьянс",
			"патерик",
			"патетик",
			"патетич",
			"патефон",
			"патолог",
			"патриот",
			"патрици",
			"патруль",
			"пациент",
			"педагог",
			"педиатр",
			"педикюр",
			"пеклева",
			"пеклёва",
			"пелерин",
			"пеликан",
			"пельмен",
			"пельмеш",
			"пендель",
			"пендинк",
			"пенчинг",
			"пеньюар",
			"переним",
			"перепел",
			"перепёл",
			"переста",
			"перифер",
			"перкаль",
			"перстен",
			"пертурб",
			"перфект",
			"перчатк",
			"пескарь",
			"пестова",
			"петрушк",
			"пехлеви",
			"печенег",
			"печенеж",
			"печорин",
			"пианино",
			"пигалиц",
			"пигмент",
			"пикантн",
			"пикколо",
			"пилястр",
			"пингвин",
			"пирамид",
			"пиреней",
			"писсуар",
			"пистоль",
			"пифагор",
			"планшет",
			"планшир",
			"пластик",
			"пластин",
			"пластич",
			"пластыр",
			"плацебо",
			"плацент",
			"плевель",
			"плейбой",
			"пленарн",
			"плесень",
			"плинтус",
			"пломбир",
			"плотник",
			"плотниц",
			"плотнич",
			"площадк",
			"площадь",
			"плунжер",
			"пневмат",
			"пневмон",
			"повестк",
			"повесть",
			"повилик",
			"повилич",
			"поворот",
			"повстан",
			"подваль",
			"подверг",
			"подверж",
			"подданн",
			"подлинн",
			"подпруг",
			"подража",
			"подробн",
			"подсобл",
			"подсолн",
			"подушеч",
			"пожалуй",
			"позвонк",
			"поздрав",
			"позитив",
			"пойнтер",
			"поколен",
			"покрови",
			"полемич",
			"полиров",
			"политен",
			"политич",
			"политур",
			"полицай",
			"полицей",
			"половин",
			"полость",
			"полотен",
			"полундр",
			"поместь",
			"помидор",
			"пономар",
			"попереч",
			"поперёк",
			"попугай",
			"популяр",
			"попурри",
			"попусти",
			"поработ",
			"порабощ",
			"поролон",
			"порошок",
			"порошоч",
			"порталь",
			"портрет",
			"портупе",
			"портьер",
			"портянк",
			"поршень",
			"порядок",
			"порядоч",
			"посконь",
			"последн",
			"поставл",
			"постель",
			"постичь",
			"постоян",
			"пострел",
			"поступл",
			"потенци",
			"потолок",
			"потолоч",
			"потребл",
			"потчева",
			"початок",
			"почечуй",
			"почитай",
			"пошехон",
			"праведн",
			"правиль",
			"прагмат",
			"пралине",
			"превент",
			"преврат",
			"превращ",
			"преград",
			"предани",
			"предвар",
			"предвод",
			"предель",
			"предлаг",
			"предлог",
			"предлож",
			"предмет",
			"предмеч",
			"предпри",
			"предрек",
			"предреч",
			"предтеч",
			"предъяв",
			"презент",
			"прекрат",
			"прекращ",
			"прелест",
			"прелюди",
			"пременн",
			"премьер",
			"препина",
			"препира",
			"препода",
			"пререка",
			"престав",
			"престиж",
			"престол",
			"преступ",
			"претвор",
			"претенд",
			"претенз",
			"претенц",
			"префект",
			"префикс",
			"приватн",
			"приверж",
			"приглас",
			"приглаш",
			"признак",
			"призрак",
			"призрач",
			"приключ",
			"прилежн",
			"принтер",
			"принцип",
			"приправ",
			"приспеш",
			"приспич",
			"пристав",
			"притвор",
			"приторн",
			"притяза",
			"приуроч",
			"прификс",
			"прихоть",
			"причаст",
			"приязнь",
			"проблем",
			"проверг",
			"проверж",
			"провизи",
			"проворн",
			"прогнат",
			"прогноз",
			"продель",
			"продолж",
			"продувн",
			"продукт",
			"продукц",
			"прожект",
			"прозект",
			"пройдох",
			"проклам",
			"пролонг",
			"пролюви",
			"промысл",
			"промышл",
			"прононс",
			"прорица",
			"просвет",
			"просвещ",
			"просвир",
			"простат",
			"простер",
			"простир",
			"простор",
			"проступ",
			"простын",
			"простёр",
			"просфор",
			"протект",
			"протекц",
			"протест",
			"противл",
			"противн",
			"професс",
			"профиль",
			"процент",
			"процесс",
			"прюнель",
			"псалтыр",
			"псориаз",
			"птерикс",
			"пуансон",
			"пуантил",
			"пудлинг",
			"пуловер",
			"пульвер",
			"пульман",
			"пульмон",
			"пунктир",
			"пуритан",
			"путассу",
			"пфенниг",
			"равелин",
			"радикал",
			"радуниц",
			"разбавл",
			"развлёк",
			"разврат",
			"развращ",
			"раздоль",
			"раздраж",
			"ракеточ",
			"раковин",
			"рамазан",
			"рангоут",
			"рандеву",
			"ранчеро",
			"раппорт",
			"рапсоди",
			"раритет",
			"расплох",
			"расправ",
			"раствор",
			"расторг",
			"расторж",
			"рафинад",
			"рашпиль",
			"реверси",
			"регенер",
			"регистр",
			"регресс",
			"резекци",
			"резолют",
			"результ",
			"рейсмас",
			"рейсмус",
			"рейтинг",
			"реквием",
			"рекупер",
			"реликви",
			"релятив",
			"ренегат",
			"рентген",
			"репресс",
			"рептили",
			"рептиль",
			"реслинг",
			"реставр",
			"ретикул",
			"реферат",
			"рефлекс",
			"рефлект",
			"рефракт",
			"рецензи",
			"рецепци",
			"рецесси",
			"рецидив",
			"решёточ",
			"ризотто",
			"рикошет",
			"рислинг",
			"риторик",
			"риторич",
			"ритуаль",
			"ришелье",
			"рокайль",
			"рондино",
			"роскошь",
			"росомах",
			"росомаш",
			"ростбиф",
			"ротатор",
			"рубанок",
			"руковод",
			"рулеточ",
			"русалоч",
			"рухлядь",
			"саквояж",
			"саксаул",
			"салазоч",
			"салицил",
			"салфетк",
			"салхино",
			"самурай",
			"санатор",
			"сангвин",
			"сандали",
			"сандаль",
			"сандвич",
			"санитар",
			"санорин",
			"сарафан",
			"сарацин",
			"сарказм",
			"саркаст",
			"сарпинк",
			"сатинёр",
			"сахалин",
			"свастик",
			"сведени",
			"свежева",
			"свежёва",
			"свеколь",
			"сверчок",
			"свидани",
			"свидань",
			"свирель",
			"свирист",
			"свобожд",
			"свойств",
			"сволочь",
			"себорей",
			"сегмент",
			"сегодня",
			"седалищ",
			"секуляр",
			"селадон",
			"селезен",
			"селекци",
			"селькуп",
			"семафор",
			"семестр",
			"семинар",
			"сенегал",
			"сенсаци",
			"сенсуал",
			"сентаво",
			"сентимо",
			"сепарат",
			"серафим",
			"сервант",
			"серенад",
			"сержант",
			"серпент",
			"серпянк",
			"серьёзн",
			"серёжеч",
			"сетречь",
			"сибарит",
			"сиволап",
			"сигналь",
			"силикат",
			"симметр",
			"симпати",
			"симптом",
			"симфони",
			"симфонь",
			"синагог",
			"сингаль",
			"синдром",
			"синекур",
			"синерод",
			"синклит",
			"синкраз",
			"синкрет",
			"синтагм",
			"синтакс",
			"синтакт",
			"сирокко",
			"сиртаки",
			"ситуаци",
			"сифилид",
			"сифилис",
			"сифилит",
			"сказуем",
			"скалдыр",
			"скандал",
			"скатерт",
			"скважин",
			"сквалыг",
			"сквалыж",
			"скворец",
			"сквореч",
			"скипетр",
			"склероз",
			"скляноч",
			"скользч",
			"скользь",
			"скорбут",
			"скорлуп",
			"скорняж",
			"скорняк",
			"скоромн",
			"скрежет",
			"скрежещ",
			"скрепер",
			"скрипиц",
			"скудель",
			"скульпт",
			"скумбри",
			"слединг",
			"слепень",
			"слесарь",
			"словарь",
			"слякоть",
			"смазлив",
			"смарагд",
			"смахива",
			"смокинг",
			"сморчок",
			"снадобь",
			"снайпер",
			"снегирь",
			"соблазн",
			"событий",
			"совесть",
			"совкупл",
			"совмест",
			"совокуп",
			"созерца",
			"солдать",
			"солидар",
			"солитер",
			"солитёр",
			"соловей",
			"солярий",
			"сомалий",
			"соображ",
			"сообраз",
			"сопрано",
			"соревну",
			"сорочеч",
			"сосисоч",
			"составл",
			"состяза",
			"спардек",
			"спардеч",
			"спартак",
			"спасибо",
			"спектив",
			"спекуль",
			"специал",
			"спидвей",
			"спираль",
			"сподвиж",
			"спокойн",
			"спондей",
			"спондил",
			"спонсор",
			"способн",
			"спровад",
			"спроваж",
			"средств",
			"сретени",
			"стабиль",
			"ставрид",
			"стадион",
			"сталагм",
			"сталакт",
			"стамеск",
			"станавл",
			"станиол",
			"становл",
			"станций",
			"стапель",
			"старост",
			"старшин",
			"статист",
			"стеарин",
			"стеатит",
			"стебель",
			"стеколь",
			"стеллаж",
			"стеллит",
			"степенн",
			"степень",
			"стеречь",
			"стержен",
			"стерляд",
			"стерляж",
			"стиракс",
			"стироль",
			"стихарь",
			"столбов",
			"стотинк",
			"страниц",
			"странич",
			"страсть",
			"стратег",
			"стрекоз",
			"стрекот",
			"стрекоч",
			"стрепет",
			"стретто",
			"стрикци",
			"стропил",
			"стручок",
			"стручоч",
			"студент",
			"студенч",
			"ступень",
			"суахили",
			"субсиди",
			"субъект",
			"сувенир",
			"суверен",
			"суворов",
			"судорог",
			"судорож",
			"султанк",
			"суматох",
			"суматош",
			"сумереч",
			"сумятиц",
			"суппорт",
			"суспенд",
			"суспенз",
			"сутолок",
			"сутолоч",
			"суффикс",
			"сухмень",
			"существ",
			"схоласт",
			"сюзерен",
			"сюрприз",
			"сёрфинг",
			"таблетк",
			"табурет",
			"таволож",
			"таиланд",
			"таймень",
			"такелаж",
			"таламус",
			"тальянк",
			"таможен",
			"тангенс",
			"тангенц",
			"танзани",
			"тантьем",
			"тарабан",
			"тарабар",
			"таракан",
			"таракаш",
			"тарарам",
			"тарарах",
			"таратай",
			"таратор",
			"тарелоч",
			"тарельч",
			"тебенев",
			"тебеньк",
			"тебенёв",
			"тебенёк",
			"текстур",
			"тельфер",
			"терилен",
			"терпент",
			"тетерев",
			"тетрадь",
			"типикон",
			"ткемали",
			"товарищ",
			"тожеств",
			"толкова",
			"толокон",
			"тонзилл",
			"тоннель",
			"торнадо",
			"тороват",
			"тотальн",
			"траверз",
			"траверс",
			"традици",
			"трайбал",
			"трактат",
			"трактир",
			"трактов",
			"трактор",
			"трамбов",
			"трамвай",
			"транжир",
			"транзит",
			"траншей",
			"трапеци",
			"траулер",
			"требова",
			"трейлер",
			"трельяж",
			"трембит",
			"тремоло",
			"тренчик",
			"трепанг",
			"трепель",
			"триггер",
			"триппер",
			"трифоль",
			"троакар",
			"троллей",
			"тромбон",
			"тропарь",
			"тротуар",
			"трутень",
			"трюфель",
			"тубероз",
			"туннель",
			"туркмен",
			"турнепс",
			"тщеслав",
			"тюбетей",
			"тюльпан",
			"ублюдок",
			"ублюдоч",
			"уведомл",
			"увертюр",
			"углевод",
			"углерод",
			"углерож",
			"уголовн",
			"угоразд",
			"узуальн",
			"уключин",
			"ультимо",
			"ундевит",
			"универс",
			"унитарн",
			"уничтож",
			"упраздн",
			"уругвай",
			"урядник",
			"уряднич",
			"утвержд",
			"участок",
			"фактори",
			"фалалей",
			"фальцет",
			"фантази",
			"фантаст",
			"фарадей",
			"фарисей",
			"фармаци",
			"февраль",
			"феномен",
			"фенхель",
			"фермент",
			"фермуар",
			"фершпил",
			"фиксоль",
			"филател",
			"филиаль",
			"филумен",
			"филёноч",
			"финикий",
			"финифть",
			"финлянд",
			"фискаль",
			"фисташк",
			"фитюльк",
			"флагман",
			"фламанд",
			"фламинг",
			"фланель",
			"флаттер",
			"флегмон",
			"флексий",
			"флигель",
			"флюгарк",
			"фолиант",
			"форвард",
			"фордзон",
			"форсунк",
			"фортель",
			"форточк",
			"форшмак",
			"француж",
			"француз",
			"фрейлин",
			"фригидн",
			"фрикасе",
			"фронтон",
			"фуганок",
			"фуганоч",
			"фуражеч",
			"фюзеляж",
			"хабанер",
			"хавронь",
			"ханурик",
			"харатей",
			"хворост",
			"херувим",
			"хинкали",
			"хлобыст",
			"хлястик",
			"холерич",
			"хорохор",
			"хоругвь",
			"христос",
			"хрустал",
			"хулахуп",
			"хулиган",
			"цейтнот",
			"центавр",
			"центнер",
			"церемон",
			"церковь",
			"цикорий",
			"цилиндр",
			"циновоч",
			"циркуль",
			"цистерн",
			"чагатай",
			"часовен",
			"частица",
			"частушк",
			"чахоточ",
			"чебурах",
			"чебураш",
			"чебурек",
			"чебуреч",
			"чекмарь",
			"чекмень",
			"человек",
			"человеч",
			"челюсть",
			"чембало",
			"чемодан",
			"чемпион",
			"черевик",
			"черевич",
			"черемис",
			"черенок",
			"череноч",
			"черепах",
			"черепаш",
			"черепит",
			"черепиц",
			"черепич",
			"черепок",
			"черешен",
			"черешок",
			"черниль",
			"черёмух",
			"черёмуш",
			"четверг",
			"четверт",
			"чечевиц",
			"чечевич",
			"чианури",
			"чихвост",
			"чонгури",
			"чурчхел",
			"шагрень",
			"шалопай",
			"шалопут",
			"шальвар",
			"шаматон",
			"шампунь",
			"шантрап",
			"шарабан",
			"шарманк",
			"шаровар",
			"шаромыг",
			"шаромыж",
			"шарошеч",
			"шартрез",
			"швартов",
			"швейцар",
			"швеллер",
			"шворень",
			"шевалье",
			"шевелюр",
			"шезлонг",
			"шеллинг",
			"шелудив",
			"шепеляв",
			"шеренож",
			"шершень",
			"шестерн",
			"шиворот",
			"шиллинг",
			"шинкова",
			"шиншилл",
			"шкатулк",
			"шлифова",
			"шлямбур",
			"шнеллер",
			"шницель",
			"шоколад",
			"шомполь",
			"шотланд",
			"шпаклёв",
			"шпандор",
			"шпаргал",
			"шпатель",
			"шпинель",
			"штабель",
			"штанген",
			"штапель",
			"штафирк",
			"штевень",
			"штейгер",
			"штемпел",
			"штепсел",
			"штиблет",
			"штукарь",
			"штукова",
			"штурвал",
			"штурман",
			"ызвестн",
			"ындивид",
			"ынсульт",
			"ынтерес",
			"ынфаркт",
			"эвдемон",
			"эволюци",
			"эквадор",
			"экватор",
			"экзальт",
			"экзамен",
			"экзегез",
			"экзегет",
			"экономл",
			"экскурс",
			"экспанс",
			"эксперт",
			"эксплик",
			"эксплиц",
			"эксплоз",
			"экспозе",
			"экспози",
			"экспорт",
			"экстерн",
			"экстраг",
			"экстрак",
			"экстрем",
			"экструз",
			"эксцесс",
			"эластич",
			"элемент",
			"элениум",
			"элеутер",
			"эликсир",
			"эмансип",
			"эмбарго",
			"эмбрион",
			"эмиссар",
			"эмиттер",
			"эмпирей",
			"эмульси",
			"эмфизем",
			"энигмат",
			"энцефал",
			"эпендим",
			"эпентез",
			"эпентет",
			"эпиграф",
			"эпидеми",
			"эпикуре",
			"эпилепс",
			"эпилепт",
			"эпистол",
			"эпитафи",
			"эпители",
			"эскалад",
			"эскалоп",
			"эскамот",
			"эскимос",
			"эскулап",
			"эспадон",
			"эспарто",
			"эссенци",
			"эстакад",
			"эстафет",
			"эстокад",
			"этажерк",
			"юньнань",
			"ярмароч",
			"ярослав",
			"абажур",
			"абазин",
			"аблакт",
			"аблаут",
			"абляут",
			"абляци",
			"абрази",
			"абреже",
			"абруцц",
			"абсент",
			"абсурд",
			"аварий",
			"август",
			"авраль",
			"австри",
			"автарк",
			"агнози",
			"агресс",
			"адажио",
			"адалин",
			"адамит",
			"адамси",
			"адвент",
			"адденд",
			"адидас",
			"адонис",
			"адуляр",
			"адыгей",
			"азарин",
			"азимут",
			"айлант",
			"айсинг",
			"академ",
			"аккорд",
			"аксиом",
			"актини",
			"актуал",
			"акцент",
			"акцепт",
			"акцепц",
			"акцесс",
			"алгебр",
			"алидад",
			"аллегр",
			"аллель",
			"аллерг",
			"аллонж",
			"аллюви",
			"аллюзи",
			"алтарь",
			"алудур",
			"алунит",
			"альбед",
			"альбин",
			"альбит",
			"альбом",
			"альный",
			"альтер",
			"альтру",
			"альянс",
			"алюмин",
			"амазон",
			"аманат",
			"аматёр",
			"амбици",
			"америк",
			"америц",
			"амиант",
			"аммиак",
			"аммиач",
			"амнист",
			"ампель",
			"амплуа",
			"амулет",
			"амунич",
			"амхара",
			"анабол",
			"анализ",
			"аналит",
			"аналог",
			"аналой",
			"анальг",
			"ананас",
			"анархи",
			"анатом",
			"анафем",
			"анафор",
			"ангель",
			"англий",
			"англик",
			"англиц",
			"андант",
			"анилин",
			"анимал",
			"анклав",
			"аннекс",
			"антенн",
			"антикв",
			"антрац",
			"антроп",
			"анчоус",
			"аншлаг",
			"аншлюс",
			"аорист",
			"апломб",
			"аполог",
			"апофем",
			"апплик",
			"аппрет",
			"апрель",
			"априор",
			"арамей",
			"арахид",
			"арахис",
			"арбитр",
			"аргали",
			"аргент",
			"ареаль",
			"арктич",
			"арнаут",
			"аромат",
			"артель",
			"артери",
			"артист",
			"асбест",
			"аспект",
			"ассигн",
			"ассири",
			"ассист",
			"ассоци",
			"астени",
			"атаман",
			"атанде",
			"ателье",
			"атлант",
			"атрофи",
			"атташе",
			"аттест",
			"ауксан",
			"ауксин",
			"аутент",
			"афронт",
			"аффект",
			"аффикс",
			"аятолл",
			"бабочк",
			"бабуин",
			"багдад",
			"байбак",
			"байбач",
			"байдар",
			"байкал",
			"байпас",
			"байрам",
			"байрон",
			"байхов",
			"бакале",
			"бакаут",
			"баклаг",
			"баклаж",
			"баклан",
			"баклуш",
			"бактер",
			"бакшиш",
			"балака",
			"баланд",
			"баланс",
			"балбес",
			"балкан",
			"балкар",
			"балкон",
			"баллад",
			"баллон",
			"баллот",
			"балова",
			"балтий",
			"балхаш",
			"бальне",
			"бамбук",
			"бампер",
			"бандаж",
			"бандер",
			"банджо",
			"бандур",
			"банкет",
			"баньян",
			"баобаб",
			"баранк",
			"барахл",
			"барахт",
			"барбос",
			"барбот",
			"бардак",
			"баретк",
			"барион",
			"баркан",
			"баркас",
			"барраж",
			"барсук",
			"барсуч",
			"бархан",
			"бархат",
			"бархот",
			"барьер",
			"баскак",
			"баскет",
			"басмач",
			"бассей",
			"бастов",
			"батали",
			"баталь",
			"батаре",
			"батист",
			"батман",
			"батожь",
			"батрак",
			"батрац",
			"батрач",
			"батырь",
			"бахвал",
			"бахром",
			"бацбий",
			"бацилл",
			"башкир",
			"башлык",
			"башлыч",
			"башмак",
			"башмач",
			"баштан",
			"баядер",
			"бегони",
			"бедлам",
			"бедуин",
			"безмен",
			"белудж",
			"бельги",
			"бенгал",
			"бензин",
			"бензой",
			"бентос",
			"бербер",
			"бердыш",
			"бережь",
			"берест",
			"беречь",
			"берилл",
			"беркел",
			"беркли",
			"беркут",
			"берлин",
			"берлог",
			"берлож",
			"берёст",
			"бестер",
			"бешмет",
			"бештау",
			"бибабо",
			"библей",
			"бивуак",
			"бигуди",
			"бизань",
			"бизнес",
			"бикини",
			"бисмут",
			"биссин",
			"бистро",
			"битенг",
			"битини",
			"битник",
			"блажен",
			"бланоч",
			"бобыль",
			"бойкот",
			"бойлер",
			"бокаль",
			"боксёр",
			"болван",
			"болваш",
			"болгар",
			"болеро",
			"боливи",
			"болонк",
			"болонь",
			"бомонд",
			"бонтон",
			"бордюр",
			"боржом",
			"бормот",
			"бормоч",
			"борожд",
			"борозд",
			"боронь",
			"боскет",
			"бостон",
			"ботинк",
			"боцман",
			"боярыш",
			"бразил",
			"брахий",
			"бревен",
			"бревеш",
			"бревёш",
			"брегет",
			"брелок",
			"брелоч",
			"бренди",
			"бретон",
			"бретёр",
			"брехер",
			"бригад",
			"брикет",
			"британ",
			"брокер",
			"брошюр",
			"брудер",
			"брутто",
			"брыжей",
			"брюмер",
			"брюнет",
			"бублик",
			"бублич",
			"бугель",
			"будуар",
			"будённ",
			"буерак",
			"буерач",
			"буйвол",
			"буйреп",
			"буквар",
			"буклет",
			"буксир",
			"булавк",
			"булавч",
			"булгач",
			"бултых",
			"бульон",
			"бумазе",
			"бункер",
			"бунчук",
			"буравл",
			"бурбон",
			"бургон",
			"бурдюк",
			"бурдюч",
			"буржуа",
			"буржуй",
			"буриме",
			"буркал",
			"бурлак",
			"бурлац",
			"бурлач",
			"бурнус",
			"буррет",
			"бурхан",
			"бурьян",
			"бустер",
			"бутыль",
			"буханк",
			"бушева",
			"бушель",
			"бушлат",
			"бушмен",
			"бюджет",
			"бюргер",
			"вагран",
			"вакант",
			"вакаци",
			"вакуол",
			"вакуум",
			"вакцин",
			"валанд",
			"валент",
			"вальян",
			"вампир",
			"вандал",
			"ваниль",
			"варвар",
			"варган",
			"варежк",
			"варнак",
			"варнач",
			"варшав",
			"вассал",
			"ватман",
			"вафель",
			"вахлак",
			"вахлац",
			"вахлач",
			"вежлив",
			"вексел",
			"вектор",
			"вельми",
			"венгер",
			"венеци",
			"вензел",
			"вентил",
			"веранд",
			"вербен",
			"вербов",
			"верезж",
			"вереск",
			"верзил",
			"вермут",
			"вероят",
			"вертел",
			"вертеп",
			"верёвк",
			"весель",
			"весьма",
			"ветошь",
			"ветчин",
			"взаимн",
			"взросл",
			"виадук",
			"виваче",
			"виверр",
			"вигонь",
			"видать",
			"видимо",
			"визави",
			"визант",
			"визирь",
			"викинг",
			"виконт",
			"викунь",
			"вискоз",
			"висмут",
			"виссон",
			"витраж",
			"витрин",
			"витязь",
			"вишень",
			"власть",
			"вместе",
			"вместо",
			"вогуль",
			"водруж",
			"водруз",
			"воевод",
			"вождел",
			"воздух",
			"воздуш",
			"возмещ",
			"возник",
			"возраж",
			"возраз",
			"войлач",
			"войлок",
			"войлоч",
			"вокаль",
			"вокзал",
			"волдыр",
			"волокн",
			"волост",
			"волочь",
			"волшеб",
			"волынк",
			"вольер",
			"вольно",
			"вообще",
			"воочию",
			"воплот",
			"воплощ",
			"вопрос",
			"вопрош",
			"ворван",
			"воробь",
			"воронк",
			"воронь",
			"восемь",
			"воспал",
			"воспит",
			"воспря",
			"восток",
			"восточ",
			"восхит",
			"восхищ",
			"вотчин",
			"вполне",
			"впредь",
			"всегда",
			"вселен",
			"вспыль",
			"вспять",
			"встрет",
			"встреч",
			"втемяш",
			"втулоч",
			"вулкан",
			"вызвол",
			"вымпел",
			"выпукл",
			"вышпар",
			"вьюрок",
			"вьюшеч",
			"вязель",
			"вяхирь",
			"вёсель",
			"габбро",
			"габион",
			"гавань",
			"гагауз",
			"газель",
			"гайдук",
			"гайдуц",
			"гаймор",
			"гайтан",
			"галакт",
			"галере",
			"галифе",
			"галлон",
			"галушк",
			"гальюн",
			"гамбит",
			"гамлет",
			"гангли",
			"ганзей",
			"гантел",
			"гаолян",
			"гарант",
			"гардин",
			"гармон",
			"гармош",
			"гарнир",
			"гарпун",
			"гарсон",
			"гастер",
			"гаубиц",
			"гаубич",
			"гафель",
			"гашетк",
			"гварде",
			"гварди",
			"гвиней",
			"гвоздь",
			"гегель",
			"гезенк",
			"гейзер",
			"гектар",
			"геморр",
			"георги",
			"гепард",
			"герань",
			"гербар",
			"герман",
			"гермет",
			"героин",
			"геронт",
			"герпет",
			"герцог",
			"гестап",
			"гетман",
			"геттер",
			"гешефт",
			"гиббон",
			"гибрид",
			"гигант",
			"гигиен",
			"гиджак",
			"гильди",
			"гимназ",
			"гипноз",
			"гипнот",
			"гитлер",
			"глагол",
			"глазет",
			"глазур",
			"глицер",
			"глобин",
			"глобул",
			"глобус",
			"глубок",
			"глубоч",
			"глухар",
			"глюкоз",
			"глютин",
			"глянец",
			"гнусав",
			"гоголь",
			"голавл",
			"голгоф",
			"голень",
			"голиаф",
			"головн",
			"головь",
			"голодь",
			"голубл",
			"голубц",
			"голубь",
			"гондол",
			"гоноре",
			"гончар",
			"горазд",
			"гордон",
			"горечь",
			"горилл",
			"гормон",
			"горнил",
			"горниц",
			"горнич",
			"городь",
			"горсть",
			"гортан",
			"горшеч",
			"горшок",
			"горшоч",
			"господ",
			"госпож",
			"готавл",
			"готовл",
			"грабар",
			"гравер",
			"гравий",
			"гравит",
			"гравюр",
			"градус",
			"грамот",
			"гранат",
			"гранит",
			"границ",
			"гранич",
			"граноч",
			"гранул",
			"графин",
			"графит",
			"гребен",
			"гребеш",
			"гребён",
			"гресси",
			"гривен",
			"гризли",
			"гримас",
			"грифон",
			"грогги",
			"гроздь",
			"громад",
			"громых",
			"грохат",
			"грохот",
			"грохоч",
			"груздь",
			"грузин",
			"грусть",
			"губерн",
			"гуверн",
			"гудрон",
			"гундос",
			"гунтер",
			"гурман",
			"гусель",
			"гуцуль",
			"дактил",
			"далмат",
			"дамаст",
			"даммар",
			"дарвин",
			"даргин",
			"дашнак",
			"дворец",
			"дебиль",
			"деверь",
			"девять",
			"деград",
			"дегуст",
			"дедукт",
			"дедукц",
			"дезаву",
			"декабр",
			"деклам",
			"деклар",
			"декрет",
			"декстр",
			"делюви",
			"демарк",
			"демарш",
			"денежь",
			"денонс",
			"депорт",
			"дервиш",
			"дергач",
			"деревн",
			"держав",
			"деррик",
			"десант",
			"десерт",
			"десниц",
			"деспот",
			"десять",
			"деталь",
			"детект",
			"дефект",
			"дефиле",
			"дехкан",
			"дешевл",
			"джерси",
			"джигит",
			"джинго",
			"джоуль",
			"джугар",
			"джунгл",
			"диабаз",
			"диабет",
			"диадем",
			"диакон",
			"диалог",
			"диатез",
			"диверс",
			"дивизи",
			"дидакт",
			"дизайн",
			"дизель",
			"дилемм",
			"динамо",
			"династ",
			"диоптр",
			"диплом",
			"дирхем",
			"дискут",
			"дислок",
			"дислоц",
			"диспон",
			"диспут",
			"дифтер",
			"диффуз",
			"днестр",
			"доволь",
			"дозвол",
			"доклад",
			"докона",
			"доктор",
			"долдон",
			"должен",
			"доллар",
			"домино",
			"донбас",
			"допинг",
			"допраш",
			"допрос",
			"допрош",
			"допуст",
			"дородн",
			"дорожь",
			"досажд",
			"доспех",
			"достав",
			"достиг",
			"достиж",
			"доступ",
			"дотошн",
			"доцент",
			"драгун",
			"дракон",
			"драпри",
			"дрезин",
			"дрожеч",
			"дротик",
			"дрочён",
			"дружин",
			"дубрав",
			"дубров",
			"думпер",
			"дуплет",
			"дурман",
			"душанб",
			"душман",
			"дьявол",
			"дьякон",
			"дюбель",
			"дягиль",
			"дёготь",
			"египет",
			"ектень",
			"ентери",
			"епархи",
			"ералаш",
			"ерепен",
			"ермолк",
			"есауль",
			"ефимок",
			"жавель",
			"жалова",
			"жалюзи",
			"жаргон",
			"жасмин",
			"желвак",
			"желвач",
			"желонк",
			"жеманн",
			"жемчуг",
			"жемчуж",
			"жеребь",
			"жерлиц",
			"жернов",
			"жесток",
			"жесточ",
			"жечься",
			"живете",
			"жиронд",
			"жолнер",
			"жолнёр",
			"жребий",
			"журавл",
			"журнал",
			"жёлудь",
			"жёрнов",
			"забавл",
			"забияк",
			"забрал",
			"завзят",
			"завист",
			"заводь",
			"завтра",
			"заглав",
			"загодя",
			"зазноб",
			"займищ",
			"заключ",
			"закром",
			"замбий",
			"заметь",
			"замшев",
			"замысл",
			"западн",
			"запань",
			"заплот",
			"запонк",
			"заправ",
			"запрет",
			"запрещ",
			"запуск",
			"запуст",
			"запыха",
			"запяст",
			"заречь",
			"заседа",
			"заслуж",
			"застав",
			"застря",
			"заступ",
			"затыль",
			"зауряд",
			"защища",
			"здоров",
			"зейгер",
			"зеланд",
			"зелень",
			"земель",
			"землян",
			"зенкер",
			"зеркал",
			"зерцал",
			"зигзаг",
			"знаком",
			"знамен",
			"зодиак",
			"золовк",
			"зорилл",
			"зрачок",
			"зубиль",
			"зуммер",
			"зяблик",
			"ибикон",
			"иволга",
			"игумен",
			"идилли",
			"иезуит",
			"иерарх",
			"изафет",
			"избавл",
			"изверг",
			"изверж",
			"извест",
			"изврат",
			"извращ",
			"извёст",
			"издерж",
			"изможд",
			"измыва",
			"изнанк",
			"изобар",
			"изобат",
			"изогон",
			"изразц",
			"изрядн",
			"изувер",
			"изъявл",
			"изюбрь",
			"икарий",
			"икебан",
			"иллион",
			"иллюзи",
			"ильмен",
			"имажин",
			"имбирь",
			"именно",
			"импери",
			"имплик",
			"импорт",
			"импров",
			"инверс",
			"инверт",
			"инвест",
			"индееч",
			"индейк",
			"индекс",
			"индиго",
			"индосс",
			"индукт",
			"индукц",
			"инертн",
			"инерци",
			"инженю",
			"инкасс",
			"инквиз",
			"инклин",
			"иногда",
			"инсину",
			"инспир",
			"интегр",
			"интенс",
			"интерн",
			"интриг",
			"интриж",
			"интуит",
			"интуиц",
			"информ",
			"иордан",
			"ипотек",
			"ипотеч",
			"ирланд",
			"ирокез",
			"исключ",
			"искони",
			"искусн",
			"исланд",
			"исмент",
			"испещр",
			"исправ",
			"иссимо",
			"истери",
			"исторг",
			"исторж",
			"истори",
			"истошн",
			"истреб",
			"исчади",
			"исчёрк",
			"италий",
			"йогурт",
			"йошкар",
			"кабаль",
			"кабарг",
			"кабаре",
			"каббал",
			"кабель",
			"каблук",
			"каблуч",
			"кабуки",
			"кабуль",
			"каверз",
			"каверн",
			"кавказ",
			"каданс",
			"каденц",
			"казарк",
			"казарм",
			"казеин",
			"казино",
			"казуар",
			"кайзер",
			"каймак",
			"кайман",
			"какаду",
			"кактус",
			"каланч",
			"калган",
			"калева",
			"календ",
			"калибр",
			"калитк",
			"каллус",
			"каллюс",
			"калмык",
			"калмыц",
			"калмыч",
			"калори",
			"кальян",
			"каляка",
			"калёва",
			"камбал",
			"камбий",
			"камбио",
			"камбуз",
			"камедь",
			"камели",
			"камень",
			"камерн",
			"камзол",
			"камлот",
			"каморр",
			"кампеш",
			"камуфл",
			"камфар",
			"камфор",
			"камчат",
			"каналь",
			"канапе",
			"кандал",
			"кандым",
			"канкан",
			"кантат",
			"кантон",
			"кантор",
			"канцер",
			"канцон",
			"каньон",
			"каолин",
			"капелл",
			"капель",
			"капкан",
			"каплун",
			"капрал",
			"каприз",
			"каприс",
			"капрон",
			"капсул",
			"каптаж",
			"каптал",
			"каптёр",
			"капуст",
			"карабк",
			"караим",
			"карась",
			"карате",
			"караул",
			"карбас",
			"карбол",
			"карбон",
			"карбюр",
			"кардан",
			"карель",
			"кариес",
			"каркас",
			"карман",
			"кармаш",
			"кармин",
			"карниз",
			"карпат",
			"карпий",
			"картав",
			"картез",
			"картел",
			"картер",
			"картеч",
			"картин",
			"картон",
			"карточ",
			"картош",
			"картуз",
			"картуш",
			"картёж",
			"карцер",
			"карцин",
			"карьер",
			"каскад",
			"каспий",
			"кассет",
			"кастет",
			"кастор",
			"катакл",
			"катерн",
			"катеху",
			"каторг",
			"каторж",
			"катран",
			"катрен",
			"каупер",
			"каутск",
			"каучук",
			"кафедр",
			"кафель",
			"кафтан",
			"кашель",
			"кашмир",
			"каштан",
			"квазар",
			"квакер",
			"кворум",
			"кегель",
			"кекуок",
			"келарь",
			"кенарь",
			"кенгур",
			"керамз",
			"кержак",
			"кержац",
			"кесарь",
			"кессон",
			"кетмен",
			"кетчуп",
			"кефаль",
			"кибитк",
			"кизиль",
			"киммер",
			"кимоно",
			"киндяк",
			"кинжал",
			"кипрей",
			"кипсей",
			"киргиз",
			"кирилл",
			"кирпич",
			"кисель",
			"китель",
			"кишлак",
			"кишлач",
			"кишмиш",
			"клавир",
			"клавиш",
			"кладий",
			"клапан",
			"клевер",
			"клевет",
			"клевещ",
			"клеенн",
			"клеймл",
			"клекот",
			"клекоч",
			"клеров",
			"клеточ",
			"кливаж",
			"кливер",
			"клиент",
			"климат",
			"клиник",
			"клиниц",
			"клинич",
			"клинок",
			"клирик",
			"клирос",
			"клирош",
			"клитик",
			"клитич",
			"клобук",
			"клобуч",
			"клозет",
			"клокот",
			"клокоч",
			"клубен",
			"клюзив",
			"клюков",
			"ключиц",
			"ключич",
			"клёкот",
			"кнопоч",
			"княжен",
			"коагул",
			"кобель",
			"кобчик",
			"ковбой",
			"коверк",
			"ковриг",
			"ковриж",
			"ковчег",
			"ковчеж",
			"ковыль",
			"когнат",
			"когорт",
			"коготь",
			"кодекс",
			"козетк",
			"козырк",
			"козырь",
			"козюль",
			"козявк",
			"кокард",
			"кокетк",
			"кокиль",
			"коклюш",
			"кокотк",
			"колбас",
			"колгот",
			"колдоб",
			"колебл",
			"коллег",
			"коллеж",
			"коллим",
			"колони",
			"колонк",
			"колонн",
			"колори",
			"колосс",
			"колпак",
			"колпач",
			"колумб",
			"колчак",
			"колчан",
			"коляск",
			"команд",
			"команч",
			"комарь",
			"комбин",
			"комель",
			"коменд",
			"комикс",
			"комисс",
			"коммун",
			"коммут",
			"комнат",
			"компар",
			"компас",
			"компил",
			"компон",
			"компот",
			"конвой",
			"конкур",
			"конопл",
			"консон",
			"консул",
			"контач",
			"контор",
			"контра",
			"контръ",
			"контуж",
			"контуз",
			"контур",
			"конфер",
			"конфет",
			"конфуж",
			"конфуз",
			"концип",
			"коньяк",
			"коньяч",
			"коопер",
			"копееч",
			"копейк",
			"копоть",
			"копчик",
			"копыль",
			"копыть",
			"корабл",
			"коралл",
			"кораль",
			"корвет",
			"кордит",
			"кордон",
			"корейк",
			"корень",
			"корзин",
			"коринк",
			"коринф",
			"коричн",
			"корнет",
			"коробл",
			"король",
			"коронк",
			"корост",
			"коротк",
			"корпор",
			"корпус",
			"коррад",
			"коррел",
			"корриг",
			"коррид",
			"коррод",
			"корруп",
			"корсаж",
			"корсак",
			"корсар",
			"корсет",
			"корсик",
			"кортеж",
			"кортес",
			"кортиз",
			"кортик",
			"корунд",
			"корчаг",
			"корчаж",
			"корчем",
			"коршун",
			"корыст",
			"корюшк",
			"косарь",
			"косатк",
			"космет",
			"космос",
			"костер",
			"костыл",
			"костюм",
			"костёл",
			"костёр",
			"котель",
			"котлас",
			"котлет",
			"котомк",
			"котурн",
			"кочева",
			"кочевь",
			"кочень",
			"кочерг",
			"кочмар",
			"кошель",
			"кошмар",
			"крамол",
			"крапив",
			"кратер",
			"кредит",
			"крекер",
			"кремеш",
			"кремль",
			"креоль",
			"крепощ",
			"кресть",
			"кретин",
			"кретон",
			"кречет",
			"кречёт",
			"кривич",
			"кризис",
			"крикет",
			"кримин",
			"криноч",
			"кринум",
			"критик",
			"кроват",
			"крокет",
			"крокус",
			"кролик",
			"кролич",
			"крольч",
			"кромоч",
			"кропот",
			"крохал",
			"кружал",
			"кружев",
			"кружеч",
			"кружок",
			"крупье",
			"кручин",
			"крушин",
			"крыжов",
			"крылеч",
			"крыльц",
			"крыноч",
			"крюшон",
			"кстати",
			"ксёндз",
			"ктитор",
			"кубарь",
			"кубрик",
			"кубышк",
			"кувалд",
			"кувшин",
			"кувырк",
			"кугуар",
			"кудахт",
			"кудахч",
			"кудель",
			"куколь",
			"кулачь",
			"кулуар",
			"кумека",
			"кунжут",
			"куплет",
			"куполь",
			"курант",
			"кураре",
			"курбет",
			"курган",
			"кургуж",
			"кургуз",
			"курдюк",
			"курдюч",
			"курень",
			"курорт",
			"курсив",
			"куртин",
			"курточ",
			"курчав",
			"курьер",
			"курьёз",
			"кустар",
			"кутафь",
			"кутузк",
			"кухонь",
			"кушетк",
			"кьянти",
			"кюрасо",
			"лабиал",
			"лаванд",
			"лавочь",
			"лавсан",
			"лагерь",
			"ладонь",
			"лазурь",
			"лайнер",
			"лакмус",
			"лакомл",
			"лакриц",
			"лакрич",
			"ламарк",
			"лампас",
			"лангет",
			"ландыш",
			"лансье",
			"лантан",
			"ланцет",
			"лапоть",
			"ларинг",
			"ластик",
			"ластич",
			"латвий",
			"латекс",
			"латунь",
			"латынь",
			"лахудр",
			"лацкан",
			"лебедь",
			"лебёдк",
			"левкас",
			"левкой",
			"легаль",
			"легато",
			"легенд",
			"легион",
			"леденц",
			"леденч",
			"лезвий",
			"лезгин",
			"лейбор",
			"лекаль",
			"ленчик",
			"лепест",
			"лепёшк",
			"лесбий",
			"летарг",
			"лечени",
			"либидо",
			"ливрей",
			"ликвид",
			"ликова",
			"линеар",
			"лисель",
			"литавр",
			"литург",
			"лихтер",
			"лицезр",
			"лобзик",
			"лодырь",
			"ложбин",
			"лозунг",
			"локаут",
			"локоть",
			"ломбер",
			"лонгет",
			"лопарь",
			"лопаст",
			"лоретк",
			"лорнет",
			"лоскут",
			"лосось",
			"лосьон",
			"лотере",
			"лохань",
			"лоцман",
			"лошадь",
			"лояльн",
			"луидор",
			"лукошк",
			"любезн",
			"люцерн",
			"лягушк",
			"магнат",
			"магнет",
			"магнит",
			"магнич",
			"мадонн",
			"мадьяр",
			"мазурк",
			"майдан",
			"макияж",
			"маклак",
			"маклач",
			"маклер",
			"макрел",
			"максим",
			"макушк",
			"малайк",
			"малева",
			"маляри",
			"малёва",
			"мамлюк",
			"мамонт",
			"манатк",
			"мангал",
			"манган",
			"мангль",
			"мандат",
			"маневр",
			"манжет",
			"манихе",
			"манишк",
			"мантий",
			"маньер",
			"манёвр",
			"марабу",
			"маразм",
			"мараль",
			"марант",
			"марель",
			"маринк",
			"марказ",
			"маркет",
			"маркиз",
			"маркит",
			"мармор",
			"марокк",
			"марсал",
			"мартен",
			"мартин",
			"мартын",
			"мартыш",
			"маршал",
			"марьяж",
			"масака",
			"мастак",
			"мастач",
			"мастер",
			"мастик",
			"мастит",
			"мастич",
			"матери",
			"матине",
			"матрас",
			"матрац",
			"матриц",
			"матрич",
			"матрос",
			"маузер",
			"мацони",
			"мачете",
			"маштак",
			"маштач",
			"меандр",
			"мебель",
			"мегрел",
			"медаль",
			"медвед",
			"медвеж",
			"медиан",
			"медиев",
			"медиум",
			"межень",
			"мексик",
			"меланж",
			"меласс",
			"мелиор",
			"мелисс",
			"мелоди",
			"мелочь",
			"мемуар",
			"мендел",
			"мензул",
			"мензур",
			"менинг",
			"мениск",
			"ментик",
			"ментол",
			"ментор",
			"менуэт",
			"меренг",
			"мерсер",
			"мертвл",
			"мерщвл",
			"месмер",
			"металл",
			"метеор",
			"метлах",
			"метрик",
			"метрич",
			"мечеть",
			"мизинч",
			"микадо",
			"микроб",
			"микрон",
			"милдью",
			"миледи",
			"милици",
			"милорд",
			"милост",
			"миндал",
			"минера",
			"минтай",
			"миньон",
			"мирвол",
			"мириад",
			"миссис",
			"митинг",
			"миткал",
			"мичман",
			"мишарь",
			"мишень",
			"мобиль",
			"могиль",
			"модель",
			"модерн",
			"модуль",
			"мозоль",
			"молдав",
			"молдов",
			"молний",
			"молодь",
			"молоть",
			"момент",
			"монарх",
			"монарш",
			"монгол",
			"монист",
			"монстр",
			"монтаж",
			"мораль",
			"морган",
			"морген",
			"мордов",
			"морков",
			"мормон",
			"мормыш",
			"морозь",
			"морось",
			"морошк",
			"мортал",
			"мортир",
			"москит",
			"москов",
			"мостов",
			"мотель",
			"моторн",
			"мотрис",
			"мотыль",
			"моцарт",
			"моцион",
			"мочаль",
			"мрамор",
			"муксун",
			"мулине",
			"мульти",
			"мундир",
			"муравл",
			"муравь",
			"мурова",
			"мускат",
			"мускул",
			"мускус",
			"муслин",
			"муссон",
			"мутовк",
			"мутовч",
			"муторн",
			"муфель",
			"муфтий",
			"мухорт",
			"мухояр",
			"мушкет",
			"мушмул",
			"мытарь",
			"мышьяк",
			"мышьяч",
			"мыщелк",
			"мюзикл",
			"мятлик",
			"наблюд",
			"наблюс",
			"наважд",
			"навест",
			"нагаеч",
			"нагайк",
			"нагель",
			"наград",
			"надежд",
			"надзир",
			"надзор",
			"надлеж",
			"надоед",
			"надоес",
			"надолб",
			"надсад",
			"надсаж",
			"наждак",
			"наждач",
			"наживл",
			"назаль",
			"назида",
			"назнач",
			"найтов",
			"накось",
			"налицо",
			"нансук",
			"наобум",
			"напалм",
			"наперс",
			"направ",
			"напрас",
			"напряг",
			"напряж",
			"нардек",
			"наречь",
			"нарзан",
			"наркоз",
			"наркот",
			"народь",
			"нарочн",
			"наслад",
			"наслег",
			"наслед",
			"настав",
			"настиг",
			"настоя",
			"настра",
			"настро",
			"наступ",
			"насущн",
			"насчёт",
			"наторе",
			"нафтен",
			"нафтол",
			"нахаль",
			"нахожд",
			"началь",
			"начеку",
			"начерт",
			"нашест",
			"небось",
			"небреж",
			"неважн",
			"невежд",
			"невест",
			"неглиж",
			"негоду",
			"негоци",
			"недель",
			"недоум",
			"нежели",
			"нейлон",
			"нектар",
			"нельзя",
			"ненаст",
			"непаль",
			"нептун",
			"нереид",
			"нерест",
			"неужто",
			"нигери",
			"никель",
			"ничтож",
			"новелл",
			"новока",
			"ноготь",
			"ножниц",
			"ножнич",
			"ножовк",
			"нокаут",
			"норавл",
			"норвеж",
			"норовл",
			"нотари",
			"нотаци",
			"ноябрь",
			"нунций",
			"нутаци",
			"ньютон",
			"обиняк",
			"обихаж",
			"обиход",
			"облада",
			"област",
			"облатк",
			"облечь",
			"обличь",
			"обложк",
			"оболоч",
			"оборач",
			"оборон",
			"оборот",
			"обороч",
			"обоюдн",
			"образу",
			"образц",
			"образч",
			"обречь",
			"обширн",
			"обшлаг",
			"обшлаж",
			"объект",
			"объемл",
			"объявл",
			"обыдён",
			"обычай",
			"овражь",
			"оглобл",
			"огород",
			"огорош",
			"огражд",
			"огромн",
			"огурец",
			"огуреч",
			"одеяль",
			"одиозн",
			"одиссе",
			"однако",
			"озадач",
			"озокер",
			"окаянн",
			"оккази",
			"окклюд",
			"окклюз",
			"околач",
			"околес",
			"околиц",
			"околыш",
			"окольн",
			"околёс",
			"окорок",
			"окрест",
			"октябр",
			"ондатр",
			"ономаз",
			"оплеух",
			"оплеуш",
			"оправд",
			"оправл",
			"опрятн",
			"опушеч",
			"оракул",
			"оратор",
			"оргазм",
			"ориент",
			"орочон",
			"орудий",
			"оружей",
			"орхиде",
			"оселок",
			"осетин",
			"осклаб",
			"оскорб",
			"основн",
			"осокор",
			"остров",
			"острог",
			"острож",
			"осцилл",
			"отврат",
			"отвращ",
			"отзыва",
			"отличн",
			"отменн",
			"отнюдь",
			"отороп",
			"отороч",
			"отправ",
			"отребь",
			"отречь",
			"отрица",
			"отшель",
			"отъемл",
			"офицер",
			"офсайд",
			"очеред",
			"очерет",
			"очерёд",
			"павиан",
			"пазанк",
			"пакова",
			"пакост",
			"палатк",
			"палитр",
			"паллад",
			"палоло",
			"палтус",
			"палубл",
			"пальто",
			"пампас",
			"пампуш",
			"память",
			"пананг",
			"панаце",
			"пандан",
			"пандем",
			"пандит",
			"пандус",
			"панель",
			"пантер",
			"панцир",
			"паперт",
			"паприк",
			"папуас",
			"парано",
			"пардон",
			"пареми",
			"парень",
			"паркет",
			"парков",
			"парнас",
			"пароди",
			"пароли",
			"пароль",
			"партер",
			"партий",
			"паскуд",
			"паскуж",
			"паслён",
			"пассаж",
			"пассат",
			"пассер",
			"пассив",
			"пастер",
			"пастил",
			"пастор",
			"патент",
			"патрон",
			"патрул",
			"паузок",
			"паупер",
			"пахлав",
			"паштет",
			"педаль",
			"педант",
			"пейзаж",
			"пейзан",
			"пеклёв",
			"пеленг",
			"пенсне",
			"пепель",
			"передо",
			"переня",
			"переяр",
			"перилл",
			"периль",
			"период",
			"перкал",
			"перкут",
			"перлов",
			"перлон",
			"перрон",
			"персик",
			"персон",
			"перстн",
			"персть",
			"перфор",
			"перцип",
			"пессим",
			"петель",
			"петици",
			"петлюр",
			"петуни",
			"печаль",
			"печатл",
			"печать",
			"печень",
			"пиастр",
			"пигмей",
			"пиджак",
			"пиджач",
			"пиетет",
			"пикник",
			"пикнич",
			"пилика",
			"пилюль",
			"пинетк",
			"пинцет",
			"пинчер",
			"пионер",
			"пипетк",
			"пируэт",
			"пистик",
			"пистон",
			"плакат",
			"планер",
			"планет",
			"планид",
			"планоч",
			"платан",
			"платин",
			"платок",
			"платон",
			"платоч",
			"плафон",
			"плебей",
			"плевел",
			"плезир",
			"плейер",
			"племян",
			"племяш",
			"пленум",
			"пленэр",
			"плесен",
			"плотин",
			"плошеч",
			"площад",
			"плутон",
			"плюгав",
			"плюрал",
			"плёноч",
			"побежд",
			"поверг",
			"поветь",
			"повидл",
			"повтор",
			"погань",
			"погодь",
			"погост",
			"погреб",
			"погрес",
			"погрёб",
			"подагр",
			"подазр",
			"подать",
			"подвал",
			"подвиг",
			"подвиж",
			"подвиз",
			"подвод",
			"подвох",
			"поддан",
			"поджар",
			"подлеж",
			"подлог",
			"подлож",
			"поднач",
			"подним",
			"подоба",
			"подобл",
			"подозр",
			"подошв",
			"подпад",
			"подпас",
			"подряд",
			"подряж",
			"подсоб",
			"подушк",
			"подчас",
			"подчин",
			"подъём",
			"позвол",
			"позици",
			"поклад",
			"покойн",
			"покров",
			"поласк",
			"полици",
			"полоск",
			"полост",
			"полось",
			"полотн",
			"полсть",
			"полтав",
			"полтин",
			"полушк",
			"полчищ",
			"полчок",
			"полынь",
			"помест",
			"помеша",
			"помост",
			"помпон",
			"понтон",
			"пончик",
			"поперх",
			"поплин",
			"поприщ",
			"попуга",
			"поражн",
			"порица",
			"порожн",
			"порошк",
			"портал",
			"портач",
			"портер",
			"портик",
			"порточ",
			"портье",
			"порфир",
			"поршен",
			"порядк",
			"посвят",
			"посвящ",
			"поскон",
			"послед",
			"пособл",
			"посред",
			"постав",
			"постиг",
			"постиж",
			"постул",
			"поступ",
			"постыл",
			"потвор",
			"потенц",
			"потому",
			"потреб",
			"потрох",
			"потрош",
			"похабл",
			"похабн",
			"походя",
			"похоть",
			"початк",
			"почему",
			"почерк",
			"пошлин",
			"правед",
			"правил",
			"правёж",
			"праздн",
			"пралин",
			"прасол",
			"прачеч",
			"пращур",
			"превал",
			"предел",
			"предок",
			"прежде",
			"презир",
			"прелаг",
			"прелат",
			"прелож",
			"прелюд",
			"препар",
			"препон",
			"препят",
			"преста",
			"претор",
			"прибег",
			"прибор",
			"приват",
			"привет",
			"привеч",
			"пригож",
			"приемл",
			"призир",
			"призна",
			"призор",
			"призре",
			"приказ",
			"прикор",
			"прилич",
			"примак",
			"примат",
			"примен",
			"пример",
			"примет",
			"примеч",
			"примул",
			"примус",
			"приним",
			"припер",
			"припёр",
			"природ",
			"приспе",
			"присущ",
			"присяг",
			"присяж",
			"притом",
			"притон",
			"притяз",
			"прихот",
			"прицеп",
			"причащ",
			"причет",
			"причин",
			"причит",
			"причём",
			"приязн",
			"приятн",
			"пробоч",
			"пробст",
			"прован",
			"провер",
			"провок",
			"провор",
			"провоц",
			"продел",
			"проект",
			"проекц",
			"произо",
			"прокаж",
			"проказ",
			"прокур",
			"пролет",
			"пролив",
			"пролог",
			"пролёт",
			"проним",
			"пропад",
			"пропаж",
			"пропал",
			"пропан",
			"пропас",
			"проран",
			"прорех",
			"прореш",
			"пророк",
			"пророч",
			"прорух",
			"просод",
			"протеж",
			"протез",
			"протер",
			"против",
			"протон",
			"профан",
			"профил",
			"проявл",
			"прудон",
			"пружин",
			"прюнел",
			"пряжеч",
			"пряник",
			"прянич",
			"псалом",
			"публик",
			"публиц",
			"публич",
			"пудель",
			"пуделя",
			"пудинг",
			"пузырь",
			"пункту",
			"пункци",
			"пунсон",
			"пунцов",
			"пупавк",
			"пупырь",
			"пурген",
			"пурпур",
			"пускай",
			"пустул",
			"пушкин",
			"пуэбло",
			"пуэрто",
			"пшениц",
			"пшенич",
			"пюпитр",
			"раввин",
			"радиус",
			"разбав",
			"разбой",
			"раздор",
			"разева",
			"раззяв",
			"разлож",
			"разним",
			"разраж",
			"разраз",
			"разреш",
			"разряд",
			"разъём",
			"ракель",
			"ракетк",
			"ракурс",
			"рамоли",
			"ранетк",
			"ранжир",
			"рантье",
			"рапорт",
			"распин",
			"распре",
			"расста",
			"расточ",
			"растяп",
			"рацион",
			"реакци",
			"реальн",
			"реаним",
			"реберь",
			"реванш",
			"ревень",
			"реверс",
			"ревизи",
			"ревмат",
			"регали",
			"регент",
			"регион",
			"реглан",
			"редакт",
			"редакц",
			"реестр",
			"режисс",
			"резерв",
			"рейтар",
			"рейтуз",
			"реквиз",
			"реклам",
			"рекорд",
			"рекрут",
			"ректор",
			"религи",
			"реликв",
			"реликт",
			"рельеф",
			"реляци",
			"ремарк",
			"ремень",
			"ремесл",
			"ремонт",
			"реноме",
			"реплик",
			"реплиц",
			"репорт",
			"реприз",
			"реснит",
			"ресниц",
			"реснич",
			"респир",
			"рессор",
			"ресурс",
			"реторт",
			"ретушь",
			"рефери",
			"реформ",
			"рефрен",
			"реценз",
			"рецепт",
			"рецепц",
			"рецесс",
			"решетч",
			"решётк",
			"решётч",
			"ригель",
			"ритуал",
			"ровень",
			"родник",
			"роднич",
			"розали",
			"розетк",
			"рококо",
			"рокфор",
			"роллер",
			"романс",
			"романт",
			"ромашк",
			"роскош",
			"россий",
			"ротонд",
			"рубато",
			"рубежь",
			"рубрик",
			"рулетк",
			"рундук",
			"рундуч",
			"русалк",
			"рыдван",
			"рыцарь",
			"рюкзак",
			"рюкзач",
			"ряженк",
			"сабель",
			"саванн",
			"саврас",
			"сажень",
			"сайгак",
			"сайгач",
			"сакман",
			"саксон",
			"салазк",
			"сальдо",
			"сальто",
			"салями",
			"самбук",
			"самоед",
			"самшит",
			"сандал",
			"сандхи",
			"санкци",
			"сантал",
			"сантим",
			"сантон",
			"сапажу",
			"сапфир",
			"саранч",
			"сардин",
			"сармат",
			"сатрап",
			"сафари",
			"сафлор",
			"сафьян",
			"сациви",
			"свадеб",
			"сверст",
			"сверхъ",
			"сверчк",
			"свинец",
			"свиреп",
			"свитер",
			"свобод",
			"сволоч",
			"свёкор",
			"себоре",
			"севрюг",
			"севрюж",
			"сегнет",
			"сегрег",
			"седель",
			"сезонь",
			"сейнер",
			"сейчас",
			"секанс",
			"секвой",
			"секрет",
			"секрец",
			"секреч",
			"сектор",
			"секунд",
			"селезн",
			"селект",
			"селитр",
			"сельдь",
			"семаси",
			"сенсит",
			"сенсор",
			"сеньор",
			"сепсис",
			"сервиз",
			"сервил",
			"сервир",
			"сервис",
			"сердеч",
			"сердит",
			"серебр",
			"середи",
			"середь",
			"сермяг",
			"сермяж",
			"серьёз",
			"серёжк",
			"сетова",
			"сеттер",
			"сечься",
			"сигнал",
			"силлаб",
			"силлог",
			"силуэт",
			"символ",
			"симпат",
			"симфон",
			"синапс",
			"синапт",
			"сингал",
			"синдик",
			"синдиц",
			"синдхи",
			"синель",
			"синема",
			"синкоп",
			"синопт",
			"синтез",
			"синтет",
			"синьор",
			"сирень",
			"сиречь",
			"сиропл",
			"систем",
			"систол",
			"ситалл",
			"ситник",
			"ситуат",
			"скальд",
			"скальз",
			"скальп",
			"скамей",
			"скаред",
			"скатёр",
			"сквайр",
			"скверн",
			"сквозь",
			"скворц",
			"скворч",
			"скелет",
			"скерцо",
			"склизк",
			"склянк",
			"скобоч",
			"сколеч",
			"скольж",
			"скольз",
			"скольк",
			"сконто",
			"скорбь",
			"скором",
			"скотин",
			"скромн",
			"скутер",
			"скуфей",
			"славян",
			"слалом",
			"сланец",
			"сласть",
			"слесар",
			"слобод",
			"слобож",
			"словак",
			"словар",
			"словац",
			"словач",
			"словен",
			"словин",
			"случай",
			"слякот",
			"смальт",
			"смерть",
			"сметан",
			"смоков",
			"сморчк",
			"смычок",
			"снаряд",
			"снаряж",
			"снасть",
			"снеток",
			"снеточ",
			"сноров",
			"соболь",
			"событи",
			"соверш",
			"совест",
			"совмещ",
			"совпад",
			"совпас",
			"соврат",
			"совращ",
			"совсем",
			"соглас",
			"соглаш",
			"содерж",
			"содрог",
			"созерц",
			"созида",
			"соколь",
			"солано",
			"солдат",
			"солидн",
			"солипс",
			"солнеч",
			"соловь",
			"солонь",
			"сольдо",
			"сомали",
			"сонетк",
			"сооруд",
			"сооруж",
			"сопран",
			"сопряж",
			"сорбит",
			"сорбци",
			"сорван",
			"сорочк",
			"сортир",
			"сосиск",
			"сослов",
			"состав",
			"состоя",
			"сосуль",
			"социал",
			"сочень",
			"сочета",
			"спасиб",
			"спектр",
			"спекул",
			"спидол",
			"спикер",
			"спиноз",
			"спирал",
			"спирит",
			"спичеч",
			"сплетн",
			"сплошь",
			"спокой",
			"сполох",
			"спонде",
			"спорад",
			"способ",
			"спотык",
			"справл",
			"справн",
			"спринт",
			"спринц",
			"спустя",
			"сретен",
			"стабил",
			"стадий",
			"стакан",
			"сталин",
			"станиц",
			"станич",
			"станов",
			"станок",
			"станоч",
			"станци",
			"статей",
			"статич",
			"статус",
			"статут",
			"стафил",
			"стачеч",
			"стволь",
			"створч",
			"стебел",
			"стекол",
			"степен",
			"стерег",
			"стереж",
			"стерео",
			"стержн",
			"стерил",
			"стернь",
			"стерон",
			"стерёг",
			"стилет",
			"стимул",
			"стирол",
			"стихий",
			"стихир",
			"стодол",
			"столбл",
			"столеч",
			"столиц",
			"столич",
			"столов",
			"стольк",
			"столяр",
			"стопор",
			"стораж",
			"сторно",
			"сторож",
			"сторон",
			"страда",
			"стражд",
			"странн",
			"страст",
			"страти",
			"страус",
			"стрежн",
			"стрель",
			"стремл",
			"стремн",
			"стрепт",
			"стресс",
			"стричь",
			"стройк",
			"стройн",
			"стронц",
			"струга",
			"структ",
			"стручк",
			"студий",
			"ступен",
			"ступиц",
			"ступич",
			"стюард",
			"суббот",
			"сублим",
			"субсид",
			"сугроб",
			"сугубл",
			"сударь",
			"суевер",
			"султан",
			"сумбур",
			"сумерк",
			"сундук",
			"сундуч",
			"суперъ",
			"супонь",
			"супруг",
			"супруж",
			"сургуч",
			"суровь",
			"сурьмл",
			"сусаль",
			"суслик",
			"суслич",
			"суслон",
			"сустав",
			"сутств",
			"суфраж",
			"сухмен",
			"сфинкс",
			"счасть",
			"сюзане",
			"сюртук",
			"сюртуч",
			"табака",
			"табель",
			"таблет",
			"таблит",
			"таблиц",
			"таблич",
			"таверн",
			"таволг",
			"таволж",
			"таджик",
			"таджич",
			"тайфун",
			"таксис",
			"тактич",
			"талант",
			"талдыч",
			"талмуд",
			"тамбур",
			"тамиль",
			"таможн",
			"тампон",
			"тамтам",
			"тандем",
			"тантал",
			"тарант",
			"тарань",
			"тарата",
			"тарахт",
			"тарелк",
			"тархан",
			"тархун",
			"тасова",
			"татами",
			"тачанк",
			"твердо",
			"твердь",
			"твержд",
			"тверёз",
			"твораж",
			"творог",
			"творож",
			"тевтон",
			"тезавр",
			"тейлор",
			"тектон",
			"телекс",
			"телеут",
			"теллур",
			"темляк",
			"темляч",
			"темпер",
			"тендер",
			"теннис",
			"теорем",
			"теорий",
			"тепель",
			"теперь",
			"терапи",
			"теребл",
			"термин",
			"термит",
			"терпен",
			"терпин",
			"терпуг",
			"террас",
			"террор",
			"терьер",
			"тетани",
			"тетрад",
			"тефтел",
			"тигель",
			"тимофе",
			"тимпан",
			"титуль",
			"товарь",
			"токкат",
			"токсик",
			"токсин",
			"толков",
			"толмач",
			"толокн",
			"толочь",
			"толуол",
			"томпак",
			"тоннел",
			"тополь",
			"топорщ",
			"топчан",
			"торакс",
			"торапл",
			"торбас",
			"торгов",
			"тореро",
			"тормаж",
			"тормож",
			"тормоз",
			"тормош",
			"торопл",
			"торпед",
			"торшер",
			"торшон",
			"тотчас",
			"трансл",
			"трансъ",
			"транше",
			"трапез",
			"трапец",
			"трахей",
			"требух",
			"требуш",
			"тревог",
			"тревож",
			"трезвл",
			"тремол",
			"трепак",
			"трепан",
			"трепел",
			"трепет",
			"трепещ",
			"трепых",
			"треска",
			"трибун",
			"триодь",
			"тритон",
			"триумф",
			"трихин",
			"тропик",
			"тропич",
			"трость",
			"тротил",
			"трофей",
			"трофик",
			"трофич",
			"трохей",
			"трувер",
			"трущоб",
			"трюфел",
			"туалет",
			"туарег",
			"тугрик",
			"тужурк",
			"тузлук",
			"тузлуч",
			"тунгус",
			"тунеяд",
			"туннел",
			"турбин",
			"турель",
			"турман",
			"турник",
			"турнир",
			"турнюр",
			"турпан",
			"турсук",
			"тустеп",
			"туфель",
			"тушева",
			"тушёва",
			"тщедуш",
			"тысячь",
			"тюбинг",
			"тюлень",
			"тюлюлю",
			"тюрбан",
			"уведом",
			"уголов",
			"угомон",
			"удмурт",
			"удэгей",
			"уздень",
			"украин",
			"укромн",
			"умлаут",
			"умляут",
			"универ",
			"унисон",
			"унитаз",
			"уничиж",
			"упражн",
			"упрежд",
			"упрямл",
			"ураган",
			"урочищ",
			"уругва",
			"усадеб",
			"усадьб",
			"усердн",
			"уславл",
			"услови",
			"условл",
			"успени",
			"устран",
			"устриц",
			"устрич",
			"уступл",
			"утварь",
			"утверд",
			"ухмыль",
			"участв",
			"участк",
			"участь",
			"учрежд",
			"ущербл",
			"фабиан",
			"фаблио",
			"фабльо",
			"фабрик",
			"фабрич",
			"фабуль",
			"факель",
			"фактор",
			"фактур",
			"фаланг",
			"фалбал",
			"фаллос",
			"фальшь",
			"фамили",
			"фамиль",
			"фантаз",
			"фантом",
			"фанфар",
			"фараон",
			"фаринг",
			"фармак",
			"фармац",
			"фартук",
			"фартуч",
			"фарфор",
			"фасова",
			"фасоль",
			"фаталь",
			"фаэтон",
			"фебель",
			"фейхоа",
			"фекали",
			"фекаль",
			"феллах",
			"фельдъ",
			"феникс",
			"фермат",
			"фермер",
			"ферязь",
			"фестон",
			"фиаско",
			"фигаро",
			"фигляр",
			"фиельд",
			"фиксол",
			"филиал",
			"филипп",
			"филлит",
			"фильтр",
			"филёнк",
			"филёнч",
			"фимиам",
			"финаль",
			"финанс",
			"финики",
			"финифт",
			"фискал",
			"фистул",
			"фитиль",
			"флакон",
			"фланел",
			"фланец",
			"флекси",
			"флигел",
			"флукту",
			"флюгер",
			"флюкту",
			"фонарь",
			"фонтан",
			"форель",
			"форзац",
			"форинт",
			"формат",
			"формул",
			"форточ",
			"фортун",
			"фосген",
			"фосфат",
			"фосфор",
			"фракий",
			"фракци",
			"фрамуг",
			"фрамуж",
			"франко",
			"фрегат",
			"фрекен",
			"фригий",
			"фритюр",
			"фугато",
			"фундук",
			"функци",
			"фуражк",
			"фургон",
			"футбол",
			"футляр",
			"фуфаеч",
			"фьельд",
			"хавбек",
			"халдей",
			"халтур",
			"хамовн",
			"харать",
			"хариус",
			"хахаль",
			"хвость",
			"хевсур",
			"хирург",
			"хламид",
			"хлесть",
			"хлопат",
			"хлопец",
			"хлопок",
			"хлопот",
			"хлопоч",
			"хоккей",
			"холост",
			"хонинг",
			"хоппер",
			"хораль",
			"хорват",
			"хоругв",
			"хорунж",
			"хохлом",
			"хребет",
			"христь",
			"хроник",
			"хрущёв",
			"хрясть",
			"хунхуз",
			"царств",
			"цейлон",
			"целков",
			"целлул",
			"целлюл",
			"целова",
			"цемент",
			"цемянк",
			"цензур",
			"цербер",
			"церебр",
			"церков",
			"цесарь",
			"цивиль",
			"цигарк",
			"цигейк",
			"циклон",
			"циклоп",
			"цимбал",
			"циновк",
			"циркон",
			"циркул",
			"циркум",
			"цирюль",
			"цитрус",
			"цифирь",
			"цицеро",
			"цоколь",
			"цунами",
			"чардаш",
			"чартер",
			"часовн",
			"частик",
			"частух",
			"чахотк",
			"чачван",
			"чеддер",
			"чекрыж",
			"челноч",
			"челомк",
			"челюст",
			"челядь",
			"чембур",
			"чепрак",
			"чепрач",
			"червон",
			"чердак",
			"чердач",
			"черемш",
			"черенк",
			"черешк",
			"черешн",
			"черешч",
			"черкас",
			"черкес",
			"черкеш",
			"чернил",
			"черств",
			"чертог",
			"чертых",
			"ческий",
			"чеснок",
			"чесноч",
			"честер",
			"чехард",
			"чехоль",
			"чигирь",
			"чизель",
			"чифирь",
			"чихвощ",
			"чихирь",
			"чопорн",
			"чурбак",
			"чурбан",
			"чурбач",
			"чучель",
			"чёрств",
			"шаблон",
			"шагрен",
			"шайтан",
			"шаланд",
			"шалбер",
			"шалман",
			"шалфей",
			"шампан",
			"шампур",
			"шандал",
			"шантаж",
			"шантан",
			"шанцев",
			"шапито",
			"шариат",
			"шарман",
			"шарнир",
			"шарошк",
			"шафран",
			"шашлык",
			"шашлыч",
			"шебарш",
			"шевель",
			"шевинг",
			"шевиот",
			"шеврон",
			"шедевр",
			"шелест",
			"шеллак",
			"шеллач",
			"шеломл",
			"шептал",
			"шербет",
			"шеренг",
			"шерсть",
			"шершав",
			"шикарн",
			"шинель",
			"шинков",
			"шиньон",
			"шкалик",
			"шканеч",
			"шкваль",
			"шкипер",
			"шлифов",
			"шлягер",
			"шляхет",
			"шматок",
			"шницел",
			"шомпол",
			"шпагат",
			"шпалер",
			"шпилеч",
			"шпильк",
			"шпинат",
			"шплинт",
			"шредер",
			"штабел",
			"штапел",
			"штатив",
			"штекер",
			"штольн",
			"штопор",
			"штрейк",
			"штукар",
			"штуков",
			"штуцер",
			"шумовк",
			"шурова",
			"щавель",
			"щебень",
			"щеголь",
			"щеколд",
			"щепоть",
			"щиповк",
			"щучина",
			"щёголь",
			"щёлочь",
			"ызвест",
			"ынерци",
			"ынтегр",
			"ыскусн",
			"ыстори",
			"эбонит",
			"эвапор",
			"эвклаз",
			"эврика",
			"эзофаг",
			"эйфори",
			"экарте",
			"экзарх",
			"экзеку",
			"экивок",
			"экипаж",
			"эклект",
			"эконом",
			"экседр",
			"экскав",
			"экспед",
			"экспир",
			"экспон",
			"экстаз",
			"экстат",
			"экстер",
			"экумен",
			"электр",
			"элизий",
			"элимин",
			"эллинг",
			"эллипс",
			"эллипт",
			"эльзас",
			"элювий",
			"элятив",
			"эмблем",
			"эмисси",
			"эмпири",
			"эмульг",
			"эмульс",
			"энанти",
			"энерги",
			"эпигон",
			"эпидем",
			"эпизод",
			"эпитет",
			"эполет",
			"эрозий",
			"эскадр",
			"эскарп",
			"эскимо",
			"эскорт",
			"эскудо",
			"эстамп",
			"эстези",
			"эстомп",
			"эстрад",
			"эталон",
			"этруск",
			"эфемер",
			"эфенди",
			"эффект",
			"эшафот",
			"эшелон",
			"юбилей",
			"ювелир",
			"юкагир",
			"юнкерс",
			"юнкерь",
			"юпитер",
			"юсеньк",
			"юстици",
			"яблонь",
			"ягодиц",
			"ягодич",
			"якобин",
			"январь",
			"янтарь",
			"янычар",
			"ярмарк",
			"ястреб",
			"ятаган",
			"яфетид",
			"ячмень",
			"ящериц",
			"ящерич",
			"ёхонек",
			"ёхоньк",
			"ёшенек",
			"ёшеньк",
			"аббат",
			"абдик",
			"абзац",
			"аборд",
			"аборт",
			"абрек",
			"абрис",
			"абхаз",
			"абцуг",
			"абшид",
			"аваль",
			"аванс",
			"авари",
			"авгур",
			"авдот",
			"авеню",
			"авест",
			"авизо",
			"авось",
			"аврал",
			"аврор",
			"австр",
			"автор",
			"авуар",
			"агами",
			"агент",
			"агнец",
			"агони",
			"аграр",
			"агрег",
			"агуль",
			"адапт",
			"адепт",
			"аджар",
			"аджик",
			"адопт",
			"адрес",
			"адыге",
			"ажгон",
			"ажиот",
			"ажюст",
			"азали",
			"азарт",
			"азбук",
			"азбуч",
			"аймак",
			"аймач",
			"айран",
			"айрол",
			"айсор",
			"акажу",
			"акант",
			"акаци",
			"акрил",
			"аксио",
			"аксон",
			"актив",
			"актин",
			"актёр",
			"акуст",
			"акциз",
			"албан",
			"алевр",
			"алеут",
			"алжир",
			"алиби",
			"алкал",
			"алкил",
			"аллах",
			"аллей",
			"аллел",
			"аллюр",
			"алмаз",
			"алтай",
			"алтар",
			"алтей",
			"алтын",
			"альон",
			"альфа",
			"аляск",
			"амбар",
			"амбре",
			"амвон",
			"аминь",
			"аммон",
			"аморт",
			"ампел",
			"ампер",
			"ампир",
			"ампул",
			"ампут",
			"амфор",
			"амхар",
			"анарх",
			"ангаж",
			"ангар",
			"ангел",
			"ангий",
			"ангин",
			"англи",
			"ангор",
			"андез",
			"андий",
			"анеми",
			"анкер",
			"анкет",
			"аннал",
			"аннон",
			"аннот",
			"аннул",
			"анонс",
			"антен",
			"антик",
			"антич",
			"антон",
			"анфас",
			"анчар",
			"аншеф",
			"апекс",
			"апелл",
			"аплод",
			"апноэ",
			"апорт",
			"апроб",
			"апсид",
			"аптек",
			"аптеч",
			"апчхи",
			"арали",
			"араме",
			"аранж",
			"арбуз",
			"аргал",
			"аргон",
			"аргус",
			"ареал",
			"аренд",
			"ареол",
			"арест",
			"арифм",
			"аркан",
			"армад",
			"армей",
			"армен",
			"армюр",
			"армяк",
			"армяч",
			"аррет",
			"арсен",
			"арсин",
			"артач",
			"артос",
			"архар",
			"архей",
			"архив",
			"арчин",
			"аршин",
			"арьер",
			"аскер",
			"аскет",
			"аскол",
			"аспид",
			"аспир",
			"ассам",
			"ассен",
			"астен",
			"атлас",
			"атлет",
			"атолл",
			"атори",
			"атроф",
			"аттик",
			"аттиц",
			"аттич",
			"афган",
			"африк",
			"аффин",
			"ахвах",
			"ахине",
			"ахтер",
			"ацтек",
			"бабах",
			"бабоч",
			"бабув",
			"бабуш",
			"бавар",
			"багаж",
			"багги",
			"багер",
			"багет",
			"багов",
			"багор",
			"бадан",
			"бадей",
			"базар",
			"базед",
			"базид",
			"базис",
			"базук",
			"бакан",
			"бакен",
			"бакун",
			"балак",
			"балет",
			"балль",
			"балов",
			"балоч",
			"балти",
			"балык",
			"балыч",
			"баляс",
			"банан",
			"баноч",
			"банту",
			"барак",
			"баран",
			"барач",
			"бараш",
			"бареж",
			"барон",
			"бароч",
			"барыг",
			"барыш",
			"басен",
			"басон",
			"басоч",
			"баста",
			"басту",
			"батал",
			"батан",
			"батат",
			"батик",
			"батог",
			"батож",
			"батон",
			"батуд",
			"батун",
			"батут",
			"батыр",
			"бауль",
			"бахил",
			"бацби",
			"башен",
			"бебут",
			"бедёр",
			"бездн",
			"бекар",
			"бекас",
			"бекеш",
			"бекон",
			"белен",
			"белоч",
			"белуг",
			"белуж",
			"белух",
			"белуш",
			"бельн",
			"бельч",
			"беляш",
			"бенди",
			"берег",
			"беред",
			"береж",
			"берез",
			"берем",
			"берет",
			"беркл",
			"берёг",
			"берёз",
			"бесед",
			"бести",
			"бетон",
			"бечев",
			"бечёв",
			"библи",
			"бивак",
			"бивач",
			"бигуд",
			"бидон",
			"бизон",
			"билет",
			"билль",
			"бильд",
			"бирон",
			"бироч",
			"бирюз",
			"бирюк",
			"бирюч",
			"бисер",
			"бистр",
			"битум",
			"битюг",
			"блажь",
			"бланк",
			"бланш",
			"бласт",
			"блева",
			"бледн",
			"блеск",
			"блест",
			"близк",
			"близн",
			"блинд",
			"блинт",
			"блист",
			"блужд",
			"блюст",
			"блёск",
			"блёст",
			"бобби",
			"бобин",
			"бобыл",
			"бобёр",
			"богар",
			"богат",
			"богач",
			"богащ",
			"богем",
			"боинг",
			"бокаж",
			"бокал",
			"болач",
			"болон",
			"болот",
			"болоч",
			"больн",
			"больш",
			"болюс",
			"бомбл",
			"бонмо",
			"боран",
			"борат",
			"бордо",
			"борей",
			"борец",
			"боров",
			"бород",
			"борон",
			"борть",
			"ботан",
			"ботул",
			"бочаг",
			"бочаж",
			"бочеч",
			"бранд",
			"брань",
			"брасс",
			"брахи",
			"бревн",
			"брежь",
			"брезг",
			"брезж",
			"брейк",
			"бренд",
			"бренн",
			"бренч",
			"брень",
			"брешь",
			"бридж",
			"бритт",
			"бричк",
			"бровь",
			"бронз",
			"бронт",
			"бронх",
			"бросч",
			"брошь",
			"брусн",
			"брызг",
			"брызж",
			"брынз",
			"брысь",
			"брюзг",
			"брюзж",
			"брюкв",
			"брёвн",
			"бубен",
			"бубон",
			"бугай",
			"бугор",
			"будар",
			"будоч",
			"будто",
			"будён",
			"бужен",
			"букан",
			"букаш",
			"букет",
			"букин",
			"букле",
			"буков",
			"булав",
			"булан",
			"булат",
			"булоч",
			"булыж",
			"бульк",
			"бумаг",
			"бумаж",
			"бурав",
			"бурак",
			"буран",
			"бурач",
			"бурре",
			"бурун",
			"бурят",
			"бутан",
			"бутил",
			"бутон",
			"бутуз",
			"бутыл",
			"буфер",
			"буфет",
			"бухар",
			"былин",
			"быстр",
			"бычок",
			"бювар",
			"бювет",
			"вабик",
			"вагон",
			"валах",
			"валаш",
			"валет",
			"валуй",
			"валун",
			"валух",
			"вальв",
			"вальс",
			"валют",
			"валёр",
			"ванад",
			"ванил",
			"вапор",
			"варан",
			"варяг",
			"варяж",
			"вастр",
			"ватаг",
			"ватаж",
			"ватер",
			"вдруг",
			"вебер",
			"вегет",
			"ведер",
			"ведьм",
			"ведёр",
			"везде",
			"везир",
			"велик",
			"велич",
			"велюр",
			"веляр",
			"венгр",
			"венед",
			"венер",
			"венет",
			"веник",
			"венич",
			"вепрь",
			"веред",
			"вереж",
			"верещ",
			"верже",
			"вериг",
			"верси",
			"верст",
			"верть",
			"верфь",
			"верхн",
			"весел",
			"весен",
			"вестн",
			"весть",
			"весёл",
			"ветвл",
			"ветвь",
			"ветер",
			"ветош",
			"вечер",
			"вечор",
			"вечёр",
			"взаим",
			"взвод",
			"вздор",
			"взима",
			"вибри",
			"виват",
			"вигон",
			"видео",
			"визит",
			"визор",
			"викар",
			"вилок",
			"вилоч",
			"винил",
			"вираж",
			"вирус",
			"виски",
			"висок",
			"височ",
			"витал",
			"витий",
			"вихор",
			"вихрь",
			"вишен",
			"вкупе",
			"вкусн",
			"власт",
			"влечь",
			"вмест",
			"внедр",
			"внемл",
			"внутр",
			"внятн",
			"вовсе",
			"вовсю",
			"вогул",
			"водоч",
			"воева",
			"вожат",
			"вождь",
			"возде",
			"возле",
			"возоп",
			"войск",
			"вокал",
			"волак",
			"волан",
			"волей",
			"волок",
			"волос",
			"волоч",
			"волош",
			"волхв",
			"волын",
			"вольт",
			"волюм",
			"волют",
			"вопль",
			"вораж",
			"ворач",
			"вораш",
			"вороб",
			"ворож",
			"ворон",
			"ворот",
			"ворох",
			"вороч",
			"ворош",
			"восем",
			"востр",
			"восьм",
			"вотум",
			"вотяк",
			"вотяц",
			"вотяч",
			"воёва",
			"впору",
			"впрок",
			"вражд",
			"врежд",
			"вроде",
			"всегд",
			"вспыл",
			"вспых",
			"вспыш",
			"всюду",
			"вторг",
			"вторж",
			"втулк",
			"втуне",
			"вуаль",
			"вчера",
			"вывер",
			"выгод",
			"выгор",
			"вымог",
			"вынян",
			"выпук",
			"выраж",
			"выраз",
			"выруч",
			"высад",
			"высок",
			"высоч",
			"вычур",
			"выявл",
			"вьюрк",
			"вьюшк",
			"вёдер",
			"вёрст",
			"гаван",
			"гавот",
			"гагар",
			"гагат",
			"газел",
			"газет",
			"газон",
			"гаичк",
			"гален",
			"галер",
			"галет",
			"галеч",
			"галль",
			"галоп",
			"галоч",
			"галош",
			"галун",
			"гальк",
			"галёр",
			"гамак",
			"гамаш",
			"гамби",
			"гапон",
			"гараж",
			"гарем",
			"гарпи",
			"гарус",
			"гастр",
			"гаусс",
			"гаучо",
			"гашиш",
			"гвазд",
			"гвалт",
			"гвине",
			"гвожд",
			"гвозд",
			"гебра",
			"гедон",
			"геенн",
			"гекза",
			"гекса",
			"гелий",
			"генез",
			"генер",
			"генет",
			"гений",
			"гепат",
			"гепта",
			"геран",
			"герой",
			"гетер",
			"гетто",
			"гехса",
			"гиджр",
			"гильз",
			"гинек",
			"гипюр",
			"гисто",
			"гитан",
			"гитар",
			"главл",
			"главн",
			"главь",
			"глаго",
			"гладк",
			"гладь",
			"глазь",
			"гланд",
			"глаук",
			"глейк",
			"глинт",
			"глипт",
			"глисс",
			"глист",
			"глосс",
			"глотт",
			"глоуш",
			"глубж",
			"глубл",
			"глубь",
			"глумл",
			"глупл",
			"глушь",
			"глядь",
			"глянц",
			"глясе",
			"гляци",
			"гневл",
			"гнезд",
			"гнейс",
			"гносе",
			"гност",
			"гнусн",
			"гнусь",
			"гнуша",
			"гнёзд",
			"гобой",
			"говар",
			"говор",
			"говяд",
			"говяж",
			"гогол",
			"гогот",
			"гогоч",
			"гокко",
			"голен",
			"голов",
			"голод",
			"голос",
			"голуб",
			"гольд",
			"гольф",
			"гомер",
			"гомоз",
			"гомон",
			"гоний",
			"гонор",
			"гонош",
			"гопак",
			"гопля",
			"гораж",
			"горал",
			"горбл",
			"горец",
			"город",
			"горож",
			"горох",
			"горош",
			"горст",
			"горьк",
			"горяч",
			"гость",
			"готик",
			"готич",
			"готов",
			"грабл",
			"грабь",
			"граве",
			"грави",
			"граду",
			"гражд",
			"грамм",
			"гранд",
			"грань",
			"грасс",
			"графи",
			"графл",
			"граци",
			"гребл",
			"гребн",
			"гребь",
			"грейд",
			"гренк",
			"гресс",
			"гривн",
			"гриль",
			"грипп",
			"гробл",
			"грозд",
			"грозн",
			"грозь",
			"громк",
			"громл",
			"громч",
			"гросс",
			"грубл",
			"грудь",
			"грузд",
			"грузн",
			"грунт",
			"групп",
			"груст",
			"грязь",
			"гуано",
			"гуашь",
			"гуляш",
			"гуман",
			"гумен",
			"гумми",
			"гумор",
			"гумус",
			"гумён",
			"гуппи",
			"гурий",
			"гурьб",
			"гусар",
			"гусит",
			"гутор",
			"гуцул",
			"дакри",
			"далбл",
			"далек",
			"далеч",
			"далли",
			"дальн",
			"далёк",
			"дамас",
			"данай",
			"дауэс",
			"дафни",
			"дверь",
			"дворц",
			"дворь",
			"дебат",
			"дебел",
			"дебет",
			"дебил",
			"дебит",
			"дебош",
			"дебют",
			"девиз",
			"девон",
			"девят",
			"дедик",
			"дедуц",
			"дежур",
			"декад",
			"декан",
			"декор",
			"делег",
			"дельт",
			"демон",
			"демос",
			"демпф",
			"денди",
			"дендр",
			"денеж",
			"деньг",
			"деньж",
			"деонт",
			"депеш",
			"депон",
			"дерби",
			"дерев",
			"дерез",
			"дерзк",
			"дерив",
			"дерть",
			"дерьм",
			"деряб",
			"дерёв",
			"десик",
			"десть",
			"десят",
			"детал",
			"детон",
			"дефек",
			"дефил",
			"дефис",
			"децим",
			"дешев",
			"дешин",
			"дешёв",
			"джайн",
			"джерс",
			"джинн",
			"джинс",
			"джонк",
			"дзинь",
			"дзюдо",
			"диван",
			"дизел",
			"дикци",
			"дилат",
			"динам",
			"динар",
			"динас",
			"динго",
			"дипло",
			"дирек",
			"дириж",
			"диско",
			"длань",
			"днепр",
			"довер",
			"довле",
			"довод",
			"догад",
			"дождь",
			"дозор",
			"доказ",
			"докук",
			"докуч",
			"долбл",
			"должн",
			"долин",
			"долих",
			"долой",
			"долот",
			"домбр",
			"домен",
			"домин",
			"домог",
			"домёк",
			"донес",
			"доним",
			"донор",
			"донос",
			"дорог",
			"дород",
			"дорож",
			"досад",
			"досоч",
			"доста",
			"досто",
			"досуг",
			"досуж",
			"досье",
			"досяг",
			"дотла",
			"доход",
			"драже",
			"дразн",
			"драхм",
			"древл",
			"древн",
			"дрейф",
			"дрель",
			"дремл",
			"дресв",
			"дресс",
			"дриад",
			"дробл",
			"дробь",
			"дрожж",
			"дрожк",
			"дрожь",
			"дрозд",
			"дросс",
			"друид",
			"дрызг",
			"дрязг",
			"дрянь",
			"дубас",
			"дубин",
			"дубль",
			"дудки",
			"дукат",
			"дулеб",
			"дунай",
			"дупел",
			"духан",
			"дуэль",
			"дуэнь",
			"дщерь",
			"дюжин",
			"дюшес",
			"дятел",
			"дёрен",
			"дёсен",
			"дёшев",
			"евнух",
			"еврей",
			"европ",
			"егерь",
			"египт",
			"едрал",
			"ежели",
			"ендов",
			"енхим",
			"еняск",
			"епанч",
			"ердяй",
			"ересь",
			"ерунд",
			"есаул",
			"еский",
			"ессей",
			"ествл",
			"ет(ся",
			"ехидн",
			"жабер",
			"жавел",
			"жакан",
			"жакет",
			"жакоб",
			"жалей",
			"желез",
			"желоб",
			"желон",
			"желть",
			"желуд",
			"желчь",
			"желёз",
			"жеман",
			"женев",
			"жердь",
			"жереб",
			"жерех",
			"жертв",
			"жерёб",
			"жестк",
			"жесть",
			"жетон",
			"живот",
			"жиздр",
			"жилет",
			"жираф",
			"жмудь",
			"жокей",
			"жонгл",
			"жупан",
			"жупел",
			"жёлоб",
			"жёлчь",
			"жёстк",
			"жёстч",
			"забав",
			"забор",
			"забот",
			"забоч",
			"забуд",
			"завед",
			"завер",
			"завет",
			"завещ",
			"завид",
			"завир",
			"завис",
			"завод",
			"задач",
			"задор",
			"зажор",
			"зазна",
			"зазор",
			"заимк",
			"заиск",
			"заказ",
			"закон",
			"закут",
			"залог",
			"залом",
			"залуч",
			"замби",
			"замет",
			"замеч",
			"замок",
			"замоч",
			"занач",
			"заним",
			"заноз",
			"запад",
			"запас",
			"запир",
			"запор",
			"запущ",
			"запят",
			"зараж",
			"зараз",
			"зарек",
			"зарок",
			"заруч",
			"заряд",
			"заряж",
			"зарёк",
			"засед",
			"засим",
			"заста",
			"застр",
			"засуч",
			"затей",
			"затем",
			"затон",
			"заточ",
			"затхл",
			"зачем",
			"зачин",
			"защит",
			"защищ",
			"заявл",
			"заядл",
			"звани",
			"звезд",
			"звень",
			"зверь",
			"звонч",
			"звёзд",
			"здани",
			"здань",
			"здесь",
			"здрав",
			"зелен",
			"зельц",
			"зелён",
			"земел",
			"зенит",
			"зениц",
			"зернь",
			"зефир",
			"зигот",
			"зипун",
			"знабл",
			"знать",
			"знобл",
			"зозул",
			"золач",
			"золот",
			"золоч",
			"зрачк",
			"зубил",
			"зулус",
			"зумпф",
			"зёрен",
			"иваси",
			"иврит",
			"игнор",
			"иголь",
			"игрек",
			"игрен",
			"игуан",
			"идент",
			"идилл",
			"идиом",
			"идиот",
			"идоль",
			"иегов",
			"иерат",
			"иерей",
			"иждив",
			"избав",
			"избег",
			"избеж",
			"извед",
			"извес",
			"извод",
			"извол",
			"изгой",
			"издат",
			"издев",
			"издёв",
			"изжог",
			"излаг",
			"излож",
			"измен",
			"изнан",
			"изнур",
			"изощр",
			"изумл",
			"изъяв",
			"изъян",
			"изюбр",
			"икари",
			"иллюз",
			"ильон",
			"имбир",
			"имени",
			"имент",
			"имень",
			"имидж",
			"иммун",
			"импер",
			"импон",
			"иначе",
			"ингал",
			"ингиб",
			"ингуш",
			"индау",
			"индей",
			"индиг",
			"индий",
			"индик",
			"индук",
			"индус",
			"индуц",
			"индюк",
			"индюш",
			"инжир",
			"иници",
			"инкуб",
			"интим",
			"интра",
			"интро",
			"инфек",
			"инфиц",
			"инфра",
			"инъек",
			"инъец",
			"ипоме",
			"иприт",
			"ирбис",
			"ирони",
			"ирриг",
			"искаж",
			"исказ",
			"искон",
			"искор",
			"искус",
			"искуш",
			"ислам",
			"испан",
			"испыт",
			"иссим",
			"иссоп",
			"иссык",
			"иссяк",
			"истер",
			"истин",
			"истир",
			"истов",
			"истор",
			"источ",
			"истяз",
			"исход",
			"исчез",
			"италь",
			"итого",
			"ичный",
			"ишиас",
			"ишиат",
			"йемен",
			"кабак",
			"кабал",
			"кабан",
			"кабат",
			"кабац",
			"кабач",
			"кабел",
			"кабин",
			"кавун",
			"кавыч",
			"кагал",
			"каган",
			"кагат",
			"кагор",
			"кадет",
			"кадоч",
			"кадык",
			"казак",
			"казан",
			"казат",
			"казах",
			"казац",
			"казач",
			"казаш",
			"казнь",
			"казус",
			"казён",
			"кайен",
			"каймл",
			"кайно",
			"какао",
			"калан",
			"калач",
			"калек",
			"калеч",
			"калик",
			"калин",
			"калит",
			"калор",
			"калош",
			"калуг",
			"калым",
			"кальк",
			"кальц",
			"каляк",
			"калёв",
			"камби",
			"камед",
			"камен",
			"камер",
			"камеш",
			"камин",
			"камор",
			"камыш",
			"канав",
			"канад",
			"канал",
			"канат",
			"канон",
			"каноэ",
			"канун",
			"канюк",
			"канюл",
			"канюч",
			"капел",
			"капищ",
			"капот",
			"капут",
			"карас",
			"карат",
			"карго",
			"карди",
			"карел",
			"карет",
			"кармл",
			"карст",
			"касат",
			"касид",
			"каско",
			"кастр",
			"катар",
			"катен",
			"катер",
			"катет",
			"катод",
			"катюш",
			"кауст",
			"кацап",
			"качуч",
			"кашне",
			"кашпо",
			"кашуб",
			"квадр",
			"квази",
			"квант",
			"кварк",
			"кварт",
			"кварц",
			"квасц",
			"квиет",
			"квинт",
			"квохт",
			"квохч",
			"кегль",
			"кекур",
			"келар",
			"келей",
			"кельт",
			"кенар",
			"кенаф",
			"кений",
			"керам",
			"керат",
			"керен",
			"кесар",
			"кетон",
			"кефал",
			"кефир",
			"кечуа",
			"кешью",
			"кивер",
			"киевл",
			"кизер",
			"кизил",
			"кизяк",
			"кизяч",
			"килеч",
			"килим",
			"кильк",
			"кинез",
			"кинем",
			"кинет",
			"киоск",
			"кисей",
			"кисел",
			"кисет",
			"кисть",
			"китай",
			"кихот",
			"кишеч",
			"клави",
			"кладь",
			"класс",
			"клева",
			"клейм",
			"клемм",
			"клепл",
			"клепт",
			"клерк",
			"клест",
			"клетк",
			"клетч",
			"клеть",
			"клешн",
			"клизм",
			"клико",
			"клипс",
			"клоак",
			"клоач",
			"клоня",
			"клоун",
			"клохт",
			"клохч",
			"клубн",
			"клукс",
			"клумб",
			"клювь",
			"клюкв",
			"клюшк",
			"клякс",
			"клянч",
			"кляуз",
			"клёва",
			"клёст",
			"клёцк",
			"кнехт",
			"кнопк",
			"кнопл",
			"князь",
			"коала",
			"кобел",
			"кобен",
			"кобур",
			"кобыл",
			"ковар",
			"ковыл",
			"ковыр",
			"ковёр",
			"когда",
			"когот",
			"кодак",
			"кожух",
			"кожуш",
			"козул",
			"козыр",
			"козюл",
			"койне",
			"кокет",
			"кокни",
			"кокон",
			"кокор",
			"кокос",
			"кокош",
			"колач",
			"колаш",
			"колеб",
			"колей",
			"колен",
			"колер",
			"колес",
			"колеч",
			"колеш",
			"колит",
			"колли",
			"колоб",
			"колод",
			"колон",
			"колор",
			"колос",
			"колот",
			"колоч",
			"колош",
			"колуп",
			"колых",
			"колыш",
			"колье",
			"кольт",
			"кольц",
			"кольч",
			"коляд",
			"колёс",
			"комар",
			"комби",
			"комел",
			"комет",
			"комми",
			"комов",
			"комод",
			"комол",
			"комуз",
			"конво",
			"конго",
			"конец",
			"конеч",
			"конто",
			"конур",
			"конус",
			"коньк",
			"коопт",
			"копал",
			"копей",
			"копий",
			"копир",
			"копош",
			"копул",
			"копыл",
			"копыт",
			"копыч",
			"копён",
			"копёр",
			"коран",
			"корач",
			"корде",
			"корей",
			"корен",
			"кореш",
			"кориц",
			"корич",
			"кормл",
			"короб",
			"коров",
			"корол",
			"корон",
			"корот",
			"короч",
			"корпи",
			"корчм",
			"корыт",
			"коряв",
			"коряг",
			"коряж",
			"коряк",
			"коряч",
			"корёж",
			"косач",
			"коста",
			"костр",
			"кость",
			"косул",
			"косяк",
			"косяч",
			"котел",
			"котил",
			"котон",
			"котор",
			"котёл",
			"кочан",
			"кочев",
			"кочен",
			"кочет",
			"кочеч",
			"кочеш",
			"кочур",
			"кочёв",
			"кошар",
			"кошев",
			"кошел",
			"кошер",
			"кошом",
			"кошёв",
			"кошёл",
			"кощей",
			"кощун",
			"кравч",
			"краен",
			"крайн",
			"крамп",
			"крани",
			"крапл",
			"красн",
			"кратк",
			"кратц",
			"кратч",
			"крачк",
			"краюх",
			"краюш",
			"кредо",
			"крейс",
			"кремл",
			"кремн",
			"креол",
			"крепк",
			"крепл",
			"крепч",
			"крепь",
			"креса",
			"кресл",
			"крест",
			"кривл",
			"кривь",
			"криль",
			"кринк",
			"криол",
			"крипт",
			"кровл",
			"кровь",
			"кроль",
			"кроме",
			"кромк",
			"кромс",
			"кропл",
			"кросн",
			"кросс",
			"кротк",
			"кротч",
			"крохо",
			"кроше",
			"кругл",
			"кружк",
			"круиз",
			"крупн",
			"крыль",
			"крынк",
			"кряхт",
			"крёст",
			"кубан",
			"кубар",
			"кубов",
			"кубок",
			"кувыр",
			"кудел",
			"кудес",
			"кузов",
			"кузьк",
			"кузьм",
			"кукиш",
			"кукож",
			"кукол",
			"кулаж",
			"кулак",
			"кулан",
			"кулац",
			"кулач",
			"кулеш",
			"кулиг",
			"кулик",
			"кулис",
			"кулич",
			"кулон",
			"культ",
			"кумач",
			"кумек",
			"кумир",
			"кумул",
			"кумык",
			"кумыс",
			"кумыч",
			"кунак",
			"кунац",
			"кунач",
			"купав",
			"купаж",
			"купат",
			"купел",
			"купец",
			"купеч",
			"купно",
			"купол",
			"купон",
			"купор",
			"купюр",
			"кураг",
			"кураж",
			"курак",
			"курар",
			"курен",
			"курлы",
			"курок",
			"куроч",
			"куртк",
			"кутей",
			"кухар",
			"кухон",
			"кучер",
			"кушак",
			"кушач",
			"кхмер",
			"кювет",
			"лабаз",
			"лабор",
			"лаваш",
			"лавин",
			"лавок",
			"лавоч",
			"лагер",
			"лагун",
			"ладан",
			"ладей",
			"ладон",
			"ладош",
			"лазер",
			"лазор",
			"лазур",
			"лакей",
			"лаком",
			"лакон",
			"лакун",
			"ламин",
			"ламут",
			"ландо",
			"ланит",
			"ланол",
			"лапид",
			"лапот",
			"лапош",
			"ларго",
			"ларёк",
			"ларёч",
			"лассо",
			"латви",
			"латер",
			"латин",
			"латук",
			"латун",
			"латын",
			"латыш",
			"лафет",
			"лафит",
			"лачуг",
			"лачуж",
			"лебед",
			"лебез",
			"лебяж",
			"лебёд",
			"левад",
			"левит",
			"левко",
			"левул",
			"легав",
			"легал",
			"легат",
			"легир",
			"лезви",
			"лейбл",
			"лекал",
			"лемех",
			"лемеш",
			"лемур",
			"ленин",
			"ленок",
			"ленто",
			"лепет",
			"лепеч",
			"лепёт",
			"лесби",
			"лесть",
			"лещин",
			"ливан",
			"ливер",
			"ливре",
			"лизин",
			"ликёр",
			"лилей",
			"лилов",
			"лиман",
			"лимит",
			"лимон",
			"линга",
			"лингв",
			"линей",
			"линий",
			"липси",
			"листь",
			"литер",
			"литов",
			"литот",
			"лицей",
			"личин",
			"лишай",
			"лобби",
			"лобио",
			"лобок",
			"лобыз",
			"логос",
			"лоджи",
			"лодоч",
			"лодыг",
			"лодыж",
			"лодыр",
			"ложеч",
			"локал",
			"локач",
			"локон",
			"локот",
			"локоч",
			"ломов",
			"лопар",
			"лопат",
			"лопач",
			"лопот",
			"лопоч",
			"лопух",
			"лопуш",
			"лосос",
			"лоток",
			"лотос",
			"лоточ",
			"лохан",
			"лошад",
			"лошак",
			"лошач",
			"лощин",
			"лужиц",
			"лужич",
			"лукав",
			"луноч",
			"льгот",
			"люлеч",
			"люльк",
			"люмен",
			"люмин",
			"люпус",
			"люстр",
			"лютер",
			"лютик",
			"лягуш",
			"лядин",
			"лядун",
			"лямбд",
			"лямоч",
			"ляпис",
			"ляссе",
			"лёгоч",
			"магне",
			"магот",
			"мадам",
			"мадер",
			"мажар",
			"мажор",
			"мазер",
			"мазур",
			"мазут",
			"майна",
			"майор",
			"макак",
			"макао",
			"макет",
			"макро",
			"макси",
			"малаг",
			"малай",
			"малак",
			"малах",
			"малий",
			"малин",
			"малле",
			"мальв",
			"мальч",
			"маляр",
			"малёв",
			"мамон",
			"мангл",
			"манго",
			"манеж",
			"манер",
			"манко",
			"манси",
			"манти",
			"манто",
			"манул",
			"маори",
			"марал",
			"маран",
			"марго",
			"марен",
			"марий",
			"марин",
			"маркс",
			"мароч",
			"масаи",
			"масон",
			"масть",
			"матер",
			"матиц",
			"матич",
			"матёр",
			"махер",
			"махин",
			"махор",
			"машин",
			"мебел",
			"мегер",
			"медал",
			"медит",
			"медиц",
			"медуз",
			"межен",
			"мездр",
			"мелан",
			"мелед",
			"мелин",
			"мелис",
			"мелод",
			"мелос",
			"мелоч",
			"мельк",
			"мельч",
			"меньш",
			"мерек",
			"мерещ",
			"мерзк",
			"мерин",
			"мерси",
			"мертв",
			"мерёж",
			"месси",
			"местр",
			"месть",
			"месье",
			"месяц",
			"месяч",
			"метан",
			"метео",
			"метиз",
			"метил",
			"метис",
			"метод",
			"метол",
			"метоп",
			"метро",
			"механ",
			"мечет",
			"мешка",
			"мешок",
			"мешот",
			"мешоч",
			"мещан",
			"мещер",
			"миазм",
			"мизан",
			"мизер",
			"микро",
			"милли",
			"мимоз",
			"миним",
			"миног",
			"минож",
			"минор",
			"минус",
			"минут",
			"мираж",
			"мирон",
			"мисси",
			"мишен",
			"мишул",
			"мишур",
			"мнени",
			"мобил",
			"могил",
			"модел",
			"модем",
			"модул",
			"модус",
			"можно",
			"мозол",
			"мокко",
			"молаж",
			"молач",
			"молвл",
			"молвь",
			"молни",
			"молод",
			"молож",
			"молок",
			"молот",
			"молох",
			"молоч",
			"моляр",
			"монах",
			"монац",
			"монаш",
			"монет",
			"мораж",
			"морал",
			"морач",
			"мордв",
			"морен",
			"морин",
			"морож",
			"мороз",
			"морок",
			"морос",
			"мороч",
			"москв",
			"мосол",
			"мость",
			"мосье",
			"моськ",
			"мотив",
			"мотор",
			"мотто",
			"мотыг",
			"мотыж",
			"мохер",
			"мочаг",
			"мочаж",
			"мочал",
			"мочеч",
			"мошен",
			"мошон",
			"мразь",
			"музей",
			"музиц",
			"музык",
			"мулат",
			"мульт",
			"мульч",
			"муляж",
			"мумиё",
			"мурав",
			"мураш",
			"мурен",
			"мурлы",
			"муров",
			"мусол",
			"мусор",
			"мутон",
			"мутуз",
			"муштр",
			"мыльч",
			"мысел",
			"мысль",
			"мытар",
			"мытищ",
			"мышеч",
			"мэлан",
			"мэрон",
			"мюрид",
			"мякин",
			"мятеж",
			"мёртв",
			"набат",
			"набоб",
			"наваг",
			"наваж",
			"навах",
			"навед",
			"навет",
			"навещ",
			"навиг",
			"навож",
			"навоз",
			"наган",
			"надоб",
			"надёж",
			"нажив",
			"назал",
			"назой",
			"наивн",
			"наити",
			"наказ",
			"налаг",
			"налим",
			"налич",
			"налог",
			"налож",
			"налой",
			"намаз",
			"намек",
			"намер",
			"намёк",
			"нанай",
			"нанду",
			"наним",
			"напад",
			"напас",
			"напыщ",
			"нарек",
			"нареч",
			"народ",
			"нарок",
			"нарош",
			"наруж",
			"наруш",
			"нарыв",
			"наряд",
			"наряж",
			"нарёк",
			"насос",
			"наста",
			"натив",
			"натуж",
			"натур",
			"науст",
			"нахал",
			"нахим",
			"наход",
			"начал",
			"начин",
			"невеж",
			"невод",
			"негод",
			"негус",
			"недел",
			"недуг",
			"недуж",
			"нежен",
			"нежин",
			"нейтр",
			"нелеп",
			"нельм",
			"немец",
			"неньк",
			"непал",
			"нерях",
			"неряш",
			"нетто",
			"нефел",
			"нефть",
			"нешто",
			"нивел",
			"нигил",
			"низри",
			"никел",
			"никот",
			"ницше",
			"нобил",
			"ногай",
			"ногот",
			"ноздр",
			"номер",
			"номин",
			"норов",
			"носок",
			"носоч",
			"нубий",
			"нукер",
			"нукле",
			"нумер",
			"нутри",
			"нутрь",
			"нюанс",
			"оазис",
			"обиль",
			"обита",
			"облав",
			"облад",
			"облак",
			"облач",
			"облек",
			"облеч",
			"облик",
			"облич",
			"обман",
			"обним",
			"обожа",
			"обойм",
			"оболт",
			"обоня",
			"оборк",
			"оборч",
			"обоюд",
			"образ",
			"обрат",
			"обращ",
			"обрек",
			"обрес",
			"обрет",
			"обреч",
			"оброк",
			"оброч",
			"обруч",
			"обряд",
			"обрёк",
			"объяв",
			"объём",
			"обыва",
			"обыкн",
			"обычн",
			"обяза",
			"обёрт",
			"оваль",
			"овать",
			"оваци",
			"овиль",
			"овраг",
			"овраж",
			"огонь",
			"огорч",
			"оград",
			"ограф",
			"огрех",
			"огуль",
			"огурч",
			"одерж",
			"одесс",
			"одеял",
			"одобр",
			"одолж",
			"одонт",
			"одуль",
			"одутл",
			"озерь",
			"ойрот",
			"окази",
			"окаян",
			"океан",
			"оккуп",
			"оклад",
			"оконь",
			"округ",
			"окрыл",
			"оксид",
			"оксол",
			"октав",
			"октан",
			"октро",
			"окунь",
			"оладь",
			"олень",
			"олимп",
			"омлет",
			"омуль",
			"онагр",
			"оникс",
			"опаль",
			"оплот",
			"ополч",
			"оппон",
			"оправ",
			"оприч",
			"оптим",
			"опушк",
			"опять",
			"оранж",
			"орарь",
			"орбит",
			"орган",
			"орден",
			"ордер",
			"ордин",
			"ореол",
			"ориум",
			"оркан",
			"орлец",
			"орнис",
			"орнит",
			"оруди",
			"оружи",
			"осабл",
			"осажд",
			"оседл",
			"осень",
			"осетр",
			"оском",
			"осман",
			"осмос",
			"осмот",
			"основ",
			"особл",
			"особь",
			"осташ",
			"остов",
			"остяк",
			"остяц",
			"остяч",
			"осяза",
			"осётр",
			"отваг",
			"отваж",
			"ответ",
			"отвеч",
			"отдох",
			"отдух",
			"отдуш",
			"отдых",
			"отель",
			"отказ",
			"отлич",
			"отлуч",
			"отлын",
			"отним",
			"отнош",
			"отпор",
			"отрад",
			"отраж",
			"отраз",
			"отрек",
			"отреч",
			"отреш",
			"отрог",
			"отрож",
			"отрок",
			"отроч",
			"отруб",
			"отряд",
			"отряж",
			"отрёк",
			"отсек",
			"отчит",
			"отчёт",
			"отъём",
			"офици",
			"офорт",
			"офсет",
			"охапк",
			"очень",
			"очерк",
			"пагод",
			"падеж",
			"падре",
			"пазух",
			"пазуш",
			"пакет",
			"паков",
			"пакощ",
			"палас",
			"палат",
			"палач",
			"палаш",
			"палев",
			"палех",
			"палеш",
			"палом",
			"палоч",
			"палуб",
			"пальм",
			"пальп",
			"пальт",
			"памят",
			"панам",
			"панел",
			"паник",
			"панич",
			"панно",
			"папай",
			"папах",
			"папаш",
			"папир",
			"папоч",
			"папул",
			"парад",
			"парат",
			"параф",
			"параш",
			"парез",
			"парен",
			"париж",
			"парик",
			"парич",
			"парод",
			"паром",
			"парти",
			"парус",
			"пасек",
			"пасеч",
			"пассе",
			"пасси",
			"пасть",
			"патер",
			"патин",
			"патио",
			"паток",
			"паточ",
			"патри",
			"пафос",
			"пацан",
			"пациф",
			"пачеч",
			"пачул",
			"педал",
			"пекин",
			"пелен",
			"пелик",
			"пелит",
			"пелён",
			"пенал",
			"пенат",
			"пендр",
			"пенни",
			"пеноч",
			"пенси",
			"пента",
			"пеньк",
			"пепел",
			"переж",
			"перек",
			"перец",
			"переч",
			"перил",
			"перси",
			"перст",
			"персь",
			"перун",
			"перёд",
			"песет",
			"песец",
			"песок",
			"песоч",
			"пестр",
			"петер",
			"петит",
			"петух",
			"петуш",
			"печал",
			"печат",
			"печён",
			"пешеч",
			"пещер",
			"пиано",
			"пигус",
			"пижам",
			"пижон",
			"пикап",
			"пикет",
			"пикул",
			"пилав",
			"пилик",
			"пилон",
			"пилот",
			"пилюл",
			"пинак",
			"пипед",
			"пират",
			"пирин",
			"пирит",
			"пирке",
			"пирог",
			"пирож",
			"письм",
			"питек",
			"питер",
			"питом",
			"питон",
			"пичуг",
			"пичуж",
			"плавл",
			"плаги",
			"плазм",
			"плани",
			"планк",
			"плант",
			"планч",
			"пласт",
			"платк",
			"плато",
			"плать",
			"плаун",
			"плахт",
			"плева",
			"плевр",
			"плези",
			"плекс",
			"плеон",
			"плеск",
			"плесн",
			"плеть",
			"плечь",
			"плешь",
			"плеяд",
			"плинт",
			"плисс",
			"пломб",
			"плоск",
			"плотн",
			"плоть",
			"плошк",
			"плута",
			"плюск",
			"плюсн",
			"плюшк",
			"плёва",
			"плёнк",
			"плёнч",
			"плёск",
			"пневм",
			"побед",
			"побор",
			"повад",
			"поваж",
			"повер",
			"повес",
			"повет",
			"повин",
			"повод",
			"поган",
			"погод",
			"погож",
			"погон",
			"подат",
			"поджи",
			"подий",
			"подле",
			"подня",
			"подоб",
			"подог",
			"подож",
			"подол",
			"подпа",
			"подъя",
			"подым",
			"поезд",
			"поезж",
			"пожар",
			"пожив",
			"пожил",
			"поздн",
			"позит",
			"позор",
			"показ",
			"покер",
			"покид",
			"покой",
			"покор",
			"покус",
			"покуш",
			"полат",
			"полез",
			"полем",
			"полен",
			"полеш",
			"полип",
			"полис",
			"полит",
			"полиц",
			"полно",
			"полов",
			"полог",
			"полож",
			"полоз",
			"полок",
			"полон",
			"полос",
			"полох",
			"полоч",
			"полош",
			"полощ",
			"полст",
			"получ",
			"полым",
			"полын",
			"полых",
			"польз",
			"польк",
			"полюс",
			"полян",
			"поляр",
			"поляч",
			"помад",
			"помаж",
			"помеш",
			"помещ",
			"помин",
			"поним",
			"понос",
			"понош",
			"понур",
			"пончо",
			"понёв",
			"поощр",
			"попад",
			"попас",
			"попир",
			"попон",
			"попра",
			"попых",
			"пораж",
			"пораш",
			"порей",
			"порог",
			"пород",
			"порож",
			"порок",
			"порос",
			"порох",
			"пороч",
			"порош",
			"порск",
			"портк",
			"портн",
			"поруч",
			"порци",
			"поршн",
			"поряд",
			"посет",
			"посещ",
			"пособ",
			"посох",
			"посош",
			"постъ",
			"посуд",
			"посяг",
			"поташ",
			"потом",
			"похаб",
			"поход",
			"похот",
			"почеч",
			"почит",
			"почти",
			"почто",
			"почём",
			"поэзи",
			"правд",
			"правл",
			"право",
			"практ",
			"праст",
			"прачк",
			"преда",
			"предъ",
			"преем",
			"презр",
			"преми",
			"прени",
			"прери",
			"пресн",
			"пресс",
			"прест",
			"призм",
			"призр",
			"приим",
			"принт",
			"принц",
			"приня",
			"притч",
			"причт",
			"приют",
			"прият",
			"приём",
			"пробк",
			"пробч",
			"прода",
			"проек",
			"проец",
			"проис",
			"пройм",
			"прокт",
			"пронз",
			"проня",
			"пропа",
			"прорв",
			"прост",
			"прось",
			"прочн",
			"прочь",
			"прояв",
			"проём",
			"прусс",
			"прыск",
			"прытк",
			"прытч",
			"прыть",
			"пряда",
			"прядь",
			"пряжк",
			"пряжь",
			"прямл",
			"прямь",
			"прячь",
			"псалм",
			"псевд",
			"психр",
			"псков",
			"пуант",
			"пугов",
			"пудел",
			"пузыр",
			"пульп",
			"пульс",
			"пульт",
			"пункт",
			"пупыр",
			"пусть",
			"путин",
			"путти",
			"путёв",
			"путём",
			"пучин",
			"пушеч",
			"пушту",
			"пчель",
			"пыжик",
			"пырей",
			"пьекс",
			"пьеро",
			"пясть",
			"пёрст",
			"пёстр",
			"рабат",
			"работ",
			"рабоч",
			"равен",
			"радар",
			"радио",
			"радуг",
			"радуж",
			"радуш",
			"разве",
			"разви",
			"разин",
			"разня",
			"разор",
			"разъя",
			"разым",
			"район",
			"ракет",
			"ракит",
			"раков",
			"ракуш",
			"ралли",
			"ранец",
			"ранчо",
			"рапид",
			"рапир",
			"расей",
			"распр",
			"распя",
			"растр",
			"ратин",
			"ратуш",
			"раунд",
			"рафин",
			"рахис",
			"реакт",
			"реакц",
			"реали",
			"реани",
			"ребус",
			"ревен",
			"ревиз",
			"регат",
			"регби",
			"регот",
			"регул",
			"редеч",
			"редис",
			"редук",
			"редут",
			"редуц",
			"редьк",
			"режим",
			"резед",
			"резин",
			"резон",
			"резус",
			"резюм",
			"рельс",
			"ремен",
			"ремеш",
			"ремиз",
			"ремит",
			"ремён",
			"ренет",
			"репар",
			"репей",
			"репет",
			"ретив",
			"ретин",
			"ретир",
			"ретро",
			"ретуш",
			"рефер",
			"рефул",
			"рецип",
			"рецит",
			"решет",
			"решеч",
			"решёт",
			"ригор",
			"риста",
			"ритор",
			"рицин",
			"робот",
			"ровес",
			"рогож",
			"рогоз",
			"родан",
			"родео",
			"родон",
			"рознь",
			"розов",
			"рокад",
			"рокер",
			"рокот",
			"рокоч",
			"роман",
			"рондо",
			"ропот",
			"росси",
			"ростр",
			"рость",
			"ротац",
			"ротон",
			"ротор",
			"рояль",
			"ртуть",
			"рубаи",
			"рубах",
			"рубаш",
			"рубеж",
			"рубид",
			"рубин",
			"рубищ",
			"рубль",
			"ружей",
			"рулад",
			"рулет",
			"рулон",
			"румын",
			"румян",
			"рупор",
			"руссо",
			"рутен",
			"рутин",
			"ручей",
			"рынок",
			"рыноч",
			"рыцар",
			"рычаг",
			"рычаж",
			"рэкет",
			"рюмоч",
			"рябин",
			"рядиц",
			"ряпух",
			"ряпуш",
			"рёбер",
			"саами",
			"сабан",
			"сабот",
			"сабур",
			"саван",
			"сажен",
			"сажён",
			"сазан",
			"сакур",
			"салаг",
			"салаж",
			"салак",
			"салат",
			"салон",
			"салоп",
			"сальд",
			"салют",
			"саман",
			"самбо",
			"санти",
			"сапог",
			"сапож",
			"сапон",
			"сарай",
			"сатан",
			"сатин",
			"сатир",
			"сатур",
			"сахар",
			"сахиб",
			"свадь",
			"сваеч",
			"свайк",
			"свать",
			"свежь",
			"свекл",
			"свекр",
			"сверб",
			"сверг",
			"сверж",
			"сверз",
			"сверк",
			"сверл",
			"свиде",
			"свинк",
			"свинц",
			"свинч",
			"свинь",
			"свист",
			"свояк",
			"свояч",
			"свёкл",
			"сдобр",
			"сеанс",
			"север",
			"седьм",
			"седёл",
			"сезам",
			"сезон",
			"сейсм",
			"секир",
			"секст",
			"секци",
			"селен",
			"сельд",
			"селёд",
			"семей",
			"семен",
			"семит",
			"сенат",
			"сепар",
			"сердц",
			"сердч",
			"серед",
			"серий",
			"серсо",
			"серьг",
			"серёд",
			"сесси",
			"сестр",
			"сибир",
			"сивер",
			"сивух",
			"сивуч",
			"сивуш",
			"сигар",
			"сидер",
			"сизиф",
			"силик",
			"силиц",
			"силок",
			"силон",
			"силос",
			"сильф",
			"симби",
			"симил",
			"симон",
			"симул",
			"синдх",
			"синел",
			"синод",
			"синус",
			"сирен",
			"сирий",
			"сироп",
			"сирот",
			"ситар",
			"ситец",
			"ситро",
			"сифил",
			"сифон",
			"скабл",
			"скалк",
			"скаль",
			"скаме",
			"скамь",
			"сканд",
			"скапо",
			"скарб",
			"скаут",
			"скачь",
			"скваж",
			"сквер",
			"сквоз",
			"сквор",
			"скенн",
			"скепс",
			"скепт",
			"скерц",
			"скетч",
			"скирд",
			"склад",
			"склеп",
			"склер",
			"склиз",
			"склок",
			"склон",
			"склоч",
			"скобк",
			"скобл",
			"сколь",
			"скопл",
			"скорб",
			"скост",
			"скреб",
			"скрес",
			"скрип",
			"скряг",
			"скряж",
			"скрёб",
			"скудн",
			"скудо",
			"скунс",
			"скуфь",
			"слабл",
			"славл",
			"сладк",
			"сладч",
			"слажд",
			"слайд",
			"сланц",
			"сласт",
			"сленг",
			"слепл",
			"слизь",
			"словь",
			"сложн",
			"слоня",
			"слышь",
			"сматр",
			"смежн",
			"смерд",
			"смерт",
			"смерч",
			"смирн",
			"смокв",
			"смоль",
			"сморк",
			"смотр",
			"смрад",
			"смугл",
			"смушк",
			"смычк",
			"снабд",
			"снабж",
			"снаст",
			"снедь",
			"снежь",
			"снетк",
			"сниск",
			"снова",
			"сныть",
			"собак",
			"собач",
			"собол",
			"собор",
			"совет",
			"совещ",
			"совок",
			"совоч",
			"совпа",
			"содом",
			"сожал",
			"созда",
			"созна",
			"сокол",
			"солаж",
			"солда",
			"солен",
			"солнц",
			"солов",
			"солод",
			"солож",
			"солом",
			"соляр",
			"сомат",
			"сомин",
			"сомне",
			"сомон",
			"сонат",
			"сонет",
			"сообщ",
			"сопел",
			"сопер",
			"сопоч",
			"сопро",
			"сорат",
			"сорбц",
			"сорго",
			"сорог",
			"сорок",
			"сороч",
			"сосед",
			"сосен",
			"состо",
			"сосуд",
			"сосул",
			"сосён",
			"сочет",
			"сочин",
			"спазм",
			"спарж",
			"спарт",
			"спаст",
			"спект",
			"спекц",
			"спеле",
			"сперм",
			"спесь",
			"специ",
			"спирт",
			"спичк",
			"сплач",
			"сплин",
			"сплот",
			"сплоч",
			"сплош",
			"споза",
			"спойт",
			"спока",
			"споко",
			"спорт",
			"спотк",
			"справ",
			"спраш",
			"спрос",
			"спрош",
			"спрут",
			"спряг",
			"спряж",
			"спурт",
			"сравн",
			"срамл",
			"сребр",
			"средн",
			"средь",
			"ставл",
			"стади",
			"сталь",
			"станс",
			"стара",
			"старт",
			"старш",
			"старь",
			"стате",
			"статн",
			"стату",
			"стать",
			"стачк",
			"ствол",
			"стебл",
			"стеги",
			"стекл",
			"стель",
			"стена",
			"стенд",
			"степс",
			"степь",
			"стерв",
			"стере",
			"стерн",
			"стесн",
			"стигм",
			"стило",
			"стиль",
			"стихи",
			"стичь",
			"стогн",
			"стожь",
			"стоик",
			"стоиц",
			"стоич",
			"столб",
			"столп",
			"столь",
			"сторн",
			"страг",
			"страд",
			"страж",
			"страз",
			"стран",
			"страт",
			"страх",
			"страч",
			"страш",
			"стращ",
			"стрек",
			"стрел",
			"стрем",
			"стрех",
			"стриг",
			"стриж",
			"стрик",
			"строг",
			"строж",
			"строи",
			"строй",
			"строк",
			"строп",
			"строф",
			"строч",
			"струг",
			"струж",
			"струй",
			"струн",
			"струп",
			"стряп",
			"студи",
			"стуль",
			"ступл",
			"ступь",
			"стяжа",
			"стяжь",
			"стёкл",
			"суаре",
			"сувой",
			"сугуб",
			"судак",
			"судан",
			"судар",
			"судач",
			"судьб",
			"судён",
			"сукон",
			"сульф",
			"сумер",
			"сумоч",
			"супин",
			"супон",
			"сурик",
			"суров",
			"сурок",
			"суроч",
			"сурьм",
			"сусал",
			"сусек",
			"сусол",
			"сутан",
			"сутен",
			"суток",
			"суточ",
			"сутул",
			"сутяг",
			"сутяж",
			"суфле",
			"сфигм",
			"схизм",
			"счаст",
			"сырок",
			"сырть",
			"сычуг",
			"сычуж",
			"сьерр",
			"сюжет",
			"сясор",
			"сёмуж",
			"табак",
			"табан",
			"табач",
			"табло",
			"табор",
			"табул",
			"табун",
			"тавот",
			"таган",
			"также",
			"такси",
			"такыр",
			"талан",
			"талер",
			"талий",
			"талон",
			"талыш",
			"тальк",
			"тамад",
			"тамил",
			"танго",
			"танец",
			"танин",
			"тапоч",
			"таран",
			"таращ",
			"тариф",
			"тарту",
			"тасов",
			"татар",
			"тахин",
			"тачеч",
			"тварь",
			"тверд",
			"тверж",
			"твист",
			"твиши",
			"твёрд",
			"твёрж",
			"театр",
			"текин",
			"текст",
			"телег",
			"тележ",
			"телий",
			"тембр",
			"тенор",
			"тенёт",
			"теори",
			"тепер",
			"терап",
			"терат",
			"тереб",
			"терем",
			"терза",
			"терий",
			"терпк",
			"терпч",
			"тесть",
			"тесьм",
			"тесём",
			"тетан",
			"тетер",
			"тетив",
			"тетра",
			"тетёр",
			"теург",
			"тибет",
			"тильд",
			"тимол",
			"тимур",
			"типун",
			"тирад",
			"тираж",
			"тиран",
			"титан",
			"титул",
			"тифон",
			"товар",
			"тогда",
			"токай",
			"толок",
			"толст",
			"томас",
			"томат",
			"томош",
			"тондо",
			"тонус",
			"топаз",
			"топол",
			"топор",
			"топот",
			"топыр",
			"торак",
			"торач",
			"торец",
			"ториц",
			"торич",
			"торок",
			"тороп",
			"торос",
			"тороч",
			"торош",
			"тотем",
			"тохар",
			"точеч",
			"точно",
			"травл",
			"травм",
			"травь",
			"тракт",
			"траль",
			"трапп",
			"трасс",
			"тратт",
			"траур",
			"трафл",
			"трахе",
			"трезв",
			"трель",
			"трень",
			"трепь",
			"треск",
			"трест",
			"триад",
			"триас",
			"триер",
			"тризн",
			"трико",
			"триод",
			"тромб",
			"тромп",
			"трост",
			"трохе",
			"троцк",
			"трудн",
			"тружд",
			"трупп",
			"трутн",
			"трынк",
			"трюмо",
			"тряпь",
			"тузем",
			"тукан",
			"тулей",
			"тулов",
			"тулуз",
			"тулуп",
			"туляр",
			"тумак",
			"туман",
			"тумбл",
			"тундр",
			"тунец",
			"туник",
			"тунис",
			"тупей",
			"тупик",
			"турец",
			"туреч",
			"турлы",
			"турне",
			"турок",
			"тутти",
			"тушин",
			"тушёв",
			"тыков",
			"тысяц",
			"тысяч",
			"тьсор",
			"тюбик",
			"тюлен",
			"тюрем",
			"тюрок",
			"тюрьм",
			"тютюн",
			"тюфяк",
			"тюфяч",
			"убежд",
			"убрус",
			"увечь",
			"уволь",
			"угодн",
			"угодь",
			"угожд",
			"уголь",
			"угорь",
			"угост",
			"угрюм",
			"удаль",
			"удель",
			"удобн",
			"удобр",
			"удруч",
			"удэге",
			"ужели",
			"ужель",
			"узбек",
			"узбеч",
			"узурп",
			"уйгур",
			"укроп",
			"уксус",
			"уловк",
			"улюлю",
			"ундин",
			"унион",
			"ункул",
			"унтер",
			"упова",
			"упорн",
			"упред",
			"упреч",
			"упруг",
			"упруж",
			"упрям",
			"упырь",
			"ураль",
			"урарт",
			"урбан",
			"уретр",
			"уровн",
			"усерд",
			"услов",
			"усопш",
			"успен",
			"уссур",
			"устав",
			"уступ",
			"утиль",
			"утопи",
			"утроб",
			"ухарь",
			"ухищр",
			"ухмыл",
			"участ",
			"учред",
			"учтив",
			"ушкуй",
			"ущель",
			"ущерб",
			"уязвл",
			"фабул",
			"фавор",
			"фавус",
			"фагот",
			"фазан",
			"фазис",
			"факел",
			"факир",
			"фалер",
			"фальс",
			"фальц",
			"фальш",
			"фамил",
			"фанат",
			"фанер",
			"фарад",
			"фарси",
			"фасад",
			"фасет",
			"фасов",
			"фасол",
			"фасон",
			"фатал",
			"фатум",
			"фауст",
			"фашин",
			"фаянс",
			"федер",
			"феери",
			"фельд",
			"фемин",
			"фенол",
			"фенон",
			"ферзь",
			"ферул",
			"фетиш",
			"фиалк",
			"фигур",
			"фидер",
			"фикус",
			"фикци",
			"филин",
			"филль",
			"филон",
			"фильм",
			"филёр",
			"финал",
			"финик",
			"финиш",
			"фиоль",
			"фиорд",
			"фитил",
			"фихте",
			"фишеч",
			"фланг",
			"фланк",
			"фланц",
			"флегм",
			"флейт",
			"флейц",
			"флекс",
			"флект",
			"флешь",
			"флирт",
			"флокс",
			"флюид",
			"флюор",
			"фокус",
			"фолио",
			"фольг",
			"фольк",
			"фонар",
			"форез",
			"форел",
			"формл",
			"форте",
			"форум",
			"фофан",
			"фраер",
			"фраки",
			"франк",
			"франт",
			"франц",
			"франч",
			"фрапп",
			"фраст",
			"фратр",
			"фрахт",
			"фрейд",
			"фрейм",
			"френч",
			"фреон",
			"фреск",
			"фриги",
			"фронд",
			"фронт",
			"фрукт",
			"фтизи",
			"фтонг",
			"фугас",
			"фужер",
			"фукси",
			"фуляр",
			"функц",
			"фураж",
			"фурор",
			"фурье",
			"футер",
			"футур",
			"фуфай",
			"фуфыр",
			"фуэте",
			"фьорд",
			"фьють",
			"фюрер",
			"хабар",
			"хаджи",
			"хазар",
			"хакас",
			"халат",
			"халиф",
			"халуп",
			"халяв",
			"хамит",
			"хандр",
			"ханты",
			"ханум",
			"харти",
			"харчо",
			"хасид",
			"хауса",
			"хафиз",
			"хваль",
			"хваст",
			"хвать",
			"хворь",
			"хвост",
			"хедер",
			"херес",
			"хибар",
			"хиджр",
			"хижин",
			"химер",
			"хинди",
			"хинду",
			"хиппи",
			"хитин",
			"хитон",
			"хлажд",
			"хламл",
			"хламь",
			"хлебь",
			"хлест",
			"хлопк",
			"хлопч",
			"хлопь",
			"хлупь",
			"хлыст",
			"хлюст",
			"хлябь",
			"хляск",
			"хляст",
			"хлёст",
			"хмарь",
			"хмель",
			"хмурь",
			"хмырь",
			"хобби",
			"хобот",
			"хозяй",
			"хокке",
			"хокку",
			"холаж",
			"холащ",
			"холер",
			"холмл",
			"холод",
			"холож",
			"холоп",
			"холощ",
			"холст",
			"холуй",
			"холяв",
			"хомут",
			"хомяк",
			"хомяч",
			"хондр",
			"хорал",
			"хоран",
			"хораш",
			"хорей",
			"хором",
			"хорон",
			"хорош",
			"хорьк",
			"хорьч",
			"хорёк",
			"хохол",
			"храбр",
			"хребт",
			"христ",
			"хрумк",
			"хруст",
			"хряск",
			"хряст",
			"хрясь",
			"худож",
			"хурал",
			"хутор",
			"царап",
			"цветь",
			"цевоч",
			"цезар",
			"цезур",
			"целов",
			"целуй",
			"центр",
			"цепен",
			"церкв",
			"цесар",
			"цефал",
			"цибул",
			"цивил",
			"цидул",
			"цикад",
			"цикор",
			"цифир",
			"цукат",
			"цутюн",
			"цыган",
			"чабан",
			"чабер",
			"чабёр",
			"чавка",
			"чавыч",
			"чакан",
			"чапыг",
			"чапыж",
			"часом",
			"частн",
			"часть",
			"чатал",
			"чебак",
			"чебот",
			"чебуч",
			"чекан",
			"чекуш",
			"челяд",
			"чемер",
			"чепан",
			"чепец",
			"чепух",
			"червл",
			"червь",
			"черед",
			"череп",
			"черес",
			"череш",
			"чернь",
			"черёд",
			"честв",
			"честь",
			"чесуч",
			"четыр",
			"чехол",
			"чечен",
			"чечет",
			"чечёт",
			"чешуй",
			"чибис",
			"чилиг",
			"чилий",
			"чилим",
			"чиляг",
			"чинар",
			"чирей",
			"чирик",
			"чирок",
			"чисть",
			"чифир",
			"чохом",
			"чубар",
			"чубук",
			"чубуч",
			"чуваш",
			"чувяк",
			"чувяч",
			"чугун",
			"чукот",
			"чулан",
			"чулоч",
			"чумаз",
			"чумак",
			"чумац",
			"чумиз",
			"чурек",
			"чуроч",
			"чухон",
			"чучел",
			"чёбот",
			"чёлоч",
			"шабаш",
			"шабер",
			"шабли",
			"шабёр",
			"шакал",
			"шалаш",
			"шаман",
			"шамот",
			"шанеж",
			"шанец",
			"шаньг",
			"шапоч",
			"шарад",
			"шарах",
			"шараш",
			"шаров",
			"шассе",
			"шасси",
			"шасть",
			"шатен",
			"шатёр",
			"шахер",
			"шашеч",
			"швабр",
			"шваль",
			"шварк",
			"шварт",
			"шебут",
			"шевел",
			"шевро",
			"шелом",
			"шелох",
			"шелух",
			"шелуш",
			"шельм",
			"шельф",
			"шеньк",
			"шепел",
			"шепот",
			"шепёт",
			"шериф",
			"шерри",
			"шерст",
			"шершн",
			"шесть",
			"шимми",
			"шинел",
			"шинок",
			"широк",
			"широч",
			"шифер",
			"шифон",
			"шишеч",
			"шкаль",
			"шканц",
			"шквал",
			"шквар",
			"школь",
			"шланг",
			"шлейф",
			"шлихт",
			"шляхт",
			"шлёнд",
			"шмель",
			"шмотк",
			"шнапс",
			"шовин",
			"шорох",
			"шоссе",
			"шпатл",
			"шпиль",
			"шпион",
			"шприц",
			"шпрот",
			"шпуль",
			"шпунт",
			"шрифт",
			"штамб",
			"штамм",
			"штамп",
			"штанг",
			"штейн",
			"штиль",
			"штифт",
			"шторм",
			"штраф",
			"штрек",
			"штрих",
			"штунд",
			"штурм",
			"штырь",
			"шугай",
			"шулер",
			"шумер",
			"шурин",
			"шуров",
			"шуруп",
			"шустр",
			"шушер",
			"шушун",
			"шёпот",
			"шёрст",
			"щавел",
			"щебен",
			"щебет",
			"щебеч",
			"щебён",
			"щегол",
			"щекот",
			"щекоч",
			"щелач",
			"щелоч",
			"щепот",
			"щербл",
			"щетин",
			"щипец",
			"щириц",
			"щёкот",
			"щёлок",
			"щёлоч",
			"щёточ",
			"ыголь",
			"ыдень",
			"ыллюз",
			"ындик",
			"ындук",
			"ыскаж",
			"ыстор",
			"эбули",
			"эваку",
			"эвенк",
			"эвфем",
			"эвфон",
			"эгрет",
			"эдици",
			"эйдет",
			"экзем",
			"экзот",
			"эклер",
			"эконо",
			"экран",
			"эксик",
			"эксит",
			"экстр",
			"эктаз",
			"эктоп",
			"эласт",
			"элизи",
			"эллин",
			"элюви",
			"эмаль",
			"эмбол",
			"эмбри",
			"эмигр",
			"эммер",
			"эмоци",
			"эмпир",
			"эмфаз",
			"эмфат",
			"эндем",
			"энерг",
			"энтер",
			"энтом",
			"эпонж",
			"эпопе",
			"эргат",
			"эрзац",
			"эритр",
			"эрози",
			"эрупт",
			"эрупц",
			"эскал",
			"эскиз",
			"эспад",
			"эстет",
			"эстон",
			"этиол",
			"этрус",
			"эфедр",
			"эфиоп",
			"юдоль",
			"юниор",
			"юнкер",
			"юрист",
			"яблок",
			"яблон",
			"яблоч",
			"ягель",
			"ягноб",
			"ягуар",
			"ядрен",
			"ядрён",
			"якобы",
			"якорь",
			"январ",
			"янсен",
			"янтар",
			"яранг",
			"ярлык",
			"ярлыч",
			"ясель",
			"ясень",
			"ясмин",
			"ясочк",
			"яспис",
			"ястык",
			"ястыч",
			"ясырь",
			"ятник",
			"ятрыш",
			"яхонт",
			"ячмен",
			"ячнев",
			"ённый",
			"ёрник",
			"ёрнич",
			"абаз",
			"абак",
			"абон",
			"аван",
			"авар",
			"авиа",
			"авиз",
			"авто",
			"агав",
			"агам",
			"агар",
			"агат",
			"агио",
			"агит",
			"агло",
			"агон",
			"агро",
			"агул",
			"адат",
			"аден",
			"адор",
			"адыг",
			"ажио",
			"ажур",
			"азат",
			"азеф",
			"азий",
			"азов",
			"азот",
			"азям",
			"аист",
			"айда",
			"акар",
			"аква",
			"акме",
			"акро",
			"актр",
			"акул",
			"акут",
			"акуш",
			"акци",
			"акын",
			"алит",
			"алле",
			"алло",
			"алма",
			"алой",
			"алоэ",
			"алта",
			"алыч",
			"альп",
			"альт",
			"альф",
			"алюм",
			"амба",
			"амбр",
			"амид",
			"амил",
			"амин",
			"амми",
			"аммо",
			"ампл",
			"амур",
			"амфи",
			"амёб",
			"анаш",
			"анги",
			"англ",
			"анди",
			"андр",
			"анем",
			"анер",
			"анил",
			"аним",
			"анис",
			"анод",
			"ансь",
			"аорт",
			"апат",
			"апач",
			"апаш",
			"араб",
			"арав",
			"арак",
			"арап",
			"арат",
			"арго",
			"ареа",
			"арен",
			"арео",
			"арил",
			"арме",
			"арми",
			"арон",
			"ароч",
			"артр",
			"арха",
			"архе",
			"арык",
			"арыч",
			"астм",
			"астр",
			"атав",
			"атак",
			"атер",
			"атмо",
			"атом",
			"ауди",
			"ауль",
			"ауто",
			"афер",
			"афин",
			"афиш",
			"афон",
			"афор",
			"ахей",
			"ахти",
			"ацет",
			"ацид",
			"ация",
			"ашуг",
			"аэро",
			"бабб",
			"бабь",
			"бавл",
			"багг",
			"багр",
			"баде",
			"бадр",
			"бадь",
			"байт",
			"байц",
			"балд",
			"балк",
			"балл",
			"балт",
			"баль",
			"банд",
			"банк",
			"бант",
			"банч",
			"бань",
			"бапт",
			"бард",
			"барж",
			"бари",
			"барк",
			"баро",
			"барс",
			"барщ",
			"баск",
			"басм",
			"басн",
			"бати",
			"бать",
			"баул",
			"бахч",
			"башк",
			"башн",
			"баян",
			"бебе",
			"беби",
			"бедн",
			"бедр",
			"безе",
			"безъ",
			"бейк",
			"бейс",
			"белк",
			"бель",
			"бенз",
			"бере",
			"берм",
			"берц",
			"бесн",
			"бета",
			"биде",
			"бикс",
			"бинт",
			"биоз",
			"биос",
			"биот",
			"бирж",
			"бирк",
			"бирм",
			"битл",
			"бишь",
			"благ",
			"блаж",
			"блат",
			"блев",
			"блек",
			"блес",
			"блеф",
			"блещ",
			"ближ",
			"близ",
			"блик",
			"блин",
			"блиц",
			"блок",
			"блох",
			"блоч",
			"блош",
			"блуд",
			"блуз",
			"блюд",
			"блюз",
			"блюм",
			"блюс",
			"блях",
			"бляш",
			"блёк",
			"бобр",
			"бодр",
			"бойк",
			"бойч",
			"бокс",
			"болт",
			"болч",
			"боль",
			"бомб",
			"бомж",
			"бонд",
			"бонз",
			"бонн",
			"борд",
			"борз",
			"борт",
			"борщ",
			"борь",
			"босс",
			"ботв",
			"бочк",
			"бочь",
			"бояр",
			"брав",
			"браг",
			"брад",
			"браж",
			"брак",
			"бран",
			"брас",
			"брат",
			"брах",
			"брач",
			"бред",
			"бреж",
			"брей",
			"брек",
			"брем",
			"брес",
			"брех",
			"бреш",
			"бриг",
			"бриз",
			"бров",
			"брод",
			"брож",
			"бром",
			"брон",
			"брос",
			"брот",
			"брош",
			"бруд",
			"брус",
			"брыз",
			"брык",
			"брыл",
			"брыс",
			"брюк",
			"брют",
			"брюх",
			"брюч",
			"брюш",
			"бряк",
			"бряц",
			"брёх",
			"бубн",
			"бугр",
			"будд",
			"будк",
			"будн",
			"буер",
			"бужд",
			"букв",
			"буки",
			"букл",
			"букс",
			"булк",
			"буль",
			"бунд",
			"бунт",
			"бург",
			"бурд",
			"бурж",
			"бурк",
			"бурл",
			"бурс",
			"бурт",
			"бурч",
			"бурш",
			"бутс",
			"буфф",
			"бухт",
			"быдл",
			"быль",
			"бэрч",
			"бюро",
			"бюст",
			"бязь",
			"бёдр",
			"бёрд",
			"бёрц",
			"важж",
			"важн",
			"вакс",
			"вакх",
			"вакш",
			"валь",
			"валя",
			"ванн",
			"вант",
			"вари",
			"варь",
			"ватт",
			"вафл",
			"вахт",
			"вдов",
			"веди",
			"ведр",
			"ведь",
			"веер",
			"вейн",
			"векш",
			"веле",
			"венд",
			"венч",
			"вепс",
			"верб",
			"верг",
			"верж",
			"верз",
			"верн",
			"верс",
			"верт",
			"верф",
			"верх",
			"верч",
			"верш",
			"верь",
			"весл",
			"весн",
			"вест",
			"весь",
			"ветв",
			"ветл",
			"вето",
			"ветр",
			"ветх",
			"ветш",
			"вешн",
			"вещь",
			"взир",
			"взор",
			"вибр",
			"визг",
			"визж",
			"визи",
			"визу",
			"вилк",
			"вилл",
			"виль",
			"винн",
			"винт",
			"винч",
			"виол",
			"вира",
			"вирш",
			"вист",
			"вита",
			"вити",
			"вихл",
			"вихр",
			"виши",
			"вишн",
			"вишь",
			"вкус",
			"вкуш",
			"влаг",
			"влад",
			"влаж",
			"влас",
			"влач",
			"влек",
			"влеч",
			"влия",
			"влёк",
			"вмен",
			"вник",
			"вним",
			"внук",
			"внуч",
			"внуш",
			"внят",
			"вобл",
			"водк",
			"водн",
			"водь",
			"воен",
			"вожд",
			"вожж",
			"воин",
			"войн",
			"волг",
			"волж",
			"волк",
			"волн",
			"волч",
			"воль",
			"вонз",
			"вонь",
			"вопл",
			"ворд",
			"ворк",
			"ворс",
			"ворч",
			"воск",
			"вотч",
			"вошь",
			"вояж",
			"воёв",
			"впер",
			"впёр",
			"враг",
			"враж",
			"врат",
			"врач",
			"вращ",
			"вред",
			"вреж",
			"врем",
			"вруч",
			"вряд",
			"всад",
			"вста",
			"встр",
			"всуе",
			"всуч",
			"всяк",
			"всяч",
			"втор",
			"вуал",
			"выда",
			"выдр",
			"выем",
			"выжл",
			"выпь",
			"высь",
			"выяв",
			"вьюг",
			"вьюж",
			"вьюк",
			"вьюч",
			"вязч",
			"вязь",
			"вятк",
			"вёдр",
			"вёрт",
			"гааг",
			"гава",
			"гадк",
			"гаер",
			"гаеч",
			"гаит",
			"гайк",
			"гала",
			"галд",
			"галк",
			"галл",
			"гало",
			"галс",
			"галч",
			"гамм",
			"ганд",
			"гапл",
			"гард",
			"гарт",
			"гарь",
			"гать",
			"геен",
			"гейм",
			"гейш",
			"гект",
			"гели",
			"геми",
			"гемм",
			"гени",
			"гену",
			"герб",
			"герм",
			"геро",
			"герц",
			"гетр",
			"гибч",
			"гибь",
			"гигр",
			"гидр",
			"гиен",
			"гиле",
			"гимн",
			"гине",
			"гипн",
			"гипо",
			"гипс",
			"гиро",
			"гирь",
			"глав",
			"глад",
			"глаж",
			"глаз",
			"глас",
			"глат",
			"глаш",
			"глик",
			"глин",
			"глиф",
			"глоб",
			"глод",
			"глот",
			"глох",
			"глоч",
			"глощ",
			"глуб",
			"глум",
			"глуп",
			"глух",
			"глуш",
			"глыб",
			"гляд",
			"глёт",
			"гнев",
			"гнед",
			"гнес",
			"гнет",
			"гнид",
			"гноз",
			"гном",
			"гнот",
			"гнус",
			"гнуш",
			"гнёт",
			"гобо",
			"гове",
			"говл",
			"голо",
			"голь",
			"гоме",
			"гомм",
			"гонг",
			"гони",
			"гоно",
			"гонт",
			"гонь",
			"горб",
			"горд",
			"горе",
			"горк",
			"горл",
			"горн",
			"горч",
			"горш",
			"горь",
			"гост",
			"гофр",
			"граб",
			"грав",
			"град",
			"грай",
			"грам",
			"гран",
			"граф",
			"грач",
			"греб",
			"грез",
			"грей",
			"грек",
			"грем",
			"грен",
			"грес",
			"грех",
			"грец",
			"греч",
			"греш",
			"гриб",
			"грив",
			"грим",
			"гриф",
			"гроб",
			"грог",
			"грож",
			"гроз",
			"гром",
			"грот",
			"грох",
			"грош",
			"груб",
			"груд",
			"груж",
			"груз",
			"грум",
			"груп",
			"груш",
			"грыж",
			"грыз",
			"гряд",
			"гряз",
			"гряс",
			"грёб",
			"грёз",
			"гуан",
			"губл",
			"гугн",
			"гуль",
			"гумм",
			"гумн",
			"гунн",
			"гури",
			"гурт",
			"гуру",
			"гусл",
			"густ",
			"гусь",
			"гюйс",
			"гюрз",
			"гяур",
			"дабр",
			"дабы",
			"даве",
			"давл",
			"давн",
			"давш",
			"дада",
			"даже",
			"дайн",
			"далж",
			"дали",
			"даль",
			"дамб",
			"дамк",
			"дамн",
			"дамп",
			"дана",
			"дант",
			"дань",
			"даос",
			"дари",
			"дарь",
			"двер",
			"двиг",
			"движ",
			"двин",
			"двор",
			"дебр",
			"дегт",
			"дежд",
			"дека",
			"дель",
			"деми",
			"дент",
			"день",
			"депо",
			"дерб",
			"дерг",
			"держ",
			"дерз",
			"дерм",
			"дерн",
			"десн",
			"деся",
			"деци",
			"джаз",
			"джем",
			"джин",
			"джип",
			"джут",
			"дзет",
			"диаз",
			"дивл",
			"диез",
			"диен",
			"диет",
			"дикт",
			"дино",
			"дипл",
			"дипс",
			"диск",
			"диур",
			"дичь",
			"длин",
			"доби",
			"добр",
			"добы",
			"догм",
			"дожд",
			"дойн",
			"долб",
			"долг",
			"долж",
			"доль",
			"домл",
			"домн",
			"домр",
			"донг",
			"донн",
			"донт",
			"донь",
			"доня",
			"доск",
			"дост",
			"дочь",
			"дошл",
			"драг",
			"драж",
			"драй",
			"драм",
			"драп",
			"древ",
			"дрек",
			"дрем",
			"дрен",
			"дроб",
			"дров",
			"дрог",
			"дрож",
			"дрок",
			"дром",
			"дроф",
			"друг",
			"друж",
			"дрыг",
			"дрых",
			"дрюк",
			"дрюч",
			"дряб",
			"дряг",
			"дрян",
			"дрях",
			"дрём",
			"дуал",
			"дубл",
			"дубь",
			"дуль",
			"думь",
			"дунг",
			"дупл",
			"дурн",
			"дурр",
			"дурь",
			"дуст",
			"дуче",
			"душк",
			"душн",
			"душч",
			"душь",
			"дуэл",
			"дуэт",
			"дцат",
			"дыбл",
			"дылд",
			"дымл",
			"дынь",
			"дышл",
			"дьяк",
			"дьяч",
			"дюйм",
			"дядь",
			"дятл",
			"дёгт",
			"дёрг",
			"дёрж",
			"дёрн",
			"еват",
			"евин",
			"евит",
			"егер",
			"егоз",
			"егор",
			"едва",
			"едий",
			"един",
			"ежев",
			"ежов",
			"елей",
			"елий",
			"елоз",
			"емий",
			"енен",
			"енеч",
			"енот",
			"еньк",
			"енёк",
			"ерет",
			"ерий",
			"ерош",
			"ерть",
			"если",
			"есть",
			"етто",
			"ехид",
			"ечок",
			"ешек",
			"жабо",
			"жабр",
			"жадн",
			"жажд",
			"жако",
			"жаль",
			"жанр",
			"жарк",
			"жарч",
			"жбан",
			"жгут",
			"жева",
			"жезл",
			"жела",
			"желе",
			"желт",
			"желч",
			"жерд",
			"жерл",
			"жест",
			"жечь",
			"живл",
			"жидк",
			"жизн",
			"жиль",
			"жиро",
			"жмуд",
			"жмур",
			"жолк",
			"жуан",
			"жужж",
			"жуир",
			"жуль",
			"журч",
			"журь",
			"жутк",
			"жутч",
			"жуть",
			"жучк",
			"жюри",
			"жёва",
			"жёлт",
			"жёлч",
			"жёрд",
			"забв",
			"забо",
			"забы",
			"завр",
			"зада",
			"заде",
			"задь",
			"зажи",
			"заик",
			"заим",
			"займ",
			"зайц",
			"зайч",
			"зако",
			"залп",
			"заль",
			"замк",
			"замш",
			"зане",
			"заня",
			"заст",
			"зате",
			"зато",
			"зача",
			"заяв",
			"заяц",
			"заяч",
			"заём",
			"зван",
			"звен",
			"звер",
			"звол",
			"звон",
			"звук",
			"звуч",
			"звяк",
			"здеш",
			"зебр",
			"зебу",
			"зело",
			"зель",
			"земк",
			"земл",
			"земь",
			"зенк",
			"зерн",
			"зеро",
			"зиго",
			"зижд",
			"зимь",
			"злак",
			"злат",
			"злач",
			"злащ",
			"злот",
			"змей",
			"змий",
			"знай",
			"знак",
			"знам",
			"знат",
			"знах",
			"знач",
			"зноб",
			"зной",
			"зодч",
			"зоид",
			"зоил",
			"золь",
			"зонг",
			"зонд",
			"зонт",
			"зоот",
			"зорк",
			"зорч",
			"зорь",
			"зраз",
			"зуав",
			"зубр",
			"зулу",
			"зурн",
			"зуёк",
			"зыбк",
			"зыбл",
			"зыбь",
			"зюйд",
			"зябл",
			"зябь",
			"зять",
			"зёрн",
			"иатр",
			"ибер",
			"ибис",
			"ивас",
			"иглу",
			"игни",
			"игол",
			"игор",
			"идей",
			"идио",
			"идиш",
			"идол",
			"иеро",
			"ижиц",
			"избы",
			"изда",
			"изол",
			"изум",
			"изъя",
			"изым",
			"изюм",
			"изящ",
			"ийся",
			"икат",
			"икон",
			"икор",
			"икул",
			"илон",
			"илот",
			"ильк",
			"ильм",
			"имам",
			"имен",
			"имит",
			"инак",
			"инач",
			"инда",
			"инде",
			"инди",
			"инду",
			"иней",
			"инок",
			"иноч",
			"интр",
			"инфл",
			"иньк",
			"иппо",
			"ирак",
			"иран",
			"ирид",
			"ирис",
			"ирод",
			"ирон",
			"искр",
			"итак",
			"итар",
			"итин",
			"итог",
			"итож",
			"ифик",
			"ифиц",
			"ифич",
			"ихти",
			"ицин",
			"ичиг",
			"ишак",
			"ишач",
			"ишеч",
			"июль",
			"июнь",
			"кабл",
			"кабр",
			"кабы",
			"кади",
			"кадк",
			"кадм",
			"кадр",
			"кажд",
			"казн",
			"казу",
			"каик",
			"кайл",
			"кайм",
			"кайр",
			"кайф",
			"кака",
			"како",
			"кали",
			"камб",
			"каме",
			"камк",
			"камн",
			"камс",
			"камч",
			"канв",
			"кано",
			"кант",
			"канц",
			"канч",
			"капл",
			"капт",
			"капч",
			"карб",
			"карг",
			"кард",
			"каре",
			"кари",
			"карл",
			"карм",
			"карп",
			"карт",
			"карч",
			"каск",
			"касс",
			"каст",
			"ката",
			"каур",
			"кафе",
			"кафр",
			"кашл",
			"каюк",
			"каюр",
			"кают",
			"каяк",
			"каём",
			"квал",
			"квас",
			"кваш",
			"квит",
			"квот",
			"квёл",
			"кегл",
			"кедр",
			"кейс",
			"кейф",
			"кекс",
			"кель",
			"кени",
			"кено",
			"кепи",
			"керн",
			"керо",
			"керч",
			"кетч",
			"киви",
			"кикс",
			"кило",
			"киль",
			"кимо",
			"кине",
			"кинз",
			"кино",
			"киот",
			"кипр",
			"кипу",
			"кипь",
			"кирз",
			"кирк",
			"кисе",
			"кисл",
			"кист",
			"кись",
			"кита",
			"китч",
			"кичк",
			"кишк",
			"клад",
			"клаж",
			"клан",
			"клас",
			"клаш",
			"клев",
			"клей",
			"клен",
			"клеп",
			"клет",
			"клещ",
			"клик",
			"клин",
			"клип",
			"клир",
			"клич",
			"клиш",
			"клок",
			"клон",
			"клоп",
			"клоч",
			"клуб",
			"клун",
			"клуш",
			"клык",
			"клыч",
			"клюв",
			"клюк",
			"ключ",
			"кляп",
			"кляс",
			"клят",
			"кляч",
			"клёв",
			"клён",
			"клёп",
			"клёш",
			"кнел",
			"книг",
			"книж",
			"кноп",
			"кнут",
			"княг",
			"княж",
			"княз",
			"коал",
			"кобз",
			"кобр",
			"кова",
			"ковр",
			"ковш",
			"когт",
			"коеч",
			"козн",
			"койк",
			"кокк",
			"кокс",
			"колб",
			"колд",
			"коле",
			"коли",
			"колл",
			"коло",
			"колч",
			"коль",
			"коми",
			"комк",
			"комл",
			"комм",
			"комс",
			"конт",
			"конц",
			"конч",
			"конь",
			"копи",
			"копл",
			"копн",
			"копр",
			"копт",
			"копч",
			"копь",
			"корд",
			"коре",
			"корж",
			"корм",
			"корн",
			"корп",
			"корт",
			"корч",
			"корь",
			"косм",
			"косн",
			"кост",
			"кось",
			"котл",
			"кофе",
			"кофр",
			"кофт",
			"кочк",
			"кошм",
			"кошт",
			"краб",
			"краг",
			"крад",
			"краж",
			"край",
			"крал",
			"кран",
			"крап",
			"крас",
			"крат",
			"крах",
			"краш",
			"кращ",
			"крек",
			"крем",
			"крен",
			"креп",
			"крещ",
			"крив",
			"криг",
			"криз",
			"крик",
			"крин",
			"крио",
			"крит",
			"крич",
			"кров",
			"крой",
			"крок",
			"крол",
			"крон",
			"кроп",
			"крот",
			"крох",
			"крош",
			"крощ",
			"круг",
			"круж",
			"круп",
			"крут",
			"круч",
			"круш",
			"крыж",
			"крыл",
			"крым",
			"крыс",
			"крюк",
			"крюч",
			"кряж",
			"ксер",
			"ксил",
			"кубк",
			"куда",
			"кудл",
			"кудр",
			"куды",
			"кузн",
			"кукл",
			"кукс",
			"кули",
			"куль",
			"купе",
			"купл",
			"купц",
			"купч",
			"курд",
			"курк",
			"курс",
			"куск",
			"куст",
			"кутн",
			"кухн",
			"кьят",
			"кюре",
			"кюри",
			"лаби",
			"лавк",
			"лавл",
			"лавр",
			"лавч",
			"ладн",
			"ладь",
			"лайб",
			"лайд",
			"лайк",
			"лака",
			"лакт",
			"ламп",
			"ланд",
			"ланк",
			"лань",
			"лаос",
			"лаот",
			"лапл",
			"лапт",
			"лапш",
			"ларг",
			"ларь",
			"ласк",
			"ласт",
			"латр",
			"лафа",
			"легк",
			"легч",
			"леди",
			"ледь",
			"леер",
			"лежь",
			"лейк",
			"лейт",
			"лейц",
			"лекс",
			"лект",
			"лекц",
			"леле",
			"лемм",
			"ленд",
			"лент",
			"ленч",
			"лень",
			"лепл",
			"лепр",
			"лепт",
			"лесс",
			"лест",
			"лесь",
			"леть",
			"лечо",
			"лечь",
			"лиан",
			"либо",
			"лива",
			"ливл",
			"ливр",
			"лили",
			"лимн",
			"лимф",
			"лине",
			"линз",
			"лини",
			"лино",
			"линч",
			"линь",
			"линя",
			"лист",
			"литв",
			"литр",
			"лифт",
			"лице",
			"лиша",
			"лишн",
			"лишь",
			"лобб",
			"лобз",
			"лоби",
			"лобк",
			"лобь",
			"ловл",
			"ловч",
			"лодк",
			"лодч",
			"ложк",
			"ложь",
			"локо",
			"локт",
			"ломл",
			"лонж",
			"лорд",
			"лорн",
			"лоск",
			"лосн",
			"лось",
			"лотк",
			"лото",
			"лохм",
			"лоци",
			"лузг",
			"лунк",
			"лунь",
			"лупл",
			"лупц",
			"лучш",
			"льст",
			"любл",
			"людь",
			"люкс",
			"люли",
			"лютн",
			"люфт",
			"люэс",
			"люэт",
			"ляжк",
			"лязг",
			"ляль",
			"лямз",
			"лямк",
			"ляци",
			"лёгк",
			"лёсс",
			"мавр",
			"маги",
			"магм",
			"магн",
			"маго",
			"мазь",
			"маис",
			"майк",
			"майн",
			"майя",
			"маки",
			"мала",
			"мали",
			"малк",
			"малч",
			"маль",
			"манг",
			"мани",
			"манк",
			"манн",
			"мант",
			"ману",
			"мань",
			"марг",
			"мари",
			"марк",
			"марл",
			"марс",
			"март",
			"марш",
			"марь",
			"маск",
			"масл",
			"масс",
			"маст",
			"матч",
			"мать",
			"мафи",
			"махн",
			"махр",
			"мачт",
			"машь",
			"маяк",
			"маяч",
			"мбри",
			"мебл",
			"мега",
			"меди",
			"медл",
			"медь",
			"межд",
			"межъ",
			"мезг",
			"мелк",
			"мело",
			"мель",
			"мень",
			"меню",
			"мере",
			"мерз",
			"мерк",
			"мерн",
			"мерц",
			"месс",
			"мест",
			"месь",
			"мета",
			"мете",
			"метк",
			"метр",
			"метч",
			"мечт",
			"меша",
			"мешк",
			"мигр",
			"миди",
			"миел",
			"микр",
			"микс",
			"миль",
			"мимо",
			"мине",
			"мини",
			"мирз",
			"мирр",
			"мирт",
			"миск",
			"мисс",
			"мист",
			"митр",
			"млад",
			"млек",
			"млеч",
			"мнем",
			"мног",
			"множ",
			"моза",
			"мозг",
			"мозж",
			"мойв",
			"мокр",
			"мокш",
			"молв",
			"молк",
			"молн",
			"молч",
			"моль",
			"мони",
			"моно",
			"монт",
			"мопс",
			"морг",
			"морд",
			"морж",
			"морз",
			"морс",
			"морф",
			"морщ",
			"морь",
			"мосл",
			"мост",
			"мото",
			"мохн",
			"мочк",
			"мочь",
			"мошк",
			"мошн",
			"мощь",
			"мрак",
			"мрач",
			"мсье",
			"муар",
			"мудр",
			"музе",
			"мулл",
			"муми",
			"мурз",
			"мурл",
			"мурч",
			"мусл",
			"мусс",
			"мута",
			"муть",
			"муфт",
			"мушк",
			"мызг",
			"мыль",
			"мымр",
			"мысл",
			"мыть",
			"мышк",
			"мышл",
			"мышц",
			"мышь",
			"мэтр",
			"мягк",
			"мягч",
			"мямл",
			"мёрз",
			"навт",
			"нагл",
			"наде",
			"надъ",
			"наиб",
			"наив",
			"найд",
			"найм",
			"нана",
			"нанк",
			"наня",
			"напа",
			"нарв",
			"нард",
			"нарк",
			"нарт",
			"наст",
			"нато",
			"натр",
			"наущ",
			"нафт",
			"наци",
			"нача",
			"наяд",
			"наян",
			"наём",
			"невр",
			"негр",
			"недр",
			"нежн",
			"нейр",
			"некр",
			"неон",
			"нерв",
			"нерк",
			"нерп",
			"нефр",
			"нефт",
			"нивх",
			"низк",
			"низь",
			"нимб",
			"нимф",
			"ниоб",
			"нитр",
			"нить",
			"ницц",
			"ничь",
			"нный",
			"новл",
			"новь",
			"нога",
			"ногт",
			"ножь",
			"ноль",
			"номи",
			"ноне",
			"норд",
			"норк",
			"норм",
			"носи",
			"носк",
			"нось",
			"нота",
			"ночь",
			"ношп",
			"нощь",
			"нрав",
			"нуби",
			"нужд",
			"нужн",
			"нукл",
			"нулл",
			"нуль",
			"нутр",
			"ныне",
			"нянч",
			"нянь",
			"обая",
			"обед",
			"обес",
			"обет",
			"обещ",
			"обид",
			"обиж",
			"обил",
			"обма",
			"обня",
			"обод",
			"обоз",
			"обуз",
			"обух",
			"обуш",
			"обуя",
			"объя",
			"обык",
			"обыч",
			"обяз",
			"обёр",
			"ован",
			"овен",
			"овеч",
			"овик",
			"овил",
			"овод",
			"овоч",
			"овощ",
			"овул",
			"овый",
			"овёс",
			"огнь",
			"огон",
			"огул",
			"одес",
			"одий",
			"один",
			"одно",
			"одол",
			"одор",
			"одул",
			"озар",
			"озер",
			"озир",
			"озон",
			"озор",
			"озёр",
			"ойль",
			"оказ",
			"океа",
			"окей",
			"окль",
			"окон",
			"окоп",
			"окош",
			"окта",
			"окул",
			"окун",
			"олад",
			"олен",
			"олеш",
			"олив",
			"олиф",
			"олов",
			"олух",
			"ольх",
			"ольш",
			"омар",
			"омбр",
			"омег",
			"омул",
			"омут",
			"онан",
			"онеч",
			"оним",
			"оноч",
			"онто",
			"онуч",
			"опак",
			"опал",
			"опар",
			"опас",
			"опаш",
			"опек",
			"опер",
			"опеч",
			"опеш",
			"опий",
			"оплы",
			"опля",
			"опок",
			"опор",
			"опус",
			"опущ",
			"опыт",
			"орав",
			"орам",
			"орги",
			"орех",
			"ореш",
			"орок",
			"орос",
			"ороч",
			"орош",
			"орто",
			"оруд",
			"оруж",
			"орфо",
			"орёл",
			"осад",
			"осан",
			"осен",
			"осин",
			"особ",
			"осок",
			"осот",
			"оста",
			"осте",
			"осто",
			"остр",
			"осьм",
			"осёл",
			"отав",
			"отар",
			"отек",
			"отец",
			"отеч",
			"отлы",
			"отня",
			"оточ",
			"отча",
			"отъя",
			"оуэн",
			"офис",
			"офит",
			"охот",
			"охти",
			"очаг",
			"очаж",
			"очеч",
			"очут",
			"очух",
			"ошиб",
			"ощут",
			"ощущ",
			"оять",
			"пади",
			"падь",
			"пазд",
			"пайк",
			"пакл",
			"пакт",
			"пале",
			"палз",
			"пали",
			"палк",
			"паль",
			"памп",
			"панд",
			"пани",
			"панк",
			"пант",
			"панъ",
			"папк",
			"пара",
			"пари",
			"парк",
			"парн",
			"парт",
			"парф",
			"парх",
			"парч",
			"парш",
			"пасс",
			"паст",
			"пасх",
			"патл",
			"пато",
			"патр",
			"пауз",
			"паук",
			"паут",
			"пауч",
			"пахт",
			"паче",
			"пачк",
			"паша",
			"пашн",
			"пашь",
			"паюс",
			"паяс",
			"паяц",
			"пеан",
			"пезн",
			"пезо",
			"пект",
			"пель",
			"пелё",
			"пемз",
			"пенз",
			"пенк",
			"пенс",
			"пень",
			"пеня",
			"пеон",
			"пепл",
			"пепс",
			"перв",
			"перг",
			"пери",
			"перл",
			"перм",
			"перс",
			"перт",
			"перу",
			"перф",
			"перх",
			"перц",
			"перч",
			"перш",
			"перь",
			"песк",
			"песо",
			"пест",
			"песц",
			"песч",
			"песь",
			"петл",
			"петр",
			"печь",
			"пешк",
			"пешн",
			"пиал",
			"пиан",
			"пигм",
			"пижм",
			"пике",
			"пикр",
			"пикт",
			"пиль",
			"пинт",
			"пион",
			"пирс",
			"писк",
			"пись",
			"пита",
			"пити",
			"пихт",
			"пицц",
			"пичк",
			"пияв",
			"плав",
			"плаз",
			"плак",
			"плам",
			"план",
			"плас",
			"плат",
			"плах",
			"плац",
			"плач",
			"плаш",
			"плащ",
			"плев",
			"плед",
			"плем",
			"плен",
			"плес",
			"плет",
			"плеч",
			"плеш",
			"плещ",
			"плие",
			"плик",
			"плис",
			"плит",
			"плов",
			"плод",
			"плож",
			"плой",
			"плот",
			"плох",
			"плоч",
			"плош",
			"площ",
			"плуг",
			"плуж",
			"плут",
			"плюс",
			"плюх",
			"плюш",
			"плющ",
			"пляж",
			"пляс",
			"пляш",
			"плёв",
			"плёс",
			"плёт",
			"поди",
			"подл",
			"подъ",
			"позд",
			"позж",
			"пози",
			"поим",
			"пойм",
			"пока",
			"поко",
			"полб",
			"полз",
			"поли",
			"полк",
			"полн",
			"поло",
			"полч",
			"поль",
			"помн",
			"помп",
			"помя",
			"пони",
			"понт",
			"поня",
			"попа",
			"порн",
			"порт",
			"порх",
			"порч",
			"почв",
			"почи",
			"почк",
			"почт",
			"пошл",
			"поэм",
			"поэт",
			"пояс",
			"поём",
			"прав",
			"праж",
			"праз",
			"прах",
			"праш",
			"пращ",
			"преж",
			"прек",
			"прем",
			"прет",
			"прещ",
			"приз",
			"прим",
			"прия",
			"проб",
			"прод",
			"проз",
			"прок",
			"пром",
			"проп",
			"прос",
			"прот",
			"проф",
			"проч",
			"прош",
			"прощ",
			"пруд",
			"пруж",
			"прус",
			"прут",
			"прыг",
			"прыж",
			"прыс",
			"прыщ",
			"пряг",
			"пряд",
			"пряж",
			"прям",
			"прян",
			"пряс",
			"прят",
			"пряч",
			"прёк",
			"псих",
			"птер",
			"птих",
			"птоз",
			"пудр",
			"пуль",
			"пунш",
			"пупс",
			"пург",
			"пурж",
			"пуск",
			"пуст",
			"путл",
			"путн",
			"путч",
			"путь",
			"пушк",
			"пушь",
			"пчел",
			"пчёл",
			"пшен",
			"пшик",
			"пшют",
			"пшён",
			"пыль",
			"пыха",
			"пыхт",
			"пышн",
			"пьез",
			"пьес",
			"пюре",
			"пядь",
			"пяль",
			"пяст",
			"пятн",
			"пять",
			"равн",
			"рагу",
			"раде",
			"радж",
			"ради",
			"разн",
			"разъ",
			"раин",
			"ракл",
			"ракш",
			"ралл",
			"рамл",
			"рамп",
			"ранг",
			"рант",
			"рань",
			"рапс",
			"раст",
			"рать",
			"раух",
			"рафи",
			"раёк",
			"раёш",
			"реаг",
			"реак",
			"реал",
			"ребр",
			"ревм",
			"ревн",
			"ревю",
			"регб",
			"редк",
			"редч",
			"рееч",
			"резв",
			"резк",
			"резч",
			"резь",
			"рейд",
			"рейк",
			"рейс",
			"рейх",
			"рект",
			"реле",
			"ремн",
			"рент",
			"репе",
			"репс",
			"речк",
			"речь",
			"решк",
			"риал",
			"рикш",
			"римл",
			"ринг",
			"риск",
			"ритм",
			"рифл",
			"рифм",
			"рихт",
			"робк",
			"робо",
			"робч",
			"рова",
			"ровн",
			"родн",
			"родь",
			"рожд",
			"рожь",
			"розг",
			"розн",
			"розь",
			"роль",
			"ромб",
			"ропт",
			"ропщ",
			"росс",
			"рост",
			"рота",
			"роял",
			"рраг",
			"ртут",
			"рубк",
			"рубл",
			"рубь",
			"ружь",
			"руин",
			"руль",
			"румб",
			"рупи",
			"русл",
			"руст",
			"руте",
			"руче",
			"ручк",
			"ручь",
			"рыбл",
			"рыбь",
			"рыль",
			"рыск",
			"рысь",
			"рыхл",
			"рьян",
			"рюмк",
			"рябл",
			"рябь",
			"рявк",
			"рядн",
			"рядь",
			"ряск",
			"рёбр",
			"саам",
			"сабл",
			"сабо",
			"савк",
			"саго",
			"садн",
			"саеч",
			"сажд",
			"сайг",
			"сайд",
			"сайк",
			"сайр",
			"сакл",
			"сакс",
			"саль",
			"самб",
			"саму",
			"сапр",
			"сара",
			"сарж",
			"сари",
			"сарк",
			"саун",
			"сачк",
			"саше",
			"сбор",
			"сбру",
			"свад",
			"свай",
			"сван",
			"свар",
			"сват",
			"свах",
			"сваш",
			"свеж",
			"свер",
			"свес",
			"свет",
			"свеч",
			"свещ",
			"свин",
			"свит",
			"свищ",
			"свой",
			"свор",
			"свят",
			"свяч",
			"свящ",
			"сдоб",
			"себе",
			"седл",
			"седм",
			"седь",
			"сейм",
			"сейф",
			"сейш",
			"секс",
			"сект",
			"сель",
			"семе",
			"семь",
			"сенн",
			"сенс",
			"сень",
			"септ",
			"серб",
			"серв",
			"серд",
			"серж",
			"сери",
			"серн",
			"серп",
			"серч",
			"сест",
			"сеть",
			"сечь",
			"сигм",
			"сидр",
			"сиен",
			"сика",
			"сикх",
			"сили",
			"силк",
			"силь",
			"синь",
			"сион",
			"сири",
			"сись",
			"ситц",
			"ситч",
			"скаж",
			"сказ",
			"скай",
			"скак",
			"скал",
			"скан",
			"скар",
			"скат",
			"скаф",
			"скач",
			"ский",
			"скит",
			"скиф",
			"скиц",
			"скоб",
			"скок",
			"скоп",
			"скор",
			"скот",
			"скоч",
			"скры",
			"скуд",
			"скук",
			"скул",
			"скуп",
			"скуч",
			"слаб",
			"слав",
			"слад",
			"слащ",
			"след",
			"слеж",
			"слез",
			"слей",
			"слеп",
			"слив",
			"слиз",
			"слов",
			"слог",
			"слож",
			"слой",
			"слон",
			"слуг",
			"служ",
			"слух",
			"случ",
			"слуш",
			"слых",
			"слыш",
			"слюд",
			"слюн",
			"сляб",
			"слёз",
			"смак",
			"смал",
			"смач",
			"смеж",
			"смек",
			"смел",
			"смет",
			"смир",
			"смог",
			"смол",
			"смур",
			"смят",
			"смёт",
			"снащ",
			"снег",
			"снед",
			"снеж",
			"снет",
			"сним",
			"сноб",
			"снов",
			"сноп",
			"снох",
			"сова",
			"совк",
			"согд",
			"сойк",
			"солн",
			"соло",
			"соль",
			"сомн",
			"сомо",
			"сонм",
			"сонь",
			"сопк",
			"сопл",
			"сорб",
			"сорт",
			"сосн",
			"соте",
			"соус",
			"соци",
			"союж",
			"союз",
			"спар",
			"спас",
			"спес",
			"спех",
			"спец",
			"спеш",
			"спид",
			"спин",
			"спир",
			"спиц",
			"спич",
			"спор",
			"спят",
			"сраж",
			"срам",
			"сред",
			"срок",
			"сроч",
			"сряд",
			"ссад",
			"ссаж",
			"ссор",
			"ссуд",
			"ссуж",
			"став",
			"стад",
			"стаж",
			"стаз",
			"стай",
			"стак",
			"стал",
			"стан",
			"стар",
			"стас",
			"стат",
			"стве",
			"стег",
			"стеж",
			"стез",
			"стек",
			"стел",
			"стен",
			"степ",
			"стер",
			"стет",
			"стиг",
			"стил",
			"стир",
			"стих",
			"стиш",
			"стог",
			"стож",
			"стой",
			"стол",
			"стом",
			"стон",
			"стоп",
			"стор",
			"стра",
			"стро",
			"стру",
			"студ",
			"стуж",
			"стук",
			"стул",
			"ступ",
			"стуч",
			"стыд",
			"стыж",
			"стяг",
			"стяж",
			"стёг",
			"стёж",
			"субъ",
			"суди",
			"судн",
			"судь",
			"сует",
			"сужд",
			"сукн",
			"суле",
			"сумм",
			"сумч",
			"сунн",
			"супл",
			"сурд",
			"сурж",
			"сурк",
			"сурн",
			"сурч",
			"сусл",
			"сутк",
			"суть",
			"суфл",
			"сучь",
			"сушь",
			"суэц",
			"сфер",
			"схем",
			"схим",
			"сцен",
			"сциф",
			"счит",
			"счёт",
			"съём",
			"сыль",
			"сыпл",
			"сыпь",
			"сырт",
			"сырь",
			"сыть",
			"сюда",
			"сюит",
			"сёдл",
			"сёмг",
			"таба",
			"табу",
			"тавр",
			"тавт",
			"таит",
			"тайг",
			"тайм",
			"тайп",
			"таки",
			"такс",
			"такт",
			"тали",
			"талк",
			"талл",
			"таль",
			"танк",
			"танц",
			"тапк",
			"тапл",
			"тапт",
			"таск",
			"тату",
			"тать",
			"тафт",
			"тафь",
			"тахе",
			"тахи",
			"тахт",
			"тачк",
			"таёж",
			"твар",
			"твид",
			"твой",
			"твор",
			"теин",
			"теле",
			"темн",
			"темп",
			"темь",
			"тенз",
			"тенк",
			"тенс",
			"тент",
			"тень",
			"теор",
			"тепл",
			"терз",
			"терм",
			"терн",
			"терп",
			"терр",
			"терц",
			"тесн",
			"тест",
			"тетр",
			"техн",
			"течь",
			"тибр",
			"тигр",
			"тинг",
			"тире",
			"тиск",
			"тисн",
			"титл",
			"титр",
			"тиун",
			"тифл",
			"тишь",
			"тмин",
			"того",
			"тоже",
			"токс",
			"толк",
			"толп",
			"толч",
			"толщ",
			"толь",
			"томи",
			"томл",
			"томн",
			"тонк",
			"тонн",
			"тонч",
			"тонь",
			"топи",
			"топл",
			"топо",
			"топт",
			"топч",
			"топь",
			"торб",
			"торг",
			"торж",
			"тори",
			"торк",
			"торс",
			"торт",
			"торф",
			"торц",
			"торч",
			"тоск",
			"тост",
			"точк",
			"точн",
			"тошн",
			"тпру",
			"трав",
			"траг",
			"трак",
			"трал",
			"трап",
			"трас",
			"трат",
			"траф",
			"трах",
			"трач",
			"треб",
			"трек",
			"трел",
			"трен",
			"треп",
			"трес",
			"трет",
			"треф",
			"трещ",
			"триб",
			"трик",
			"трио",
			"трог",
			"трок",
			"трон",
			"троп",
			"трос",
			"троф",
			"трох",
			"трощ",
			"труб",
			"труд",
			"труж",
			"трун",
			"труп",
			"трус",
			"трут",
			"трух",
			"труш",
			"трюк",
			"трюм",
			"трюх",
			"тряп",
			"тряс",
			"трях",
			"трёп",
			"тубо",
			"туда",
			"туес",
			"туль",
			"тумб",
			"туне",
			"тунц",
			"тупл",
			"турб",
			"турк",
			"турн",
			"турч",
			"туск",
			"туфл",
			"туфт",
			"тучн",
			"тушь",
			"тщет",
			"тыкв",
			"тыль",
			"тырк",
			"тырл",
			"тырс",
			"тысч",
			"ться",
			"тьфу",
			"тюль",
			"тюрк",
			"тюрч",
			"тягч",
			"тять",
			"тёзк",
			"тёпл",
			"тёрн",
			"убед",
			"убий",
			"убог",
			"убож",
			"убой",
			"уваж",
			"увеч",
			"увещ",
			"увол",
			"увул",
			"угле",
			"угод",
			"угол",
			"угор",
			"угощ",
			"удав",
			"удал",
			"удар",
			"удач",
			"удел",
			"удил",
			"удоб",
			"удод",
			"уезд",
			"ужас",
			"ужин",
			"ужли",
			"узел",
			"узор",
			"узус",
			"указ",
			"улан",
			"улей",
			"улик",
			"улит",
			"улиц",
			"улич",
			"улус",
			"улуч",
			"улыб",
			"ульч",
			"умбр",
			"умык",
			"уник",
			"уним",
			"унци",
			"упор",
			"урал",
			"уран",
			"урду",
			"урем",
			"урод",
			"урок",
			"уроч",
			"урюк",
			"урюч",
			"уряд",
			"усоб",
			"успе",
			"уста",
			"устн",
			"усть",
			"утил",
			"уток",
			"утол",
			"утоп",
			"утор",
			"уточ",
			"утюг",
			"утюж",
			"утёс",
			"ухаб",
			"ухар",
			"ухит",
			"ухич",
			"учес",
			"учит",
			"учуг",
			"учуж",
			"учёт",
			"ушат",
			"ушек",
			"ушеч",
			"ущел",
			"уязв",
			"фабр",
			"фавн",
			"фаги",
			"файл",
			"факс",
			"факт",
			"фалд",
			"фалл",
			"фаль",
			"фанг",
			"фанз",
			"фант",
			"фарс",
			"фарт",
			"фарц",
			"фарш",
			"фаск",
			"фаун",
			"феер",
			"фейс",
			"фелл",
			"фено",
			"феод",
			"ферз",
			"ферм",
			"ферр",
			"ферт",
			"феск",
			"фетр",
			"фехт",
			"фибр",
			"фиде",
			"физи",
			"фикс",
			"фикт",
			"филе",
			"филл",
			"филь",
			"финн",
			"финт",
			"фирм",
			"фирн",
			"фиск",
			"фифи",
			"фишк",
			"фишю",
			"флав",
			"флаг",
			"флаж",
			"флан",
			"флат",
			"флеб",
			"флеш",
			"флор",
			"флот",
			"флюс",
			"фляг",
			"фляж",
			"флёр",
			"фогт",
			"фойе",
			"фоли",
			"фонд",
			"форд",
			"форм",
			"форс",
			"форт",
			"фоск",
			"фосф",
			"фото",
			"фраз",
			"фрак",
			"фрау",
			"фрач",
			"фрез",
			"френ",
			"фриз",
			"фрик",
			"фриш",
			"фтор",
			"фузе",
			"фузи",
			"фукс",
			"фуле",
			"фунд",
			"фунт",
			"фури",
			"фурк",
			"фурч",
			"фусц",
			"хадж",
			"хайл",
			"хаки",
			"халв",
			"халд",
			"хамс",
			"хамь",
			"ханж",
			"хаос",
			"хаот",
			"харк",
			"харч",
			"хауз",
			"хвал",
			"хвар",
			"хват",
			"хвач",
			"хвой",
			"хвор",
			"хвощ",
			"хетт",
			"хими",
			"химк",
			"хипп",
			"хиро",
			"хитр",
			"хлад",
			"хлам",
			"хлеб",
			"хлев",
			"хлещ",
			"хлип",
			"хлоп",
			"хлор",
			"хлуп",
			"хлыщ",
			"хлюп",
			"хляб",
			"хляс",
			"хлёб",
			"хмел",
			"хмур",
			"ходж",
			"ходь",
			"хожд",
			"хожь",
			"хозя",
			"холе",
			"холк",
			"холл",
			"холм",
			"холщ",
			"хорд",
			"хоре",
			"хорт",
			"хорь",
			"хоть",
			"хотя",
			"хохл",
			"хохм",
			"хохо",
			"храм",
			"хран",
			"храп",
			"хрен",
			"хриз",
			"хрип",
			"хром",
			"хрон",
			"хрум",
			"хруп",
			"хрущ",
			"хрыч",
			"хряк",
			"хряп",
			"хряс",
			"хряч",
			"хрящ",
			"худш",
			"хуль",
			"хунт",
			"хурм",
			"цанг",
			"цапл",
			"цапф",
			"царь",
			"цвес",
			"цвет",
			"цвеч",
			"цевк",
			"цевь",
			"цедр",
			"цейс",
			"целл",
			"цель",
			"ценз",
			"цент",
			"цепл",
			"цепс",
			"цепт",
			"цепь",
			"цеце",
			"циан",
			"цикл",
			"цилл",
			"цинг",
			"цинк",
			"цирк",
			"цирр",
			"цист",
			"цитр",
			"цифр",
			"цыпл",
			"чабр",
			"чадр",
			"чайк",
			"чайн",
			"чалм",
			"чаль",
			"чарт",
			"част",
			"чась",
			"чать",
			"чаус",
			"чауш",
			"чван",
			"челн",
			"чель",
			"чепч",
			"черв",
			"черк",
			"черн",
			"черп",
			"черт",
			"черч",
			"чест",
			"четв",
			"четь",
			"чехл",
			"чешу",
			"чиви",
			"чили",
			"чипс",
			"чирк",
			"числ",
			"чист",
			"член",
			"чмок",
			"чонк",
			"чрев",
			"чред",
			"чтоб",
			"чудь",
			"чуеч",
			"чужд",
			"чуйк",
			"чукч",
			"чулк",
			"чумл",
			"чурк",
			"чуть",
			"чухн",
			"чушк",
			"чушь",
			"чёлк",
			"чёлн",
			"чёрк",
			"чёрн",
			"чёрт",
			"чётк",
			"чётч",
			"шабр",
			"шавк",
			"шаеч",
			"шайб",
			"шайк",
			"шале",
			"шаль",
			"шамк",
			"шанс",
			"шапк",
			"шапч",
			"шарж",
			"шарк",
			"шарм",
			"шарп",
			"шарф",
			"шаст",
			"шатр",
			"шахт",
			"шашк",
			"шашн",
			"швах",
			"швед",
			"швыр",
			"шевр",
			"шедш",
			"шейк",
			"шейх",
			"шелк",
			"шепт",
			"шепч",
			"шерп",
			"шерф",
			"шест",
			"шибк",
			"шибл",
			"шибч",
			"шиль",
			"шинк",
			"ширм",
			"ширь",
			"шифр",
			"шихт",
			"шишк",
			"шкал",
			"шкаф",
			"шкет",
			"шкив",
			"шкод",
			"школ",
			"шкот",
			"шкур",
			"шлаг",
			"шлак",
			"шлам",
			"шлей",
			"шлем",
			"шлеп",
			"шлиф",
			"шлих",
			"шлиц",
			"шлык",
			"шлыч",
			"шлюз",
			"шлюп",
			"шляп",
			"шлях",
			"шлёп",
			"шмел",
			"шмыг",
			"шмяк",
			"шнек",
			"шнур",
			"шныр",
			"шорк",
			"шорт",
			"шосс",
			"шофе",
			"шпаг",
			"шпаж",
			"шпак",
			"шпал",
			"шпан",
			"шпар",
			"шпат",
			"шпиг",
			"шпик",
			"шпил",
			"шпиц",
			"шпон",
			"шпор",
			"шпул",
			"шпур",
			"шпын",
			"шрам",
			"штаб",
			"штал",
			"штан",
			"штат",
			"штил",
			"шток",
			"штоп",
			"штор",
			"штос",
			"штоф",
			"штуд",
			"штук",
			"штуч",
			"штыб",
			"штык",
			"штыр",
			"шуан",
			"шурп",
			"шурф",
			"шурш",
			"шурь",
			"шуст",
			"шхун",
			"шёлк",
			"шёпт",
			"щебн",
			"щегл",
			"щедр",
			"щелк",
			"щелч",
			"щель",
			"щемл",
			"щепл",
			"щерб",
			"щипл",
			"щипц",
			"щупл",
			"щупь",
			"щёлк",
			"щётк",
			"ыдей",
			"ымит",
			"ыноч",
			"ыскр",
			"ытог",
			"ытож",
			"ыюль",
			"ыюнь",
			"эбен",
			"эвак",
			"эвен",
			"эвфу",
			"эгид",
			"эдак",
			"эдем",
			"эжек",
			"эзоп",
			"экви",
			"экзо",
			"экип",
			"экто",
			"элег",
			"элит",
			"эльф",
			"эмал",
			"эман",
			"эмир",
			"эмит",
			"эндо",
			"энео",
			"энто",
			"эпат",
			"эпид",
			"эпос",
			"эпох",
			"эрго",
			"эрег",
			"эрек",
			"эрод",
			"эрот",
			"эруд",
			"эссе",
			"этаж",
			"этак",
			"этап",
			"этик",
			"этил",
			"этим",
			"этич",
			"этот",
			"этюд",
			"эфес",
			"эфир",
			"эхин",
			"юань",
			"юбил",
			"юбоч",
			"юкол",
			"юльк",
			"юмор",
			"юнак",
			"юнац",
			"юрид",
			"юрис",
			"юрод",
			"юрок",
			"юточ",
			"юфть",
			"ябед",
			"явор",
			"ягел",
			"ягод",
			"ядер",
			"язвл",
			"язык",
			"языч",
			"якор",
			"якут",
			"якша",
			"ялов",
			"ямай",
			"янки",
			"япон",
			"ярем",
			"ярий",
			"яров",
			"яруг",
			"ярус",
			"ярыг",
			"ярыж",
			"ясак",
			"ясач",
			"ясен",
			"яств",
			"ятин",
			"ятор",
			"яфет",
			"ячей",
			"ящер",
			"ящик",
			"ящич",
			"ящур",
			"ёнок",
			"ёноч",
			"ёныш",
			"ёрза",
			"ави",
			"авл",
			"авт",
			"авь",
			"ага",
			"агу",
			"адм",
			"адь",
			"аеч",
			"ази",
			"азм",
			"азо",
			"азу",
			"аил",
			"аир",
			"айв",
			"акр",
			"акт",
			"ала",
			"алг",
			"али",
			"алк",
			"алч",
			"амм",
			"амт",
			"аму",
			"ана",
			"анг",
			"анд",
			"ань",
			"апо",
			"ара",
			"арб",
			"ард",
			"ари",
			"арк",
			"арм",
			"арт",
			"арф",
			"арх",
			"арч",
			"асб",
			"асс",
			"ась",
			"атк",
			"ато",
			"атр",
			"ату",
			"ать",
			"аул",
			"аур",
			"аут",
			"ачь",
			"аэр",
			"баб",
			"бав",
			"баз",
			"бай",
			"бак",
			"бал",
			"бан",
			"бар",
			"бас",
			"бат",
			"бах",
			"бац",
			"бач",
			"баю",
			"бег",
			"бед",
			"беж",
			"бей",
			"бек",
			"бел",
			"бен",
			"бер",
			"бес",
			"беш",
			"биб",
			"бий",
			"бил",
			"био",
			"бир",
			"бис",
			"бит",
			"бич",
			"бле",
			"боа",
			"боб",
			"бог",
			"бод",
			"бож",
			"бой",
			"бок",
			"бол",
			"бон",
			"бор",
			"бос",
			"бот",
			"боч",
			"бра",
			"бре",
			"бри",
			"брр",
			"брю",
			"буд",
			"буж",
			"буз",
			"буй",
			"бук",
			"бум",
			"бун",
			"бур",
			"бус",
			"бут",
			"буф",
			"бух",
			"буч",
			"бык",
			"был",
			"быт",
			"быч",
			"бэр",
			"бяз",
			"бяк",
			"ваб",
			"вад",
			"важ",
			"ваз",
			"вал",
			"ван",
			"вар",
			"ват",
			"ваш",
			"ващ",
			"вая",
			"вед",
			"вез",
			"вей",
			"век",
			"вел",
			"вен",
			"вер",
			"вес",
			"вет",
			"вех",
			"веч",
			"веш",
			"вещ",
			"вея",
			"взъ",
			"взя",
			"вив",
			"виг",
			"вид",
			"виз",
			"вик",
			"вил",
			"вин",
			"вир",
			"вис",
			"вит",
			"вих",
			"виц",
			"вня",
			"вод",
			"вое",
			"вож",
			"вои",
			"вой",
			"вол",
			"вон",
			"воп",
			"вос",
			"вот",
			"вош",
			"вощ",
			"вою",
			"впи",
			"все",
			"вые",
			"вык",
			"вым",
			"выс",
			"выч",
			"выш",
			"вяд",
			"вяж",
			"вяз",
			"вял",
			"вят",
			"вящ",
			"вёз",
			"вёр",
			"гав",
			"гаг",
			"гад",
			"гаж",
			"газ",
			"гак",
			"гал",
			"гам",
			"ган",
			"гар",
			"гас",
			"гат",
			"гач",
			"гаш",
			"гащ",
			"где",
			"гей",
			"гел",
			"гем",
			"ген",
			"гео",
			"гиб",
			"гид",
			"гик",
			"гин",
			"гип",
			"гир",
			"гит",
			"гич",
			"гли",
			"гля",
			"гни",
			"гну",
			"гов",
			"год",
			"гож",
			"гой",
			"гол",
			"гом",
			"гон",
			"гоп",
			"гор",
			"гос",
			"гот",
			"гоф",
			"гре",
			"гря",
			"губ",
			"гуд",
			"гуж",
			"гуз",
			"гук",
			"гул",
			"гум",
			"гус",
			"гут",
			"гущ",
			"дав",
			"дал",
			"дам",
			"дан",
			"дар",
			"дат",
			"дач",
			"дви",
			"дев",
			"дед",
			"дее",
			"деж",
			"дей",
			"дек",
			"дел",
			"дем",
			"ден",
			"деп",
			"дер",
			"дет",
			"дец",
			"деч",
			"дзе",
			"диа",
			"див",
			"диз",
			"дик",
			"дин",
			"дип",
			"дир",
			"дит",
			"дих",
			"дич",
			"дож",
			"доз",
			"дой",
			"док",
			"дол",
			"дом",
			"дон",
			"дор",
			"дот",
			"дох",
			"доч",
			"дош",
			"дощ",
			"дра",
			"дуб",
			"дуг",
			"дуд",
			"дуж",
			"дул",
			"дум",
			"дуо",
			"дур",
			"дух",
			"душ",
			"дыб",
			"дым",
			"дын",
			"дыр",
			"дых",
			"дыш",
			"дыщ",
			"дюж",
			"дюн",
			"дюр",
			"дяд",
			"дёж",
			"дён",
			"дёр",
			"ева",
			"евк",
			"евл",
			"ево",
			"евр",
			"евь",
			"его",
			"еди",
			"едь",
			"ее:",
			"еже",
			"езд",
			"езж",
			"екс",
			"еле",
			"елл",
			"ему",
			"енд",
			"енк",
			"енц",
			"енч",
			"ерт",
			"ерш",
			"ерь",
			"ест",
			"есх",
			"есц",
			"есь",
			"етт",
			"еть",
			"ец:",
			"ешк",
			"ещё",
			"жаб",
			"жад",
			"жал",
			"жам",
			"жар",
			"жах",
			"жда",
			"жег",
			"жен",
			"жив",
			"жиг",
			"жид",
			"жиж",
			"жил",
			"жим",
			"жин",
			"жир",
			"жит",
			"жог",
			"жок",
			"жом",
			"жор",
			"жох",
			"жук",
			"жул",
			"жур",
			"жух",
			"жуч",
			"жёв",
			"жёг",
			"жён",
			"заб",
			"зав",
			"зад",
			"зай",
			"зал",
			"зам",
			"зап",
			"зар",
			"зва",
			"зда",
			"зев",
			"зек",
			"зем",
			"зет",
			"зиг",
			"зим",
			"зия",
			"зме",
			"зна",
			"зоа",
			"зоб",
			"зов",
			"зой",
			"зол",
			"зон",
			"зоо",
			"зор",
			"зре",
			"зря",
			"зуб",
			"зуд",
			"зуж",
			"зыб",
			"зыв",
			"зык",
			"зыр",
			"зыч",
			"зюз",
			"зяб",
			"зят",
			"зёв",
			"зём",
			"иаз",
			"ибо",
			"ивл",
			"ивь",
			"игл",
			"игр",
			"иде",
			"идо",
			"иев",
			"иен",
			"иже",
			"изб",
			"изъ",
			"ий:",
			"ика",
			"икр",
			"икс",
			"или",
			"илл",
			"иль",
			"име",
			"инд",
			"ино",
			"инь",
			"иол",
			"ион",
			"ипо",
			"иск",
			"итв",
			"ить",
			"иуд",
			"ичк",
			"ичь",
			"ище",
			"йог",
			"йод",
			"йот",
			"кад",
			"каж",
			"каз",
			"как",
			"кал",
			"кам",
			"кап",
			"кар",
			"кас",
			"кат",
			"кач",
			"каш",
			"кащ",
			"ква",
			"кеб",
			"кед",
			"кеп",
			"кет",
			"кив",
			"кид",
			"кий",
			"кик",
			"кил",
			"ким",
			"кип",
			"кис",
			"кит",
			"кич",
			"киш",
			"кле",
			"клю",
			"кля",
			"ков",
			"код",
			"кож",
			"коз",
			"кок",
			"кол",
			"кон",
			"коп",
			"кор",
			"кос",
			"кот",
			"кош",
			"кощ",
			"кр.",
			"кра",
			"кро",
			"кры",
			"кря",
			"кто",
			"куб",
			"куг",
			"куд",
			"куз",
			"кул",
			"кум",
			"кун",
			"куп",
			"кур",
			"кус",
			"кут",
			"куц",
			"куч",
			"куш",
			"кущ",
			"кыш",
			"кюр",
			"лаб",
			"лав",
			"лаг",
			"лад",
			"лаж",
			"лаз",
			"лай",
			"лак",
			"лал",
			"лам",
			"лап",
			"лар",
			"лас",
			"лат",
			"лач",
			"лащ",
			"лев",
			"лег",
			"лед",
			"леж",
			"лез",
			"лей",
			"лек",
			"лен",
			"леп",
			"лес",
			"лет",
			"леч",
			"леш",
			"лещ",
			"лиг",
			"лид",
			"лиж",
			"лиз",
			"лик",
			"лил",
			"лип",
			"лир",
			"лис",
			"лит",
			"лиф",
			"лих",
			"лич",
			"лиш",
			"лоб",
			"лов",
			"лог",
			"лож",
			"лоз",
			"лок",
			"лом",
			"лон",
			"лоп",
			"лор",
			"лос",
			"лот",
			"лох",
			"лош",
			"лощ",
			"луб",
			"луг",
			"луд",
			"луж",
			"луз",
			"лук",
			"лун",
			"луп",
			"луч",
			"лущ",
			"лыг",
			"лыж",
			"лык",
			"лыс",
			"лыч",
			"льв",
			"льд",
			"лье",
			"льщ",
			"люб",
			"люд",
			"люк",
			"люп",
			"лют",
			"люф",
			"ляг",
			"лял",
			"ляп",
			"лях",
			"ляш",
			"лёг",
			"лёд",
			"лёж",
			"лён",
			"лёт",
			"маг",
			"маз",
			"май",
			"мак",
			"мал",
			"мам",
			"мао",
			"мар",
			"мат",
			"мах",
			"мац",
			"мач",
			"маш",
			"мащ",
			"мгл",
			"мег",
			"мед",
			"мез",
			"мел",
			"мер",
			"мес",
			"мет",
			"мех",
			"меч",
			"меш",
			"мещ",
			"мзд",
			"миг",
			"миз",
			"мик",
			"мил",
			"мим",
			"мин",
			"мио",
			"мир",
			"мит",
			"миф",
			"миц",
			"миш",
			"мле",
			"мов",
			"мог",
			"мод",
			"мож",
			"мой",
			"мок",
			"мол",
			"мон",
			"мор",
			"мот",
			"мох",
			"моч",
			"мощ",
			"мст",
			"муж",
			"муз",
			"мук",
			"мул",
			"мум",
			"мур",
			"мут",
			"мух",
			"муч",
			"муш",
			"мущ",
			"мыз",
			"мык",
			"мыл",
			"мыс",
			"мыт",
			"мыч",
			"мыш",
			"мэр",
			"мя:",
			"мяг",
			"мяк",
			"мяс",
			"мят",
			"мяу",
			"мяч",
			"мёд",
			"мёт",
			"наг",
			"наж",
			"най",
			"нан",
			"нар",
			"нат",
			"нац",
			"нач",
			"наш",
			"неб",
			"нег",
			"неж",
			"нек",
			"нем",
			"нен",
			"нео",
			"нес",
			"нет",
			"неф",
			"нив",
			"ние",
			"ниж",
			"ним",
			"нис",
			"ниш",
			"нищ",
			"нов",
			"ног",
			"нож",
			"ноз",
			"нол",
			"ном",
			"нон",
			"нор",
			"нос",
			"нот",
			"ноч",
			"нош",
			"нощ",
			"нуг",
			"нуд",
			"нул",
			"нут",
			"ный",
			"нын",
			"ныр",
			"ньк",
			"нюн",
			"нюх",
			"нюш",
			"нян",
			"няц",
			"няч",
			"нёб",
			"нёс",
			"обж",
			"обл",
			"обр",
			"общ",
			"объ",
			"ове",
			"овл",
			"овс",
			"овц",
			"овч",
			"огн",
			"оди",
			"одн",
			"одр",
			"ози",
			"озо",
			"оит",
			"окл",
			"окн",
			"окс",
			"окт",
			"оку",
			"оле",
			"онт",
			"опи",
			"опо",
			"опс",
			"опт",
			"орг",
			"орд",
			"орл",
			"осл",
			"осм",
			"осп",
			"ост",
			"осу",
			"ось",
			"отц",
			"отч",
			"отъ",
			"охр",
			"охт",
			"очь",
			"ошн",
			"оят",
			"пав",
			"пад",
			"паж",
			"паз",
			"пай",
			"пак",
			"пал",
			"пан",
			"пап",
			"пар",
			"пас",
			"пат",
			"паф",
			"пах",
			"паш",
			"пая",
			"пег",
			"пед",
			"пеж",
			"пей",
			"пек",
			"пел",
			"пен",
			"пер",
			"пес",
			"пех",
			"печ",
			"пеш",
			"пив",
			"пий",
			"пик",
			"пил",
			"пим",
			"пин",
			"пир",
			"пис",
			"пит",
			"пих",
			"пиш",
			"пищ",
			"пла",
			"пли",
			"пло",
			"плы",
			"плю",
			"поз",
			"пой",
			"пол",
			"пом",
			"пон",
			"поп",
			"пор",
			"пос",
			"пот",
			"поч",
			"пря",
			"пуг",
			"пуд",
			"пуз",
			"пук",
			"пул",
			"пум",
			"пун",
			"пуп",
			"пур",
			"пут",
			"пуф",
			"пух",
			"пуч",
			"пуш",
			"пущ",
			"пыж",
			"пыл",
			"пыр",
			"пыт",
			"пых",
			"пыш",
			"пэр",
			"пяд",
			"пял",
			"пят",
			"пяч",
			"пёк",
			"пён",
			"пёр",
			"пёс",
			"раб",
			"рад",
			"раж",
			"рай",
			"рак",
			"рам",
			"ран",
			"рас",
			"рат",
			"рах",
			"рац",
			"рач",
			"ращ",
			"рде",
			"реб",
			"рев",
			"ред",
			"реж",
			"рез",
			"рей",
			"рек",
			"рем",
			"рео",
			"реп",
			"рех",
			"рец",
			"реч",
			"реш",
			"риб",
			"риг",
			"риз",
			"рик",
			"рим",
			"рин",
			"рис",
			"риф",
			"роб",
			"ров",
			"рог",
			"род",
			"рож",
			"роз",
			"рой",
			"рок",
			"рол",
			"ром",
			"рон",
			"рос",
			"рот",
			"рощ",
			"руб",
			"руг",
			"руд",
			"рук",
			"рул",
			"рун",
			"рус",
			"рут",
			"рух",
			"руч",
			"руш",
			"рыб",
			"рыв",
			"рыг",
			"рыд",
			"рыж",
			"рык",
			"рыл",
			"рып",
			"рыс",
			"рыч",
			"рюм",
			"рюх",
			"рюш",
			"ряб",
			"ряд",
			"ряж",
			"ряс",
			"рёв",
			"рёк",
			"саг",
			"сад",
			"саж",
			"сак",
			"сал",
			"сам",
			"сан",
			"сап",
			"сар",
			"сас",
			"сач",
			"сбы",
			"сва",
			"сво",
			"сда",
			"себ",
			"сед",
			"сей",
			"сек",
			"сел",
			"сем",
			"сен",
			"сер",
			"сес",
			"сет",
			"сеч",
			"сив",
			"сиг",
			"сид",
			"сиж",
			"сиз",
			"сил",
			"син",
			"сип",
			"сир",
			"сис",
			"сит",
			"сия",
			"сла",
			"сле",
			"сло",
			"слы",
			"сме",
			"сня",
			"соб",
			"сов",
			"сод",
			"сок",
			"сол",
			"сом",
			"сон",
			"соп",
			"сор",
			"сос",
			"сот",
			"соф",
			"сох",
			"соц",
			"соч",
			"сош",
			"спа",
			"спе",
			"спо",
			"ста",
			"стл",
			"сто",
			"сты",
			"суд",
			"суе",
			"суж",
			"сук",
			"сул",
			"сум",
			"суп",
			"сух",
			"суч",
			"суш",
			"сущ",
			"схи",
			"сыл",
			"сын",
			"сып",
			"сыр",
			"сыт",
			"сых",
			"сыч",
			"сыщ",
			"сэр",
			"сюд",
			"сюр",
			"ся]",
			"сяд",
			"сяж",
			"сяк",
			"сёк",
			"сёл",
			"таг",
			"таз",
			"таи",
			"тай",
			"так",
			"тал",
			"там",
			"тап",
			"тар",
			"тас",
			"тат",
			"тау",
			"таф",
			"тах",
			"тач",
			"таш",
			"тащ",
			"тез",
			"тей",
			"тек",
			"тел",
			"тем",
			"тен",
			"теп",
			"тер",
			"тес",
			"тет",
			"тех",
			"теч",
			"теш",
			"тий",
			"тик",
			"тил",
			"тин",
			"тип",
			"тир",
			"тис",
			"тиф",
			"тих",
			"тиш",
			"тле",
			"тоб",
			"тог",
			"тож",
			"той",
			"ток",
			"тол",
			"том",
			"тон",
			"топ",
			"тот",
			"точ",
			"тощ",
			"тре",
			"тро",
			"трю",
			"тсс",
			"туб",
			"тув",
			"туг",
			"туж",
			"туз",
			"туй",
			"тук",
			"тул",
			"туп",
			"тус",
			"тут",
			"туф",
			"тух",
			"туч",
			"туш",
			"тшш",
			"тык",
			"тыл",
			"тын",
			"тыр",
			"тыч",
			"ть]",
			"тьм",
			"тюк",
			"тюл",
			"тюр",
			"тюч",
			"тяв",
			"тяг",
			"тяж",
			"тяп",
			"тят",
			"тёк",
			"тёл",
			"тём",
			"тёр",
			"тёс",
			"тёт",
			"тёч",
			"тёш",
			"тёщ",
			"уби",
			"убо",
			"увы",
			"угл",
			"угр",
			"угу",
			"уда",
			"удэ",
			"уже",
			"ужо",
			"узд",
			"узк",
			"узл",
			"уйм",
			"уль",
			"уме",
			"умл",
			"умь",
			"умё",
			"уни",
			"унт",
			"уны",
			"унь",
			"уня",
			"упо",
			"ура",
			"урн",
			"урч",
			"уст",
			"усь",
			"утк",
			"утл",
			"утр",
			"учт",
			"ушл",
			"ушч",
			"уют",
			"уём",
			"фаб",
			"фаг",
			"фаз",
			"фай",
			"фак",
			"фал",
			"фан",
			"фар",
			"фас",
			"фат",
			"фаш",
			"фен",
			"фер",
			"фиг",
			"физ",
			"фик",
			"фил",
			"фин",
			"фит",
			"фиц",
			"фоб",
			"фок",
			"фон",
			"фор",
			"фос",
			"фот",
			"фри",
			"фру",
			"фу:",
			"фуг",
			"фуж",
			"фук",
			"фур",
			"фут",
			"фыр",
			"фён",
			"хав",
			"хаж",
			"хаз",
			"хай",
			"хам",
			"хан",
			"хап",
			"хар",
			"хат",
			"хво",
			"хек",
			"хем",
			"хер",
			"хеш",
			"хив",
			"хил",
			"хим",
			"хин",
			"хир",
			"хит",
			"хищ",
			"хлы",
			"хмы",
			"хны",
			"ход",
			"хож",
			"хоз",
			"хол",
			"хоп",
			"хор",
			"хот",
			"хоч",
			"хрю",
			"худ",
			"хуж",
			"хул",
			"цап",
			"цар",
			"цац",
			"цед",
			"цеж",
			"цез",
			"цел",
			"цен",
			"цео",
			"цеп",
			"цер",
			"цет",
			"цех",
			"цид",
			"цин",
			"цит",
			"цок",
			"цоп",
			"цуг",
			"цук",
			"цык",
			"цып",
			"цыц",
			"чав",
			"чад",
			"чай",
			"чал",
			"чао",
			"чар",
			"час",
			"чах",
			"чач",
			"чаш",
			"чащ",
			"чей",
			"чек",
			"чел",
			"чем",
			"чес",
			"чет",
			"чех",
			"чеш",
			"чещ",
			"чиж",
			"чий",
			"чир",
			"чит",
			"чих",
			"чиц",
			"чич",
			"чищ",
			"чок",
			"чон",
			"чох",
			"что",
			"чуб",
			"чуг",
			"чуд",
			"чуж",
			"чум",
			"чун",
			"чур",
			"чут",
			"чух",
			"чёс",
			"чёт",
			"шаг",
			"шаж",
			"шал",
			"шар",
			"шат",
			"шаф",
			"шах",
			"шаш",
			"шев",
			"шед",
			"шей",
			"шел",
			"шеп",
			"шеф",
			"шеч",
			"шиб",
			"шиз",
			"ший",
			"шик",
			"шил",
			"шин",
			"шип",
			"шир",
			"шиш",
			"шле",
			"шля",
			"шов",
			"шок",
			"шор",
			"шоу",
			"шоф",
			"шуб",
			"шуг",
			"шум",
			"шут",
			"шуч",
			"шыр",
			"щад",
			"щаж",
			"щек",
			"щел",
			"щем",
			"щен",
			"щеп",
			"щер",
			"щип",
			"щит",
			"щиц",
			"щич",
			"щук",
			"щуп",
			"щур",
			"щуч",
			"щёк",
			"щёл",
			"щён",
			"щёч",
			"ыва",
			"ыгл",
			"ыгр",
			"ыде",
			"ыдн",
			"ызб",
			"ый:",
			"ый]",
			"ыкр",
			"ыме",
			"ынд",
			"ынк",
			"ыск",
			"ыть",
			"эва",
			"эге",
			"эго",
			"эдр",
			"экз",
			"эко",
			"экю",
			"эль",
			"элю",
			"эму",
			"энд",
			"эоз",
			"эол",
			"эпи",
			"эрб",
			"эрг",
			"эре",
			"эрз",
			"эст",
			"эти",
			"этк",
			"этн",
			"это",
			"юбк",
			"юбч",
			"южн",
			"юзг",
			"юка",
			"юкк",
			"юнг",
			"юрк",
			"юрт",
			"юст",
			"юфт",
			"ючи",
			"юшк",
			"явк",
			"явл",
			"явь",
			"ягд",
			"ягн",
			"ядр",
			"язв",
			"язь",
			"яиц",
			"яич",
			"яйл",
			"яйц",
			"яко",
			"якш",
			"ялт",
			"яма",
			"ямб",
			"янк",
			"янн",
			"янт",
			"янь",
			"ярд",
			"ярк",
			"ярм",
			"ярн",
			"ярч",
			"ярь",
			"ясл",
			"ясн",
			"яст",
			"ятк",
			"ять",
			"яхт",
			"яци",
			"яче",
			"ячк",
			"яшк",
			"яшм",
			"ёва",
			"ёвк",
			"ёво",
			"ёжк",
			"ёзн",
			"ёмк",
			"ёнк",
			"ёрз",
			"ёрт",
			"ёрш",
			"ёхъ",
			"а:",
			"аб",
			"аз",
			"аи",
			"ау",
			"ац",
			"аю",
			"ба",
			"бд",
			"бе",
			"би",
			"бн",
			"бо",
			"бр",
			"бу",
			"бы",
			"бь",
			"бэ",
			"бя",
			"ва",
			"ве",
			"ви",
			"вл",
			"вр",
			"вс",
			"въ",
			"вь",
			"вэ",
			"вя",
			"га",
			"гб",
			"ге",
			"ги",
			"гм",
			"гн",
			"го",
			"да",
			"дв",
			"ди",
			"дл",
			"дн",
			"др",
			"ду",
			"дч",
			"дэ",
			"дё",
			"е:",
			"еб",
			"ед",
			"еж",
			"ез",
			"ек",
			"ес",
			"ех",
			"еч",
			"еш",
			"жа",
			"жв",
			"жг",
			"жд",
			"же",
			"жж",
			"жи",
			"жм",
			"жн",
			"жр",
			"зв",
			"зе",
			"зл",
			"зн",
			"зр",
			"зю",
			"и:",
			"иг",
			"ид",
			"ир",
			"ия",
			"йд",
			"кв",
			"ла",
			"лб",
			"лг",
			"ле",
			"лж",
			"ли",
			"лы",
			"ма",
			"ме",
			"мк",
			"мл",
			"мн",
			"мо",
			"мт",
			"мч",
			"мш",
			"мщ",
			"мы",
			"мь",
			"мэ",
			"нк",
			"нт",
			"ны",
			"нэ",
			"ню",
			"од",
			"оо",
			"ос",
			"оч",
			"ощ",
			"пе",
			"пи",
			"пл",
			"пн",
			"пс",
			"пт",
			"пх",
			"пь",
			"пэ",
			"ра",
			"рв",
			"рд",
			"рж",
			"ри",
			"ро",
			"рт",
			"ры",
			"се",
			"си",
			"сл",
			"сп",
			"ст",
			"съ",
			"сю",
			"та",
			"тк",
			"тл",
			"тм",
			"то",
			"тр",
			"ту",
			"тщ",
			"ты",
			"тэ",
			"тя",
			"уд",
			"уж",
			"уз",
			"фа",
			"фе",
			"фу",
			"фэ",
			"ха",
			"хи",
			"хн",
			"хо",
			"хр",
			"цо",
			"цы",
			"ча",
			"че",
			"чо",
			"чт",
			"чу",
			"чх",
			"чь",
			"ша",
			"шв",
			"шу",
			"ы:",
			"ыд",
			"ыз",
			"ый",
			"ын",
			"ыр",
			"ыс",
			"ых",
			"ыш",
			"ыщ",
			"эв",
			"эз",
			"эй",
			"эк",
			"эм",
			"эн",
			"эо",
			"эп",
			"эр",
			"эс",
			"эт",
			"эф",
			"эх",
			"юг",
			"юд",
			"юж",
			"юз",
			"юл",
			"юн",
			"юр",
			"юс",
			"ют",
			"юх",
			"юч",
			"юш",
			"ющ",
			"я",
			"яв",
			"яг",
			"яд",
			"яж",
			"яз",
			"яй",
			"ял",
			"ям",
			"ян",
			"ят",
			"ях",
			"яц",
			"яч",
			"яш",
			"ящ",
			"яя",
			"ёб",
			"ёв",
			"ёз",
			"ёк",
			"ём",
			"ёр",
			"ёс",
			"ёч",
			"ёш",
			"ёж",
			"е",
		]),
		new Set([
			"енность",
			"ествова",
			"изирова",
			"ированн",
			"истичес",
			"мейстер",
			"надцать",
			"охоньки",
			"охонько",
			"ошеньки",
			"ошенько",
			"тельниц",
			"тельств",
			"абельн",
			"ационн",
			"ибельн",
			"идальн",
			"имость",
			"ительн",
			"нность",
			"ональн",
			"охоньк",
			"ошеньк",
			"ственн",
			"ствова",
			"тельск",
			"унюшки",
			"усеньк",
			"амент",
			"ариус",
			"арник",
			"атарь",
			"атник",
			"атниц",
			"дцать",
			"ейник",
			"емент",
			"еньки",
			"енько",
			"еньку",
			"ешниц",
			"иальн",
			"ианск",
			"изаци",
			"изова",
			"иничн",
			"инств",
			"инчан",
			"ирова",
			"истик",
			"итель",
			"ическ",
			"ичниц",
			"лезск",
			"льник",
			"льниц",
			"льщик",
			"льщин",
			"ность",
			"нюшки",
			"няком",
			"овани",
			"ованн",
			"овато",
			"овенн",
			"овиан",
			"овизн",
			"овлив",
			"овник",
			"овниц",
			"овств",
			"овчан",
			"овщик",
			"овщин",
			"онизм",
			"онько",
			"оньку",
			"остью",
			"очниц",
			"тельн",
			"тость",
			"уальн",
			"чонок",
			"ышком",
			"amyp",
			"авец",
			"ажды",
			"алей",
			"альн",
			"анек",
			"анин",
			"анск",
			"арад",
			"арий",
			"атай",
			"атин",
			"атор",
			"ачей",
			"ачий",
			"евик",
			"евич",
			"евск",
			"ейск",
			"елив",
			"елин",
			"ельн",
			"енек",
			"енец",
			"еник",
			"ениц",
			"енск",
			"енци",
			"еств",
			"ийск",
			"иком",
			"ильн",
			"инец",
			"инит",
			"инск",
			"иозн",
			"ионн",
			"итет",
			"итор",
			"итур",
			"итян",
			"ичан",
			"ичий",
			"ичка",
			"ишом",
			"ками",
			"ловк",
			"менн",
			"мент",
			"нича",
			"овал",
			"оват",
			"овец",
			"овий",
			"овин",
			"овит",
			"овиц",
			"ович",
			"овищ",
			"овск",
			"омец",
			"онек",
			"онер",
			"онок",
			"оныш",
			"оньк",
			"орий",
			"ость",
			"очки",
			"очко",
			"ощав",
			"смен",
			"ства",
			"стви",
			"тель",
			"уган",
			"ульк",
			"униц",
			"уном",
			"унск",
			"ушки",
			"ушок",
			"ческ",
			"члив",
			"ытьб",
			"ышек",
			"эзск",
			"авк",
			"айк",
			"айш",
			"аль",
			"ами",
			"ани",
			"анк",
			"анн",
			"анс",
			"ант",
			"ану",
			"арн",
			"арь",
			"аст",
			"аци",
			"ацк",
			"ачк",
			"ашк",
			"ашн",
			"бин",
			"бищ",
			"вор",
			"вск",
			"вши",
			"ебн",
			"евн",
			"евт",
			"ежк",
			"езн",
			"ейк",
			"ейн",
			"ейш",
			"ель",
			"ени",
			"енн",
			"ент",
			"ень",
			"ери",
			"ерк",
			"еск",
			"есс",
			"етк",
			"ецк",
			"ечк",
			"еющ",
			"жан",
			"жды",
			"знь",
			"иад",
			"иан",
			"иат",
			"ива",
			"ивн",
			"изм",
			"изн",
			"инг",
			"инк",
			"иот",
			"ист",
			"ици",
			"ича",
			"ичн",
			"ишк",
			"ишн",
			"иян",
			"йск",
			"ках",
			"кой",
			"ком",
			"лан",
			"лец",
			"лив",
			"лин",
			"лиц",
			"лищ",
			"льн",
			"льц",
			"ляв",
			"ман",
			"мен",
			"нец",
			"ник",
			"нин",
			"нит",
			"ниц",
			"нич",
			"нск",
			"нци",
			"няк",
			"обн",
			"ова",
			"овк",
			"овн",
			"овь",
			"озн",
			"оид",
			"оль",
			"ому",
			"онк",
			"онн",
			"орн",
			"отк",
			"отн",
			"оту",
			"оть",
			"очк",
			"очн",
			"ошь",
			"снь",
			"ств",
			"тор",
			"тур",
			"тяй",
			"тян",
			"унк",
			"ург",
			"урк",
			"учи",
			"ушк",
			"чак",
			"чан",
			"чат",
			"чив",
			"чик",
			"чин",
			"чук",
			"щик",
			"щин",
			"ыль",
			"ынь",
			"ырь",
			"ышк",
			"ышн",
			"ютк",
			"ядь",
			"яжн",
			"яка",
			"ятн",
			"ёжь",
			"ённ",
			"ёшк",
			"am",
			"up",
			"ав",
			"аг",
			"ад",
			"аж",
			"ай",
			"ак",
			"ал",
			"ан",
			"ар",
			"ат",
			"ах",
			"ач",
			"аш",
			"ащ",
			"вш",
			"ев",
			"ее",
			"ей",
			"ел",
			"ен",
			"ер",
			"ет",
			"ец",
			"ив",
			"из",
			"ий",
			"ик",
			"ил",
			"им",
			"ин",
			"ис",
			"ит",
			"их",
			"иц",
			"ич",
			"иш",
			"ищ",
			"йн",
			"ка",
			"ки",
			"ко",
			"ку",
			"лк",
			"ль",
			"мя",
			"ни",
			"нн",
			"но",
			"ну",
			"нь",
			"об",
			"ов",
			"ое",
			"оз",
			"ой",
			"ок",
			"ол",
			"ом",
			"он",
			"ор",
			"от",
			"ох",
			"ош",
			"ою",
			"ск",
			"сн",
			"сь",
			"ся",
			"тв",
			"те",
			"ти",
			"ть",
			"ть",
			"уг",
			"уй",
			"ук",
			"ул",
			"ун",
			"ур",
			"ус",
			"ут",
			"ух",
			"уч",
			"уш",
			"ущ",
			"ую",
			"ци",
			"чк",
			"ше",
			"ши",
			"шк",
			"шн",
			"ыг",
			"ые",
			"ык",
			"ым",
			"ыч",
			"юк",
			"як",
			"яр",
			"ёж",
			"ёл",
			"ён",
			"ёх",
			"a",
			"o",
			"p",
			"а",
			"б",
			"в",
			"д",
			"е",
			"и",
			"к",
			"л",
			"м",
			"н",
			"о",
			"с",
			"т",
			"у",
			"х",
			"ц",
			"ч",
			"ш",
			"ы"
		]),
		new Set([
			"ами",
			"еми",
			"емя",
			"ими",
			"ите",
			"ишь",
			"ого",
			"ому",
			"умя",
			"ёте",
			"ёшь",
			"am",
			"ax",
			"cm",
			"ex",
			"ам",
			"ас",
			"ая",
			"ей",
			"ем",
			"ею",
			"её",
			"ие",
			"ий",
			"им",
			"ит",
			"их",
			"ию",
			"ми",
			"мя",
			"ов",
			"ое",
			"ой",
			"ом",
			"ою",
			"оё",
			"ум",
			"ут",
			"ух",
			"ую",
			"шь",
			"ёт",
			"ёх",
			"а",
			"е",
			"и",
			"м",
			"о",
			"у",
			"й",
		]),
	)

	// Get roots from dictionary like ["head/prefix/root/suffix/foot"]
	//
	// roots = new Set
	// for(const w of lib){
	// 	for(const m of w.split('/') ) {
	// 		if( $mol_spell_ru.prefix.has( m ) ) continue
	// 		if( $mol_spell_ru.postfix.has( m ) ) continue
	// 		if( $mol_spell_ru.foot.has( m ) ) continue
	// 		roots.add(m)
	// 	}
	// }
	// JSON.stringify([...roots])
	
}
